import React, { Fragment } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Card from '@material-ui/core/Card';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

var colors = {
  transparent: 'rgba(0, 0, 0, 0)',
  alto: '#d9d9d9',
  digitalBlue: '#005d83',
  seaBlue: '#047a9c',
  digitalMarineTurquoise: '#19a5a3',
  charcoal: '#252525',
  concrete: '#c7c7c7',
  summerSky: '#31bbf5',
  focusBlue: '#1977D4',
  inkBlue: '#003558',
  mediumGray: '#6a7070',
  moonlight: '#e9e9e9',
  strawberryRed: '#ca4644',
  sunshineYellow: '#ffb81c',
  sunflowerYellow: '#ff9b19',
  whiteGray: '#f5f5f5',
  white: '#ffffff',
  black: '#000000'
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/**
 * Account outlined icon
 *
 * @file AccountOutlined.jsx
 * @author Sam George
 */
var AccountOutlined = function AccountOutlined(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        React.createElement('path', { d: 'M0 0H24V24H0z', transform: 'translate(-1 -1)' }),
        React.createElement('path', {
          stroke: 'currentcolor',
          strokeWidth: '1.75',
          d: 'M12 1.875c-1.386 0-2.543.448-3.353 1.233-.822.797-1.272 1.93-1.272 3.225 0 2.331.69 4.295 2.092 5.88.263.298.408.68.408 1.077v1.017c0 .39-.121.761-.334 1.068-.213.307-.517.55-.883.688l-5.01 1.878c-.533.2-.976.555-1.286 1.003-.31.447-.487.986-.487 1.556L2 22.125 22.125 22v-1.5c0-.57-.177-1.11-.487-1.556-.31-.448-.753-.803-1.286-1.003l-5.01-1.878c-.366-.138-.67-.381-.883-.688-.213-.307-.334-.677-.334-1.068V13.29c0-.307.023-.63.603-1.305 1.272-1.544 1.897-3.431 1.897-5.652 0-1.295-.45-2.428-1.272-3.225-.81-.785-1.967-1.233-3.353-1.233z',
          transform: 'translate(-1 -1)'
        })
      )
    )
  );
};

/**
 * Activities Icon
 *
 * @file Activities.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Activities = function Activities(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M15.803 2.47956L16.4939 6.39783C17.394 6.91567 18 7.88706 18 9V15C18 16.6569 16.6569 18 15 18H5C3.34315 18 2 16.6569 2 15V12.8435C1.53745 12.4142 1.20599 11.8361 1.08797 11.1668L0.0460783 5.25793C-0.241631 3.62625 0.847874 2.07027 2.47956 1.78256L12.3276 0.0460783C13.9593 -0.241631 15.5153 0.847874 15.803 2.47956ZM15 7.75H5C4.30964 7.75 3.75 8.30964 3.75 9V15C3.75 15.6904 4.30964 16.25 5 16.25H15C15.6904 16.25 16.25 15.6904 16.25 15V9C16.25 8.30964 15.6904 7.75 15 7.75ZM11.475 12.6C11.7649 12.6 12 12.9134 12 13.3C12 13.6866 11.7649 14 11.475 14H6.525C6.23505 14 6 13.6866 6 13.3C6 12.9134 6.23505 12.6 6.525 12.6H11.475ZM13.3 10C13.6866 10 14 10.3134 14 10.7C14 11.0866 13.6866 11.4 13.3 11.4H6.7C6.3134 11.4 6 11.0866 6 10.7C6 10.3134 6.3134 10 6.7 10H13.3ZM12.6315 1.76949L2.78344 3.50597C2.10357 3.62585 1.64961 4.27418 1.76949 4.95404L2.26515 7.76508C2.73589 6.72422 3.78337 6 5 6H14.6468L14.0796 2.78344C13.9597 2.10357 13.3114 1.64961 12.6315 1.76949Z',
        fill: 'currentcolor'
      })
    )
  );
};

var AddIcon = function AddIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 18'
    }, props),
    React.createElement('path', {
      d: 'M10,8 L14,8 C14.5522847,8 15,8.44771525 15,9 C15,9.55228475 14.5522847,10 14,10 L10,10 L10,14 C10,14.5522847 \n      9.55228475,15 9,15 C8.44771525,15 8,14.5522847 8,14 L8,10 L4,10 C3.44771525,10 3,9.55228475 3,9 C3,8.44771525 \n      3.44771525,8 4,8 L8,8 L8,4 C8,3.44771525 8.44771525,3 9,3 C9.55228475,3 10,3.44771525 10,4 L10,8 Z',
      fill: 'currentcolor'
    })
  );
};

var AddCircleOutlinedIcon = function AddCircleOutlinedIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 18'
    }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      fillRule: 'nonzero',
      d: 'M9,16.25 C13.0040644,16.25 16.25,13.0040644 16.25,9 C16.25,4.99593556 13.0040644,1.75 9,1.75 C4.99593556,1.75 \n         1.75,4.99593556 1.75,9 C1.75,13.0040644 4.99593556,16.25 9,16.25 Z M9,18 C4.02943725,18 0,13.9705627 0,9 \n         C0,4.02943725 4.02943725,0 9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 Z'

    }),
    React.createElement('path', {
      fill: 'currentcolor',
      d: 'M10,8 L12,8 C12.5522847,8 13,8.44771525 13,9 C13,9.55228475 12.5522847,10 12,10 L10,10 L10,12 C10,12.5522847 \n         9.55228475,13 9,13 C8.44771525,13 8,12.5522847 8,12 L8,10 L6,10 C5.44771525,10 5,9.55228475 5,9 C5,8.44771525 \n         5.44771525,8 6,8 L8,8 L8,6 C8,5.44771525 8.44771525,5 9,5 C9.55228475,5 10,5.44771525 10,6 L10,8 Z'

    })
  );
};

var ArchiveIcon = function ArchiveIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 18'
    }, props),
    React.createElement('path', {
      d: 'M1,4 L1.90790158,2.12745299 C2.24223433,1.43789168 2.94119229,1 3.7075298,1 L14.2924702,1 C15.0588077,1 \n        15.7577657,1.43789168 16.0920984,2.12745299 L17,4 L17,14.25 C17,15.7687831 15.7687831,17 14.25,17 L3.75,17 \n        C2.23121694,17 1,15.7687831 1,14.25 L1,4 Z M2.94484615,4 L15.0551539,4 L14.5174237,2.89093162 \n        C14.4756321,2.80473646 14.3882624,2.75 14.2924702,2.75 L3.7075298,2.75 \n        C3.61173761,2.75 3.52436786,2.80473646 3.48257627,2.89093162 L2.94484615,4 Z \n        M15.25,5.75 L2.75,5.75 L2.75,14.25 C2.75,14.8022847 3.19771525,15.25 3.75,15.25 L14.25,15.25 \n        C14.8022847,15.25 15.25,14.8022847 15.25,14.25 L15.25,5.75 Z',
      fill: 'currentcolor',
      fillRule: 'nonzero'
    }),
    React.createElement('path', {
      d: 'M8.125,11.007015 L8.125,7.87750722 C8.125,7.39287336 8.51675084,7 9,7 C9.48324916,7 9.875,7.39287336 \n        9.875,7.87750722 L9.875,11.007015 L11.5011367,9.38181662 C11.8440224,9.03912873 12.39995,9.03912873 \n        12.7428357,9.38181662 C13.0857214,9.7245045 13.0857214,10.2801113 12.7428357,10.6227992 L9.62084952,13.7429841 \n        L9.6205304,13.7433028 C9.27761902,14.0856719 8.72192987,14.0855657 8.37915048,13.7429841 L5.25716429,10.6227992 \n        C4.91427857,10.2801113 4.91427857,9.7245045 5.25716429,9.38181662 C5.60005002,9.03912873 6.15597762,9.03912873 \n        6.49886334,9.38181662 L8.125,11.007015 Z',
      fill: 'currentcolor',
      fillRule: 'nonzero'
    })
  );
};

/**
 * Arrow back icon
 *
 * @file ArrowBack.jsx
 */
var ArrowBack = function ArrowBack(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M5.41421356,11 L21,11 C21.5522847,11 22,11.4477153 22,12 C22,12.5522847 21.5522847,13 21,13 L5.41421356,13 L12.6873629,20.2731493 C13.0778872,20.6636736 13.0778872,21.2968386 12.6873629,21.6873629 C12.2968386,22.0778872 11.6636736,22.0778872 11.2731493,21.6873629 L2.29289322,12.7071068 C1.90236893,12.3165825 1.90236893,11.6834175 2.29289322,11.2928932 L11.2731493,2.3126371 C11.6636736,1.92211281 12.2968386,1.92211281 12.6873629,2.3126371 C13.0778872,2.70316139 13.0778872,3.33632637 12.6873629,3.72685066 L5.41421356,11 Z'
      })
    )
  );
};

/**
 * Audio Icon
 *
 * @file Audio.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Audio = function Audio(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 16' }, props),
      React.createElement(
        'g',
        { fill: 'none' },
        React.createElement('path', {
          d: 'M11.3228 8.54459H10.3228V8.53491L10.323 8.52524L11.3228 8.54459ZM11.3228 14.3587L10.323 14.378L10.3228 14.3684V14.3587H11.3228ZM6.67764 14.3629H7.67764V14.3833L7.67681 14.4036L6.67764 14.3629ZM6.67764 8.5404L7.67681 8.49968L7.67764 8.52003V8.5404H6.67764ZM4.91012 8.92824L5.41012 9.79426L4.91012 8.92824ZM4.17538 9.35244L4.67538 10.2185L4.17538 9.35244ZM4.17538 13.5508L4.67538 12.6848L4.17538 13.5508ZM13.0906 8.92859L13.5906 8.06256L13.0906 8.92859ZM11.5163 9.35487C11.9565 9.35487 12.3141 9.0024 12.3226 8.56395L10.323 8.52524C10.3355 7.87652 10.8649 7.35487 11.5163 7.35487V9.35487ZM12.0969 9.35487H11.5163V7.35487H12.0969V9.35487ZM12.6776 9.35487H12.0969V7.35487H12.6776V9.35487ZM11.8711 8.54841C11.8711 8.99381 12.2322 9.35487 12.6776 9.35487V7.35487C13.3368 7.35487 13.8711 7.88923 13.8711 8.54841H11.8711ZM13.325 10.2186L12.5906 9.79461L13.5906 8.06256L14.325 8.48653L13.325 10.2186ZM13.7788 11.8986V11.0046H15.7788V11.8986H13.7788ZM12.5906 13.1087L13.325 12.6847L14.325 14.4167L13.5906 14.8407L12.5906 13.1087ZM12.6776 13.5484C12.2322 13.5484 11.8711 13.9095 11.8711 14.3549H13.8711C13.8711 15.014 13.3368 15.5484 12.6776 15.5484V13.5484ZM12.0969 13.5484H12.6776V15.5484H12.0969V13.5484ZM11.5163 13.5484H12.0969V15.5484H11.5163V13.5484ZM12.3226 14.3393C12.3141 13.9009 11.9565 13.5484 11.5163 13.5484V15.5484C10.8649 15.5484 10.3355 15.0267 10.323 14.378L12.3226 14.3393ZM10.3228 14.3587V8.54459H12.3228V14.3587H10.3228ZM6.48425 13.5484C6.04981 13.5484 5.69601 13.8915 5.67847 14.3222L7.67681 14.4036C7.65085 15.0406 7.12711 15.5484 6.48425 15.5484V13.5484ZM5.90323 13.5484H6.48425V15.5484H5.90323V13.5484ZM5.32296 13.5484H5.90323V15.5484H5.32296V13.5484ZM6.12941 14.3549C6.12941 13.9095 5.76835 13.5484 5.32296 13.5484V15.5484C4.66378 15.5484 4.12941 15.014 4.12941 14.3549H6.12941ZM4.67538 12.6848L5.41012 13.109L4.41012 14.8411L3.67538 14.4169L4.67538 12.6848ZM4.22134 11.0049V11.8984H2.22134V11.0049H4.22134ZM5.41012 9.79426L4.67538 10.2185L3.67538 8.48641L4.41012 8.06221L5.41012 9.79426ZM5.32296 9.35487C5.76834 9.35487 6.12941 8.99381 6.12941 8.54841H4.12941C4.12941 7.88923 4.66379 7.35487 5.32296 7.35487V9.35487ZM5.90323 9.35487H5.32296V7.35487H5.90323V9.35487ZM6.48425 9.35487H5.90323V7.35487H6.48425V9.35487ZM5.67847 8.58111C5.69602 9.01174 6.04982 9.35487 6.48425 9.35487V7.35487C7.1271 7.35487 7.65085 7.8627 7.67681 8.49968L5.67847 8.58111ZM7.67764 8.5404V14.3629H5.67764V8.5404H7.67764ZM4.41012 8.06221C4.23642 8.1625 4.12941 8.34784 4.12941 8.54841H6.12941C6.12941 9.06237 5.85522 9.53728 5.41012 9.79426L4.41012 8.06221ZM2.22134 11.0049C2.22134 9.96592 2.77562 9.00589 3.67538 8.48641L4.67538 10.2185C4.39442 10.3807 4.22134 10.6805 4.22134 11.0049H2.22134ZM3.67538 14.4169C2.77562 13.8974 2.22134 12.9374 2.22134 11.8984H4.22134C4.22134 12.2228 4.39442 12.5226 4.67538 12.6848L3.67538 14.4169ZM4.12941 14.3549C4.12941 14.5554 4.23642 14.7408 4.41012 14.8411L5.41012 13.109C5.85522 13.366 6.12941 13.8409 6.12941 14.3549H4.12941ZM13.5906 14.8407C13.7642 14.7405 13.8711 14.5553 13.8711 14.3549H11.8711C11.8711 13.8408 12.1454 13.3657 12.5906 13.1087L13.5906 14.8407ZM15.7788 11.8986C15.7788 12.9374 15.2246 13.8973 14.325 14.4167L13.325 12.6847C13.6058 12.5226 13.7788 12.2229 13.7788 11.8986H15.7788ZM14.325 8.48653C15.2246 9.00594 15.7788 9.96584 15.7788 11.0046H13.7788C13.7788 10.6804 13.6058 10.3807 13.325 10.2186L14.325 8.48653ZM13.8711 8.54841C13.8711 8.34798 13.7642 8.16278 13.5906 8.06256L12.5906 9.79461C12.1454 9.53756 11.8711 9.06251 11.8711 8.54841H13.8711Z',
          fill: 'currentcolor'
        }),
        React.createElement('path', {
          d: 'M2.97292 11.3333L1.85381 11.1299C1.73079 10.5475 1.66669 9.94541 1.66669 9.33336C1.66669 6.47523 3.06442 3.83421 5.33336 2.40514C7.6023 0.976077 10.3978 0.976077 12.6667 2.40514C14.9356 3.83421 16.3334 6.47523 16.3334 9.33336C16.3334 9.93381 16.2717 10.5247 16.1532 11.0967L15.1524 11.2983',
          stroke: 'currentcolor',
          strokeWidth: '2',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        })
      )
    )
  );
};

var BellFilled = function BellFilled(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 16 17', fill: 'none' }, props),
    React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.49877 2.18871C12.0872 2.85435 14 5.2038 14 8V10.882C14 11.5672 14.3871 12.1936 15 12.5L15.1056 \n        12.5528C15.6537 12.8269 16 13.3871 16 14V14.25C16 14.6642 15.6642 15 15.25 15H10.45C10.2184 16.1411 9.20948 \n        17 8 17C6.79052 17 5.78164 16.1411 5.55001 15H0.75C0.335786 15 0 14.6642 0 14.25V14C0 13.3871 0.346263 12.8269 \n        0.894427 12.5528L1 12.5C1.61287 12.1936 2 11.5672 2 10.882V8C2 5.2038 3.91276 2.85435 6.50123 2.18871C6.53338 \n        1.3887 7.1921 0.75 8 0.75C8.8079 0.75 9.46662 1.3887 9.49877 2.18871Z',
      fill: 'currentcolor'
    })
  );
};

var BlankCalendarOutlined = function BlankCalendarOutlined(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 18 18', fill: 'none' }, props),
    React.createElement(
      'defs',
      null,
      React.createElement('path', { id: 'abcal', d: 'M0 0h17.5v17.5H0z' })
    ),
    React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd'
      },
      React.createElement(
        'mask',
        { id: 'b' },
        React.createElement('use', { xlinkHref: '#abcal' })
      ),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M16.088 5.645a.282.282 0 0 1-.282.282H1.694a.283.283 0 0 1-.283-.282l.01-2.514a.713.713\n        0 0 1 .695-.59h13.267c.39 0 .706.316.706.705v2.399zm0 9.738a.706.706 0 0 1-.705.706H2.117a.708.708\n        0 0 1-.706-.706V7.621c0-.156.127-.282.282-.282h14.114c.154 0 .281.126.281.282v7.762zm-.705-14.254h-.52A.28.28\n        0 0 1 14.6.941a1.414 1.414 0 0 0-2.663 0 .282.282 0 0 1-.267.188H5.831a.28.28 0 0 1-.265-.188A1.417 1.417\n        0 0 0 4.234 0c-.596 0-1.131.378-1.332.941a.281.281 0 0 1-.264.188h-.522A2.12 2.12\n        0 0 0 0 3.246v12.137C0 16.551.95 17.5 2.117 17.5h13.266a2.118 2.118 0 0 0 2.117-2.117V3.246a2.119 2.119\n        0 0 0-2.117-2.117z'
      })
    )
  );
};

/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Book Filled icon.
 * @file BookFilled.jsx
 * @author Vinothkumar, Krishnamoorthi
 */
var BookFilled = function BookFilled(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 16 16'
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      fillRule: 'evenodd',
      d: 'M9.171 15.77c-.089.138-.244.23-.421.23h-1.5c-.177 0-.332-.092-.421-.23-1.11-.504-2.32-.77-3.556-.77H1c-.552 0-1-.448-1-1V2c0-.552.448-1 1-1h2.273C4.962 1 6.603 1.497 8 2.414 9.396 1.497 11.038 1 12.727 1H15c.552 0 1 .448 1 1v12c0 .552-.448 1-1 1h-2.273c-1.236 0-2.446.266-3.556.77zM7 13.944V3.85C5.896 3.136 4.603 2.75 3.273 2.75H1.75v10.5h1.523c1.285 0 2.547.239 3.727.694zM6 12.68V4.629c-.683-.57-1.484-.879-2.307-.879H2.75v8.376h.943c.795 0 1.577.19 2.307.554zM9 3.85v10.093c1.18-.455 2.442-.694 3.727-.694h1.523V2.75h-1.523c-1.33 0-2.623.386-3.727 1.101zm1 .778v8.05c.73-.362 1.512-.553 2.307-.553h.943V3.75h-.943c-.823 0-1.624.308-2.307.879z'
    })
  );
};

/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

var BookHalfFilled = function BookHalfFilled(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 16 16'
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, props),
    React.createElement(
      'g',
      {
        fill: 'currentcolor',
        fillRule: 'evenodd'
      },
      React.createElement(
        'g',
        {
          fill: 'currentcolor'
        },
        React.createElement('path', {
          d: 'M9.171 15.77c-.089.138-.244.23-.421.23h-1.5c-.177 0-.332-.092-.421-.23-1.11-.504-2.32-.77-3.556-.77H1c-.552 0-1-.448-1-1V2c0-.552.448-1 1-1h2.273C4.962 1 6.603 1.497 8 2.414 9.396 1.497 11.038 1 12.727 1H15c.552 0 1 .448 1 1v12c0 .552-.448 1-1 1h-2.273c-1.236 0-2.446.266-3.556.77zM7 13.944V3.85C5.896 3.136 4.603 2.75 3.273 2.75H1.75v10.5h1.523c1.285 0 2.547.239 3.727.694zM9 3.85v10.093c1.18-.455 2.442-.694 3.727-.694h1.523V2.75h-1.523c-1.33 0-2.623.386-3.727 1.101z',
          transform: 'translate(-308 -1072) translate(292 466) translate(0 220) translate(0 180) translate(0 192) translate(16 13) translate(0 1)'
        }),
        React.createElement('path', {
          d: 'M6 12.68V4.629c-.683-.57-1.484-.879-2.307-.879H2.75v8.376h.943c.795 0 1.577.19 2.307.554z',
          transform: 'translate(-308 -1072) translate(292 466) translate(0 220) translate(0 180) translate(0 192) translate(16 13) translate(0 1)'
        })
      )
    )
  );
};

/**
 * Bookmark filled icon
 *
 * @file BookmarkFilled.jsx
 * @author Sam George
 */
var BookmarkFilled = function BookmarkFilled(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M12,17.0933232 L5.66583691,22.7460971 C5.25377873,23.1138287 4.62163425,23.0778949 4.25390268,22.6658367 C4.09037716,22.4825997 4,22.2455937 4,22 L4,3 C4,1.8954305 4.8954305,1 6,1 L18,1 C19.1045695,1 20,1.8954305 20,3 L20,22 C20,22.5522847 19.5522847,23 19,23 C18.754406,23 18.5174001,22.9096228 18.3341631,22.7460973 L12,17.0933232 Z'
      })
    )
  );
};

/**
 * Bookmark outlined icon
 *
 * @file BookmarkOutlined.jsx
 * @author Sam George
 */
var BookmarkOutlined = function BookmarkOutlined(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M18,3 L6,3 L6,19.7672659 L12,14.4127077 L18,19.7672659 L18,3 Z M12,17.0933232 L5.66583691,22.7460971 C5.25377873,23.1138287 4.62163425,23.0778949 4.25390268,22.6658367 C4.09037716,22.4825997 4,22.2455937 4,22 L4,3 C4,1.8954305 4.8954305,1 6,1 L18,1 C19.1045695,1 20,1.8954305 20,3 L20,22 C20,22.5522847 19.5522847,23 19,23 C18.754406,23 18.5174001,22.9096228 18.3341631,22.7460973 L12,17.0933232 Z'
      })
    )
  );
};

/**
 * Book open outlined icon
 *
 * @author Hari Gangadharan
 */
var BookOutlined = function BookOutlined(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M13.25 22.3777C13.25 22.3777 13 23 12.5 23H11.5C11 23 10.75 22.3777 10.75 22.3777C9.111 21.4806 7.2606 21 \n        5.36364 21H2C1.44772 21 1 20.5523 1 20L1 3C1 2.44772 1.44772 2 2 2L5.36364 2C7.76104 2 10.0841 2.76764 \n        12 4.1735C14.826 2.7245 17.0381 2 18.6364 2L22 2C22.5523 2 23 2.44772 23 3V20C23 20.5523 22.5523 21 22 \n        21H18.6364C16.7394 21 14.889 21.4806 13.25 22.3777ZM11 5.92393C9.3917 4.68108 7.41067 4 5.36364 \n        4H3V19H5.36364C7.32884 19 9.25163 19.4378 11 20.2619V5.92393ZM13 5.92393V20.2619C14.7484 19.4378 16.6712 19 \n        18.6364 19H21V4H18.6364C16.5893 4 14.6083 4.68108 13 5.92393Z'
      })
    )
  );
};

var CalendarOutlined = function CalendarOutlined(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 22 23' }, props),
    React.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      React.createElement('path', { d: 'M-1 0h24v24H-1z' }),
      React.createElement('path', {
        fill: 'currentcolor',
        fillRule: 'nonzero',
        d: 'M16 .5A2 2 0 0 1 17.937 2H19.5A2.5 2.5 0 0 1 22 4.5v16a2.5 2.5 0 0 1-2.5 2.5h-17A2.5 2.5 0 0 1 0 \n          20.5v-16A2.5 2.5 0 0 1 2.5 2h1.563a2 2 0 0 1 3.874 0h6.126A2 2 0 0 1 16 .5zM20 9H2v11.5a.5.5 0 0 0 \n          .5.5h17a.5.5 0 0 0 .5-.5V9zm-.5-5h-17a.5.5 0 0 0-.492.41L2 4.5V7h18V4.5a.5.5 0 0 0-.5-.5z'
      }),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M15.5 16h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zM15.5 11h2a.5.5 0 0 1 \n          .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zM10.5 11h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 \n          1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zM10.5 16h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 \n          1-.5-.5v-2a.5.5 0 0 1 .5-.5zM5.5 16h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 \n          1-.5-.5v-2a.5.5 0 0 1 .5-.5z'
      })
    )
  );
};

/**
 * Card View Icon
 *
 * @file CardView.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var CardView = function CardView(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M10.5 13C10.7761 13 11 13.2239 11 13.5V21.5C11 21.7761 10.7761 22 10.5 22H2.5C2.22386 22 2 21.7761 2 21.5V13.5C2 13.2239 2.22386 13 2.5 13H10.5ZM21.5 13C21.7761 13 22 13.2239 22 13.5V21.5C22 21.7761 21.7761 22 21.5 22H13.5C13.2239 22 13 21.7761 13 21.5V13.5C13 13.2239 13.2239 13 13.5 13H21.5ZM9 15H4V20H9V15ZM20 15H15V20H20V15ZM10.5 2C10.7761 2 11 2.22386 11 2.5V10.5C11 10.7761 10.7761 11 10.5 11H2.5C2.22386 11 2 10.7761 2 10.5V2.5C2 2.22386 2.22386 2 2.5 2H10.5ZM21.5 2C21.7761 2 22 2.22386 22 2.5V10.5C22 10.7761 21.7761 11 21.5 11H13.5C13.2239 11 13 10.7761 13 10.5V2.5C13 2.22386 13.2239 2 13.5 2H21.5ZM9 4H4V9H9V4ZM20 4H15V9H20V4Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * Renders a Caret Down Icon. Usually this icon along with CaretUp is used as dropdown open/close indicator.
 *
 * @author Hari Gangadharan
 */
var CaretDown = function CaretDown(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
    }, props),
    React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.8979 0L2.09673 0C1.48954 0 0.997314 0.490743 0.997314 1.0961C0.997314 1.39081 1.11635 1.6731 1.32755 \n        1.87929L5.22814 5.68708C5.65554 6.10431 6.33909 6.10431 6.76649 5.68708L10.6671 1.87929C11.1009 1.45576 \n        11.1082 0.761786 10.6834 0.329247C10.4766 0.118674 10.1935 0 9.8979 0Z',
      fill: 'currentColor'
    })
  );
};

/**
 * Renders a Caret Down Icon. Usually this icon along with CaretUp is used as dropdown open/close indicator.
 *
 * @author Hari Gangadharan
 */
var CaretUp = function CaretUp(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
    }, props),
    React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.09673 6H9.8979C10.5051 6 10.9973 5.50926 10.9973 4.9039C10.9973 4.60919 10.8783 4.3269 10.6671 \n        4.12071L6.76649 0.312922C6.33909 -0.104308 5.65554 -0.104308 5.22814 0.312922L1.32756 4.12071C0.89371 \n        4.54424 0.886379 5.23821 1.31118 5.67075C1.51799 5.88133 1.80113 6 2.09673 6Z',
      fill: 'currentColor'
    })
  );
};

/**
 * An icon for selection controls - unchecked state.
 *
 * @author Hari Gangadharan
 */
var CircleOutline = function CircleOutline(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 19 19' }, props),
    React.createElement('circle', { stroke: 'currentColor', strokeWidth: '2', cx: '9.5', cy: '9.5', r: '8.5', fill: 'none' })
  );
};

/**
 * An icon for Inprogress task
 *
 * @author Praveen Punniyamoorthi
 */
var CircleInprogressOutline = function CircleInprogressOutline(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM9 14.4C11.9823 14.4 14.4 11.9823 14.4 9C14.4 6.01766 11.9823 3.6 9 3.6C6.01766 3.6 3.6 6.01766 3.6 9C3.6 11.9823 6.01766 14.4 9 14.4Z',
        fill: '#A9A9A9'
      }),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M15.364 2.63604C13.6761 0.948212 11.3869 0 9 0V3.59961C11.9822 3.59982 14.3996 6.0174 14.3996 8.99961C14.3996 11.9818 11.9822 14.3994 9 14.3996V18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * An icon for Not started task
 *
 * @author Praveen Punniyamoorthi
 */
var CircleNotStartedOutline = function CircleNotStartedOutline(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM9 14.4C11.9823 14.4 14.4 11.9823 14.4 9C14.4 6.01766 11.9823 3.6 9 3.6C6.01766 3.6 3.6 6.01766 3.6 9C3.6 11.9823 6.01766 14.4 9 14.4Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * An icon for selection controls - checked state.
 *
 * @author Hari Gangadharan
 */
var CheckCircleFilled = function CheckCircleFilled(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 19 19' }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      d: '\n        M 0, 9.5 a 9.5,9.5 0 1,0 19,0 a 9.5,9.5 0 1,0 -19,0\n        M8.823 13.7a.877.877 0 0 1-1.278.043l-2.281-2.239a.874.874 0 0 1-.011-1.237.877.877 0 0 1 1.24-.01l1.629\n        1.598 5.348-5.998a.877.877 0 0 1 1.238-.072.874.874 0 0 1 .072 1.236L8.823 13.7z'
    })
  );
};

var ChevronDown = function ChevronDown(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
    }, props),
    React.createElement('path', {
      d: 'M12.6772865,16.7357409 C12.2849891,17.0973856 11.6736274,17.0878409 11.2928932,16.7071068 \n        L4.29289322,9.70710678 C3.90236893,9.31658249 3.90236893,8.68341751 4.29289322,8.29289322 \n        C4.68341751,7.90236893 5.31658249,7.90236893 5.70710678,8.29289322 L12,14.5857864 \n        L18.2928932,8.29289322 C18.6834175,7.90236893 19.3165825,7.90236893 19.7071068,8.29289322 \n        C20.0976311,8.68341751 20.0976311,9.31658249 19.7071068,9.70710678 L12.7071068,16.7071068 \n        C12.6971852,16.7170283 12.6872407,16.7265641 12.6772745,16.735721 L12.6772865,16.7357409 Z',
      fill: 'currentcolor',
      fillRule: 'nonzero'
    })
  );
};

var ChevronLeftIcon = function ChevronLeftIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
    }, props),
    React.createElement('path', {
      d: 'M6.79341988,11.2914944 L15.7898236,2.29347265 C16.1810501,1.90217578 16.8153536,1.90217578 \n        17.2065801,2.29347265 C17.5978066,2.68476951 17.5978066,3.31918708 17.2065801,3.71048394 \n        L8.91855462,12 L17.2065801,20.2895161 C17.5978066,20.6808129 17.5978066,21.3152305 \n        17.2065801,21.7065274 C16.8153536,22.0978242 16.1810501,22.0978242 15.7898236,21.7065274 \n        L6.79341988,12.7085056 C6.40219337,12.3172088 6.40219337,11.6827912 6.79341988,11.2914944 Z',
      fill: 'currentcolor',
      fillRule: 'nonzero'
    })
  );
};

var ChevronRightIcon = function ChevronRightIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
    }, props),
    React.createElement('path', {
      d: 'M17.2065801,11.2914944 C17.5978066,11.6827912 17.5978066,12.3172088 17.2065801,12.7085056 \n        L8.21017637,21.7065274 C7.81894987,22.0978242 7.18464638,22.0978242 6.79341988,21.7065274 \n        C6.40219337,21.3152305 6.40219337,20.6808129 6.79341988,20.2895161 L15.0814454,12 L6.79341988,3.71048394 \n        C6.40219337,3.31918708 6.40219337,2.68476951 6.79341988,2.29347265 C7.18464638,1.90217578 7.81894987,1.90217578\n        8.21017637,2.29347265 L17.2065801,11.2914944 Z',
      fill: 'currentcolor',
      fillRule: 'nonzero'
    })
  );
};

var ChevronUp = function ChevronUp(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
    }, props),
    React.createElement('path', {
      d: 'M12.6772865,7.2642591 L12.6772745,7.264279 C12.6872407,7.27343586 12.6971852,7.28297167 12.7071068,7.29289322 \n        L19.7071068,14.2928932 C20.0976311,14.6834175 20.0976311,15.3165825 19.7071068,15.7071068 \n        C19.3165825,16.0976311 18.6834175,16.0976311 18.2928932,15.7071068 L12,9.41421356 L5.70710678,15.7071068 \n        C5.31658249,16.0976311 4.68341751,16.0976311 4.29289322,15.7071068 C3.90236893,15.3165825 \n        3.90236893,14.6834175 4.29289322,14.2928932 L11.2928932,7.29289322 C11.6736274,6.91215906 \n        12.2849891,6.90261436 12.6772865,7.2642591 Z',
      fill: 'currentcolor',
      fillRule: 'nonzero'
    })
  );
};

var ClockOutlined = function ClockOutlined(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 18 18', fill: 'none' }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      fillRule: 'evenodd',
      d: 'M9 16.714c-4.254 0-7.714-3.46-7.714-7.714 0-4.254 3.46-7.714 7.714-7.714 4.254 0 7.714 3.46 7.714 7.714\n        0 4.254-3.46 7.714-7.714 7.714M9 0C4.037 0 0 4.037 0 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9m2.603\n        12.632a.785.785 0 0 1-1.085 0L8.505 10.62a.77.77 0 0 1-.276-.591V4.886a.772.772 0 0 1 1.542 0v4.829l1.832\n        1.832c.3.3.3.787 0 1.085'
    })
  );
};

/**
 * Close Icon
 *
 * @file Close.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Close = function Close(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M12.0002 10.5858L18.7177 3.86827C19.1082 3.47775 19.7414 3.47775 20.1319 3.86827C20.5224 4.2588 20.5224 4.89196 20.1319 5.28249L13.4144 12L20.1318 18.7175C20.5223 19.108 20.5223 19.7411 20.1318 20.1317C19.7413 20.5222 19.1081 20.5222 18.7176 20.1317L12.0002 13.4142L5.28255 20.1316C4.89203 20.5222 4.25886 20.5222 3.86834 20.1316C3.47782 19.7411 3.47782 19.108 3.86834 18.7174L10.5859 12L3.86851 5.28257C3.47798 4.89204 3.47798 4.25888 3.86851 3.86836C4.25903 3.47783 4.8922 3.47783 5.28272 3.86836L12.0002 10.5858Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * An icon for Copy Clipboard
 *
 * @author Praveen Punniyamoorthi
 */
var Copy = function Copy(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 16 18'
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, props),
    React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13 15V16C13 17.1046 12.1046 18 11 18H2C0.89543 18 0 17.1046 0 16V5C0 3.89543 0.89543 3 2 3H3V2C3 0.89543 3.89543 0 5 0H11.5858C11.851 0 12.1054 0.105357 12.2929 0.292893L15.7071 3.70711C15.8946 3.89464 16 4.149 16 4.41421V13C16 14.1046 15.1046 15 14 15H13ZM11.25 15H5C3.89543 15 3 14.1046 3 13V4.75H2C1.86193 4.75 1.75 4.86193 1.75 5V16C1.75 16.1381 1.86193 16.25 2 16.25H11C11.1381 16.25 11.25 16.1381 11.25 16V15ZM14.25 13V5H12C11.4477 5 11 4.55228 11 4V1.75H5C4.86193 1.75 4.75 1.86193 4.75 2V13C4.75 13.1381 4.86193 13.25 5 13.25H14C14.1381 13.25 14.25 13.1381 14.25 13Z',
      fill: 'currentcolor'
    })
  );
};

var CollapseIcon = function CollapseIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 18'
    }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      fillRule: 'evenodd',
      d: 'M2.958 1.8l4.578 4.576a.833.833 0 1 1-1.179 1.179L1.78 2.978l-.006 4.02a.775.775 0 0 1-.773.773A.77.77 0 0 1 \n        .23 7l.008-5.97c0-.426.346-.772.773-.773L6.98.249a.77.77 0 0 1 .77.772.775.775 0 0 1-.772.773l-4.02.005zM15.042\n        16.24l-4.578-4.578a.833.833 0 1 1 1.179-1.178l4.577 4.577.006-4.02c0-.427.346-.773.773-.773a.77.77 0 0 1 \n        .771.77l-.008 5.97a.775.775 0 0 1-.773.774l-5.97.008a.77.77 0 0 1-.77-.772c0-.426.346-.772.772-.773l4.02-.005z'
    })
  );
};

/**
 * Collapse Control Icon
 *
 * @file CollapseControl.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var CollapseControl = function CollapseControl(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M16.4138 8.99769H18.9925C19.5445 8.99769 19.992 9.44518 19.992 9.99719C19.992 10.5492 19.5445 10.9967 18.9925 10.9967H13.995C13.443 10.9967 12.9955 10.5492 12.9955 9.99719V4.99968C12.9955 4.44767 13.443 4.00018 13.995 4.00018C14.547 4.00018 14.9945 4.44767 14.9945 4.99968V7.5684L18.2829 4.29004C18.6748 3.89811 19.3102 3.89811 19.7021 4.29004C20.0941 4.68196 20.0941 5.3174 19.7021 5.70933L16.4138 8.99769ZM5.00139 12.9957H9.99889C10.5509 12.9957 10.9984 13.4432 10.9984 13.9952V18.9927C10.9984 19.5448 10.5509 19.9922 9.99889 19.9922C9.44688 19.9922 8.99939 19.5448 8.99939 18.9927V16.414L5.71103 19.7024L5.70524 19.7082C5.31331 20.0969 4.68047 20.0943 4.29174 19.7024L4.28595 19.6966C3.89722 19.3047 3.89982 18.6718 4.29174 18.2831L7.57011 14.9947H5.00139C4.44938 14.9947 4.00189 14.5473 4.00189 13.9952C4.00189 13.4432 4.44938 12.9957 5.00139 12.9957Z',
        fill: 'currentcolor'
      })
    )
  );
};

var CollapseMojo = function CollapseMojo(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
    }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      d: 'M16.9684 8.62613H19.8691C20.49 8.62613 20.9934 9.12949 20.9934 9.75043C20.9934 10.3714 20.49 10.8747 19.8691 10.8747H14.2476C13.6266 10.8747 13.1233 10.3714 13.1233 9.75043V4.12891C13.1233 3.50797 13.6266 3.0046 14.2476 3.0046C14.8685 3.0046 15.3719 3.50797 15.3719 4.12891V7.01837L19.0708 3.33065C19.5117 2.88978 20.2265 2.88978 20.6673 3.33065C21.1082 3.77151 21.1082 4.4863 20.6673 4.92716L16.9684 8.62613ZM4.13082 13.1235H9.75235C10.3733 13.1235 10.8767 13.6269 10.8767 14.2478V19.8694C10.8767 20.4903 10.3733 20.9937 9.75235 20.9937C9.13141 20.9937 8.62804 20.4903 8.62804 19.8694V16.9687L4.92908 20.6676L4.92256 20.6741C4.4817 21.1114 3.76983 21.1085 3.33257 20.6676L3.32605 20.6611C2.88878 20.2202 2.8917 19.5084 3.33257 19.0711L7.02029 15.3721H4.13082C3.50989 15.3721 3.00652 14.8688 3.00652 14.2478C3.00652 13.6269 3.50989 13.1235 4.13082 13.1235Z'
    })
  );
};

var CollapseMojoAudio = function CollapseMojoAudio(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 18'
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, props),
    React.createElement('path', {
      fill: 'currentcolor'
      // eslint-disable-next-line max-len
      , d: 'M13.9684 5.62613H16.8691C17.49 5.62613 17.9934 6.12949 17.9934 6.75043C17.9934 7.37137 17.49 7.87474 16.8691 7.87474H11.2476C10.6266 7.87474 10.1233 7.37137 10.1233 6.75043V1.12891C10.1233 0.507968 10.6266 0.00460026 11.2476 0.00460023C11.8685 0.00460023 12.3719 0.507968 12.3719 1.12891V4.01837L16.0708 0.330649C16.5117 -0.110216 17.2265 -0.110216 17.6673 0.330649C18.1082 0.771511 18.1082 1.4863 17.6673 1.92716L13.9684 5.62613ZM1.13082 10.1235H6.75235C7.37328 10.1235 7.87665 10.6269 7.87665 11.2478V16.8694C7.87665 17.4903 7.37328 17.9937 6.75235 17.9937C6.13141 17.9937 5.62804 17.4903 5.62804 16.8694V13.9687L1.92908 17.6676L1.92256 17.6741C1.4817 18.1114 0.769832 18.1085 0.332567 17.6676L0.326048 17.6611C-0.111216 17.2202 -0.108297 16.5084 0.332567 16.0711L4.02029 12.3721H1.13082C0.509887 12.3721 0.00651901 11.8688 0.00651898 11.2478C0.00651898 10.6269 0.509887 10.1235 1.13082 10.1235Z'
    })
  );
};

/**
 * Correct icon
 *
 * @file Correct.jsx
 * @author Sam George
 */
var Correct = function Correct(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M8.86376719,18.6700721 L5.26967222,14.847751 C4.89151183,14.4455773 4.9106717,13.8127028 5.312467,13.4341863 C5.7142623,13.0556698 6.34654132,13.0748477 6.72470172,13.4770214 L9.49147384,16.4194844 L17.1805189,5.42478964 C17.4969355,4.97234034 18.1198793,4.86230556 18.5719029,5.17902006 C19.0239265,5.49573457 19.1338577,6.11926503 18.8174412,6.57171433 L10.4241223,18.573462 C10.1077058,19.0259113 9.48476201,19.135946 9.03273841,18.8192315 C8.96968125,18.77505 8.91328127,18.7248977 8.86376719,18.6700721 L8.86376719,18.6700721 Z'
      })
    )
  );
};

/**
 * An icon for Delete
 *
 * @author Praveen Punniyamoorthi
 */
var Delete = function Delete(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        d: '\n    M13,0 C14.1045695,0 15,0.8954305 15,2 L22,2 C22.5522847,2 23,2.44771525 23,3 C23,3.55228475 22.5522847,4\n    22,4 L21,4 L21,21 C21,22.6568542 19.6568542,24 18,24 L6,24 C4.34314575,24 3,22.6568542 3,21 L3,4 L2,4 C1.44771525,4 1,3.55228475 1,3\n    C1,2.44771525 1.44771525,2 2,2 L9,2 C9,0.8954305 9.8954305,0 11,0 L13,0 Z M19,4 L5,4 L5,20.7777778 C5,21.4527925 5.44771525,22 6,22\n    L18,22 C18.5522847,22 19,21.4527925 19,20.7777778 L19,4 Z M9,6 L9,19 C9,19.5522847 8.55228475,20 8,20 C7.44771525,20 7,19.5522847 7,19 L7,6\n    L9,6 Z M17,6 L17,19 C17,19.5522847 16.5522847,20 16,20 C15.4477153,20 15,19.5522847 15,19 L15,6 L17,6 Z M13,6 L13,19 C13,19.5522847 12.5522847,20 12,20\n    C11.4477153,20 11,19.5522847 11,19 L11,6 L13,6 Z',
        fill: 'currentColor'
      })
    )
  );
};

/**
 * Descending icon
 *
 * @file Descending.jsx
 * @author Sam George
 */
var Descending = function Descending(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M13,16.5857864 L16.2928932,13.2928932 C16.6834175,12.9023689 17.3165825,12.9023689 17.7071068,13.2928932 C18.0976311,13.6834175 18.0976311,14.3165825 17.7071068,14.7071068 L12.7071068,19.7071068 C12.3165825,20.0976311 11.6834175,20.0976311 11.2928932,19.7071068 L6.29289322,14.7071068 C5.90236893,14.3165825 5.90236893,13.6834175 6.29289322,13.2928932 C6.68341751,12.9023689 7.31658249,12.9023689 7.70710678,13.2928932 L11,16.5857864 L11,5 C11,4.44771525 11.4477153,4 12,4 C12.5522847,4 13,4.44771525 13,5 L13,16.5857864 L13,16.5857864 Z'
      })
    )
  );
};

/**
 * Document Icon
 *
 * @file Document.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Document = function Document(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 15 18' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M9.26984 0.29716L14.1657 5.69706C14.3158 5.86212 14.3992 6.077 14.3997 6.30005V15.7499L14.3997 15.7502C14.3847 17.0076 13.3532 18.0148 12.0958 17.9998H2.30395L2.30363 17.9998C1.0462 18.0147 0.0148193 17.0073 0 15.7499V2.25012L3.85426e-06 2.2498C0.0150066 0.992361 1.04652 -0.0148334 2.30396 0.000165365H8.60385C8.8578 0.000765654 9.09969 0.108632 9.26984 0.29716ZM11.4645 5.40012L8.9985 2.70017V4.63514L8.99764 4.64758C8.97397 5.03953 9.27253 5.37646 9.66449 5.40012H11.4645ZM12.0958 16.1999H2.30396C2.04097 16.2152 1.81536 16.0144 1.80005 15.7514L1.79997 15.7499V2.25012C1.81443 1.98708 2.03939 1.78557 2.30243 1.80004L2.30396 1.80013H7.19987V4.63508C7.16963 6.01511 8.25902 7.16078 9.63883 7.20003H12.5998V15.7499C12.5853 16.0129 12.3603 16.2144 12.0973 16.2L12.0958 16.1999ZM4.49992 10.8H7.19987C7.69692 10.8 8.09985 10.397 8.09985 9.89999C8.09985 9.40294 7.69692 9 7.19987 9H4.49992C4.00287 9 3.59993 9.40294 3.59993 9.89999C3.59993 10.397 4.00287 10.8 4.49992 10.8ZM9.89982 12.5999H4.49992C4.00287 12.5999 3.59993 13.0029 3.59993 13.4999C3.59993 13.997 4.00287 14.3999 4.49992 14.3999H9.89982C10.3969 14.3999 10.7998 13.997 10.7998 13.4999C10.7998 13.0029 10.3969 12.5999 9.89982 12.5999Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * Double page icon
 *
 * @file DoublePage.jsx
 * @author Sam George
 */
var DoublePage = function DoublePage(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M3.938 4c-.193 0-.378.077-.515.213l-3.21 3.21C.077 7.56 0 7.745 0 7.938v10.244C0 19.186.814 20 1.818 20h7.566c1.004 0 1.818-.814 1.818-1.818V5.818C11.202 4.814 10.388 4 9.384 4H3.938zm.426 1.455h5.02c.178 0 .327.128.358.298l.005.065v12.364c0 .178-.128.327-.298.358l-.065.005H1.818c-.178 0-.327-.128-.358-.298l-.005-.065V8.364h2.181c.373 0 .68-.281.723-.643l.005-.085V5.455zM20.064 4c.193 0 .378.077.515.213l3.21 3.21c.136.137.213.322.213.515v10.244c0 1.004-.814 1.818-1.818 1.818h-7.566c-1.004 0-1.818-.814-1.818-1.818V5.818C12.8 4.814 13.614 4 14.618 4h5.446zm-.426 1.455h-5.02c-.178 0-.327.128-.358.298l-.005.065v12.364c0 .178.128.327.298.358l.065.005h7.566c.178 0 .327-.128.358-.298l.005-.065V8.364h-2.181c-.373 0-.68-.281-.723-.643l-.005-.085V5.455z'
      })
    )
  );
};

/**
 * Download icon
 *
 * @file Download.jsx
 * @author Sam George
 */
var Download = function Download(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M22,15 C22.5522847,15 23,15.4477153 23,16 L23,20 C23,21.6568542 21.6568542,23 20,23 L4,23 C2.34314575,23 1,21.6568542 1,20 L1,16 C1,15.4477153 1.44771525,15 2,15 C2.55228475,15 3,15.4477153 3,16 L3,20 C3,20.5522847 3.44771525,21 4,21 L20,21 C20.5522847,21 21,20.5522847 21,20 L21,16 C21,15.4477153 21.4477153,15 22,15 Z M12,0 C12.5522847,0 13,0.44771525 13,1 L13,12.5857864 L16.2928932,9.29289322 C16.6834175,8.90236893 17.3165825,8.90236893 17.7071068,9.29289322 C18.0976311,9.68341751 18.0976311,10.3165825 17.7071068,10.7071068 L12.7071068,15.7071068 C12.5118446,15.9023689 12.2559223,16 12,16 C11.7440777,16 11.4881554,15.9023689 11.2928932,15.7071068 L6.29289322,10.7071068 C5.90236893,10.3165825 5.90236893,9.68341751 6.29289322,9.29289322 C6.68341751,8.90236893 7.31658249,8.90236893 7.70710678,9.29289322 L11,12.5857864 L11,1 C11,0.44771525 11.4477153,0 12,0 Z'
      })
    )
  );
};

/**
 * Downloading Icon
 *
 * @file Downloading.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Downloading = function Downloading(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement(
        'g',
        { fill: 'none' },
        React.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M12 11L12 9.25L13 9.25C13.6904 9.25 14.25 8.69036 14.25 8L14.25 4C14.25 3.30964 13.6904 2.75 13 2.75L5 2.75C4.30965 2.75 3.75 3.30964 3.75 4L3.75 8C3.75 8.69036 4.30964 9.25 5 9.25L6 9.25L6 11L5 11C3.34315 11 2 9.65685 2 8L2 4C2 2.34314 3.34315 0.999999 5 0.999999L13 1C14.6569 1 16 2.34315 16 4L16 8C16 9.65685 14.6569 11 13 11L12 11ZM8.32562 17.7185L5.27934 14.6408C4.90689 14.2654 4.90689 13.6569 5.27934 13.2815C5.65179 12.9062 6.25565 12.9062 6.6281 13.2815L8 14.6718L8 6C8 5.44771 8.44772 5 9 5C9.55229 5 10 5.44771 10 6L10 14.6718L11.3719 13.2815C11.7444 12.9062 12.3482 12.9062 12.7207 13.2815C13.0931 13.6569 13.0931 14.2654 12.7207 14.6408L9.67438 17.7185C9.30193 18.0938 8.69807 18.0938 8.32562 17.7185Z',
          fill: 'currentcolor'
        })
      )
    )
  );
};

/**
 * DrawerClose icon
 *
 * @file DrawerClose.jsx
 * @author Sam George
 */
var DrawerClose = function DrawerClose(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 23 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M6.49516 5.70789C6.85694 5.29789 7.44449 5.29789 7.80627 5.70789C8.16894 6.11789 8.16894 6.78189 7.80627 7.19189L4.75205 10.6499H16.4649C16.9769 10.6499 17.392 11.1199 17.392 11.6999C17.392 12.2799 16.9769 12.7499 16.4649 12.7499H4.75116L7.80538 16.2079C8.16805 16.6179 8.16805 17.2819 7.80538 17.6919C7.44361 18.1019 6.85605 18.1019 6.49427 17.6919L1.85605 12.4419C1.49427 12.0319 1.49427 11.3679 1.85605 10.9579L6.49516 5.70789Z'
      }),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M20.3337 1C21.3159 1 22.1114 1.895 22.1114 3V21C22.1114 22.105 21.3159 23 20.3337 23H11.4448C10.4625 23 9.66699 22.105 9.66699 21V15H11.4448V21H20.3337V3H11.4448V9H9.66699V3C9.66699 1.895 10.4625 1 11.4448 1H20.3337Z'
      })
    )
  );
};

/**
 * DrawerLeft icon
 *
 * @file DrawerLeft.jsx
 * @author Sam George
 */
var DrawerLeft = function DrawerLeft(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M20.5,1 C21.8807119,1 23,2.11928813 23,3.5 L23,20.5 C23,21.8807119 21.8807119,23 20.5,23 L3.5,23 C2.11928813,23 1,21.8807119 1,20.5 L1,3.5 C1,2.11928813 2.11928813,1 3.5,1 L20.5,1 Z M9,3 L3.83333333,3 C3.37309604,3 3,3.22385763 3,3.5 L3,20.5 C3,20.7761424 3.37309604,21 3.83333333,21 L9,21 L9,3 Z M20.5833333,3 L11,3 L11,21 L20.5833333,21 C20.813452,21 21,20.7761424 21,20.5 L21,3.5 C21,3.22385763 20.813452,3 20.5833333,3 Z M6.5,15 C6.77614237,15 7,15.2238576 7,15.5 L7,16.5 C7,16.7761424 6.77614237,17 6.5,17 L5.5,17 C5.22385763,17 5,16.7761424 5,16.5 L5,15.5 C5,15.2238576 5.22385763,15 5.5,15 L6.5,15 Z M6.5,11 C6.77614237,11 7,11.2238576 7,11.5 L7,12.5 C7,12.7761424 6.77614237,13 6.5,13 L5.5,13 C5.22385763,13 5,12.7761424 5,12.5 L5,11.5 C5,11.2238576 5.22385763,11 5.5,11 L6.5,11 Z M6.5,7 C6.77614237,7 7,7.22385763 7,7.5 L7,8.5 C7,8.77614237 6.77614237,9 6.5,9 L5.5,9 C5.22385763,9 5,8.77614237 5,8.5 L5,7.5 C5,7.22385763 5.22385763,7 5.5,7 L6.5,7 Z'
      })
    )
  );
};

/**
 * Pencil icon to edit
 *
 * @file Edit.jsx
 * @author Arish Kumar K
 */
var Edit = function Edit(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M20.8405891,1.73208983 L22.2710156,3.16389393 C23.2471353,4.14017189 23.2471353,5.72286342 22.2710156,6.69914137 L5.96952503,23.0038467 L2,23.0038467 C1.44771525,23.0038467 1,22.5561314 1,22.0038467 L1,18.0406468 L17.3050552,1.73237628 C18.2812869,0.755986452 19.8641993,0.755858202 20.8405891,1.73208983 Z M15.5899453,6.27653046 L3,18.8689584 L3,21.0038467 L5.14098239,21.0038467 L17.7278808,8.41446601 L15.5899453,6.27653046 Z M19.4265475,3.14647526 C19.2312122,2.95117164 18.9146297,2.95119729 18.7194082,3.14645041 L18.7194082,3.14645041 L17.0040194,4.86217747 L19.141955,7.00011302 L20.8566874,5.2850424 C21.0519114,5.08978681 21.0519114,4.7732485 20.8561213,4.5774265 L20.8561213,4.5774265 Z'
      })
    )
  );
};

/**
 * Email icon
 * @author Praveen Punniyamoorthi
 */
var Email = function Email(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M3.5,4 L20.5,4 C21.8807119,4 23,5.11928813 23,6.5 L23,18.5 C23,19.8807119 21.8807119,21 20.5,21 L3.5,21 C2.11928813,21 1,19.8807119 1,18.5 L1,6.5 C1,5.11928813 2.11928813,4 3.5,4 Z M21,6.51937515 L21,6.5 C21,6.22385763 20.7761424,6 20.5,6 L3.5,6 C3.22385763,6 3,6.22385763 3,6.5 L3,6.51937515 L10.1259149,12.220107 C11.2215708,13.0966318 12.7784292,13.0966318 13.8740851,12.220107 L21,6.51937515 Z M21,9.08062485 L15.1234752,13.7818447 C13.297382,15.2427193 10.702618,15.2427193 8.87652476,13.7818447 L3,9.08062485 L3,18.5 C3,18.7761424 3.22385763,19 3.5,19 L20.5,19 C20.7761424,19 21,18.7761424 21,18.5 L21,9.08062485 Z'
      })
    )
  );
};

var ExpandIcon = function ExpandIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 19 18'
    }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      d: 'M2.497 15.061l4.578-4.577a.833.833 0 1 1 1.178 1.178L3.676 16.24l4.02.005c.427 0 .773.347.773.773a.77.77 0 0\n         1-.77.772l-5.97-.008a.775.775 0 0 1-.774-.773l-.008-5.97a.77.77 0 0 1 .772-.771c.426 0 .772.346.773.773l.005\n         4.02zM16.938 2.978L12.36 7.555a.833.833 0 1 1-1.178-1.179L15.759 1.8l-4.02-.005a.775.775 0 0 1-.773-.773.77.77\n         0 0 1 .771-.772l5.97.008c.426 0 .772.347.773.773L18.488 7a.77.77 0 0 1-.772.771.775.775\n         0 0 1-.773-.773l-.005-4.02z'
    })
  );
};

/**
 * Expand Control Icon
 *
 * @file ExpandControl.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var ExpandControl = function ExpandControl(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M19.0019 4C19.5542 4 20.0019 4.44771 20.0019 5L20.0019 10.5523 18.0019 10V7.42L14.7119 10.71L14.7061 10.7158C14.314 11.1047 13.6808 11.1021 13.2919 10.71L13.2861 10.7042C12.8972 10.3121 12.8998 9.67892 13.2919 9.29L16.5719 6H14.0019C13.4496 6 13.0019 5.55228 13.0019 5C13.0019 4.44771 13.4496 4 14.0019 4H19.0019ZM9.2958 13.2842C9.68792 12.8953 10.3211 12.8979 10.71 13.29L10.7158 13.2958C11.1047 13.6879 11.1021 14.3211 10.71 14.71L7.42 18H10C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20H5C4.44771 20 4 19.5523 4 19V14C4 13.4477 4.44771 13 5 13C5.55228 13 6 13.4477 6 14V16.57L9.29 13.29L9.2958 13.2842Z',
        fill: 'currentcolor'
      })
    )
  );
};

var ExpandMojo = function ExpandMojo(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
    }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      d: 'M19.0019 4C19.5542 4 20.0019 4.44771 20.0019 5L20.0019 10C20.0019 10.5523 19.5542 11 19.0019 11C18.4496 11 18.0019 10.5523 18.0019 10V7.42L14.7119 10.71L14.7061 10.7158C14.314 11.1047 13.6808 11.1021 13.2919 10.71L13.2861 10.7042C12.8972 10.3121 12.8998 9.67892 13.2919 9.29L16.5719 6H14.0019C13.4496 6 13.0019 5.55228 13.0019 5C13.0019 4.44771 13.4496 4 14.0019 4H19.0019ZM9.2958 13.2842C9.68792 12.8953 10.3211 12.8979 10.71 13.29L10.7158 13.2958C11.1047 13.6879 11.1021 14.3211 10.71 14.71L7.42 18H10C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20H5C4.44771 20 4 19.5523 4 19V14C4 13.4477 4.44771 13 5 13C5.55228 13 6 13.4477 6 14V16.57L9.29 13.29L9.2958 13.2842Z'
    })
  );
};

var ExpandMojoAudio = function ExpandMojoAudio(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 18'
    }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      d: 'M16.8751 0C17.4964 0 18 0.50362 18 1.12487L18 6.7492C18 7.37045 17.4964 7.87407 16.8751 7.87407C16.2539 7.87407 15.7503 7.37045 15.7503 6.7492V3.84704L12.0495 7.54786L12.0429 7.55438C11.6018 7.99186 10.8896 7.98894 10.4521 7.54786L10.4456 7.54133C10.0081 7.10025 10.0111 6.38803 10.4521 5.95055L14.1417 2.24973H11.2508C10.6296 2.24973 10.1259 1.74611 10.1259 1.12487C10.1259 0.50362 10.6296 0 11.2508 0H16.8751ZM5.95707 10.4434C6.39815 10.0059 7.11037 10.0089 7.54786 10.4499L7.55438 10.4565C7.99186 10.8976 7.98894 11.6098 7.54786 12.0473L3.84704 15.7481H6.7492C7.37045 15.7481 7.87407 16.2517 7.87407 16.8729C7.87407 17.4942 7.37045 17.9978 6.7492 17.9978H1.12487C0.50362 17.9978 0 17.4942 0 16.8729V11.2486C0 10.6274 0.50362 10.1237 1.12487 10.1237C1.74611 10.1237 2.24973 10.6274 2.24973 11.2486V14.1395L5.95055 10.4499L5.95707 10.4434Z'
    })
  );
};

/**
 * Figure Icon
 *
 * @file Figure.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Figure = function Figure(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M2 14V9.75C2 9.33579 2.33579 9 2.75 9H6V5.75C6 5.33579 6.33579 5 6.75 5H10V2.75C10 2.33579 10.3358 2 10.75 2H15.25C15.6642 2 16 2.33579 16 2.75V14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H1C0.447715 16 0 15.5523 0 15C0 14.4477 0.447715 14 1 14H2ZM3.75 10.75V14.25H6.25V10.75H3.75ZM7.75 6.75V14.25H10.25V6.75H7.75ZM11.75 3.75V14.25H14.25V3.75H11.75Z',
        fill: 'currentcolor'
      })
    )
  );
};

var FilterIcon = function FilterIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 16 12' }, props),
    React.createElement('path', {
      stroke: 'currentcolor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '2',
      d: 'M7 11h2M1 1h14M4 6h8'
    })
  );
};

/**
 * FilterOptions Icon
 *
 * @file FilterOptions.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var FilterOptions = function FilterOptions(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 16 15' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M0.799631 3.20283H1.7432C2.19521 4.4482 3.57122 5.09136 4.81659 4.63935C5.48456 4.39691 6.01067 3.8708 6.25311 3.20283H15.193C15.6346 3.20283 15.9926 2.84482 15.9926 2.4032C15.9926 1.96157 15.6346 1.60357 15.193 1.60357H6.25311C5.8011 0.358189 4.42509 -0.284962 3.17972 0.167045C2.51175 0.409485 1.98564 0.935594 1.7432 1.60357H0.799631C0.358007 1.60357 0 1.96157 0 2.4032C0 2.84482 0.358007 3.20283 0.799631 3.20283ZM13.5937 4.8019C12.5796 4.80475 11.6768 5.44502 11.3388 6.40117H0.799631C0.358007 6.40117 0 6.75917 0 7.2008C0 7.64242 0.358007 8.00043 0.799631 8.00043H11.3388C11.7804 9.24952 13.151 9.90411 14.4001 9.46248C15.6492 9.02085 16.3038 7.65025 15.8621 6.40115C15.5225 5.44035 14.6128 4.79905 13.5937 4.8019ZM9.45164 11.1991H15.193C15.6346 11.1991 15.9926 11.5571 15.9926 11.9988C15.9926 12.4404 15.6346 12.7984 15.193 12.7984H9.45164C9.2092 13.4664 8.68309 13.9925 8.01512 14.2349C6.76974 14.6869 5.39373 14.0438 4.94172 12.7984H0.799631C0.358007 12.7984 0 12.4404 0 11.9988C0 11.5571 0.358007 11.1991 0.799631 11.1991H4.94172C5.18416 10.5312 5.71027 10.0051 6.37824 9.76261C7.62362 9.31061 8.99962 9.95376 9.45164 11.1991Z',
        fill: 'currentcolor'
      })
    )
  );
};

var FlagOutlined = function FlagOutlined(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 18 18', fill: 'none' }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      fillRule: 'evenodd',
      d: 'M3.75 1.5h12.743a.75.75 0 0 1 .614 1.181L14.25 6.75l2.857 4.069A.75.75 \n        0 0 1 16.493 12H3.75v4.5a.75.75 0 1 1-1.5 0v-15a.75.75 \n        0 0 1 1.5 0zm0 1.5v7.5h11.3l-2.633-3.75L15.05 3H3.75z'
    })
  );
};

/**
 * FlashcardOutlined icon
 *
 * @file FlashcardOutlined.jsx
 */
var FlashcardOutlined = function FlashcardOutlined(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M20.7499131,3.89281658 L21.5971235,8.69758534 C22.4488721,9.33599586 23,10.3536365 23,11.5 L23,19.5 C23,21.4329966 21.4329966,23 19.5,23 L6.5,23 C4.56700338,23 3,21.4329966 3,19.5 L3,16.612641 C2.7268278,16.2136893 2.53237177,15.7514151 2.44294349,15.2442422 L1.05375806,7.36578013 C0.718096723,5.46215007 1.98918652,3.64684572 3.89281658,3.31118437 L16.6953174,1.05375806 C18.5989474,0.718096723 20.4142518,1.98918652 20.7499131,3.89281658 Z M19.5,10 L6.5,10 C5.67157288,10 5,10.6715729 5,11.5 L5,19.5 C5,20.3284271 5.67157288,21 6.5,21 L19.5,21 C20.3284271,21 21,20.3284271 21,19.5 L21,11.5 C21,10.6715729 20.3284271,10 19.5,10 Z M15,16 C15.5522847,16 16,16.4477153 16,17 C16,17.5522847 15.5522847,18 15,18 L9,18 C8.44771525,18 8,17.5522847 8,17 C8,16.4477153 8.44771525,16 9,16 L15,16 Z M17,13 C17.5522847,13 18,13.4477153 18,14 C18,14.5522847 17.5522847,15 17,15 L9,15 C8.44771525,15 8,14.5522847 8,14 C8,13.4477153 8.44771525,13 9,13 L17,13 Z M17.0426137,3.02337357 L4.24011293,5.28079988 C3.42427148,5.42465474 2.87951871,6.20264232 3.02337357,7.01848378 L3.49654237,9.70195741 C4.1082484,8.682356 5.22443781,8 6.5,8 L19.4432672,8 L18.7802976,4.24011293 C18.6364428,3.42427148 17.8584552,2.87951871 17.0426137,3.02337357 Z'
      })
    )
  );
};

/**
 * Folder(resource) icon
 *
 * @file Folder.jsx
 * @author Sam George
 */
var Folder = function Folder(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        fillRule: 'nonzero',
        d: 'M21 19H3V7h18v12zm-.2-13.75H12L9.8 3H3.2C1.979 3 1 4.001 1 5.25v13.5C1 19.993 1.985 21 3.2 21h17.6c1.215 0 2.2-1.007 2.2-2.25V7.5c0-1.249-.99-2.25-2.2-2.25z'
      })
    )
  );
};

/**
 * Icon for Font
 *
 * @author Hari Gangadharan
 */
var Font = function Font(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 24 24' }, props),
    React.createElement(
      'g',
      { fill: 'currentcolor', fillRule: 'evenodd', transform: 'translate(-229.500000, -11.000000)' },
      React.createElement('path', {
        d: 'M249.149321,35 L246.20362,27.416 L236.701357,27.416 L233.755656,35 L231,35 L240.312217,11 L242.687783,11\n           L252,35 L249.149321,35 L249.149321,35 Z M245.348416,24.824 L242.59276,17.432 C242.21267,16.472 241.832579,\n           15.32 241.452489,13.976 C241.262443,15.032 240.882353,16.184 240.40724,17.432 L237.651584,24.824 \n           L245.348416,24.824 L245.348416,24.824 Z'
      })
    )
  );
};

/**
 * Icon for Font/Preferences.
 *
 * @file FontChange.jsx
 * @author Hari Gangadharan
 */
var FontChange = function FontChange(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M13.310767,18 L3.68909709,18 L2.08682019,22.5018489 C1.98049731,22.8005797 1.69843235,23 1.38222295,23 L0.498772198,23 C0.223307919,23 -1.42108547e-14,22.7759928 -1.42108547e-14,22.4996659 C-1.42108547e-14,22.4423332 0.00982323007,22.3854271 0.0290407035,22.3314326 L7.32560331,1.83059272 C7.55715997,1.17999789 8.27063861,0.840888161 8.91920246,1.07316993 C9.27137406,1.19929945 9.54852501,1.4773183 9.67426078,1.83059272 L15.5516441,18.3440251 L18.0133532,11.4490578 C18.2176247,10.8769166 18.8470314,10.5786993 19.4191726,10.7829708 C19.7298465,10.8938907 19.9743397,11.1383839 20.0852595,11.4490578 L23.9707516,22.331879 C24.0636022,22.5919432 23.9280489,22.8780371 23.6679848,22.9708878 C23.6140263,22.9901526 23.5571581,23 23.4998638,23 L22.8796943,23 C22.5627065,23 22.2799472,22.8007129 22.1733626,22.5021815 L21.6370389,21 L16.4969462,21 L16.9708234,22.3314326 C17.0634461,22.5916705 16.9282256,22.8779556 16.6688001,22.9708684 C16.6149741,22.990146 16.5582456,23 16.5010919,23 L15.6176411,23 C15.3014317,23 15.0193668,22.8005797 14.9130439,22.5018489 L13.310767,18 Z M12.5989364,16 L8.49993205,4.48320282 L4.4009277,16 L12.5989364,16 Z M17.086376,19.25 L21.0122367,19.25 L19.0493064,13.7520554 L17.086376,19.25 Z'
      })
    )
  );
};

/**
 * Fullscreen-off icon
 *
 * @file FullscreenOff.jsx
 * @author Sam George
 */
var FullscreenOff = function FullscreenOff(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M22,14 C22.5522847,14 23,14.4477153 23,15 C23,15.5522847 22.5522847,16 22,16 L17,16 C16.4477153,16 16,16.4477153 16,17 L16,22 C16,22.5522847 15.5522847,23 15,23 C14.4477153,23 14,22.5522847 14,22 L14,17 C14,15.3431458 15.3431458,14 17,14 L22,14 Z M7,14 C8.65685425,14 10,15.3431458 10,17 L10,22 C10,22.5522847 9.55228475,23 9,23 C8.44771525,23 8,22.5522847 8,22 L8,17 C8,16.4477153 7.55228475,16 7,16 L2,16 C1.44771525,16 1,15.5522847 1,15 C1,14.4477153 1.44771525,14 2,14 L7,14 Z M15,1 C15.5522847,1 16,1.44771525 16,2 L16,7 C16,7.55228475 16.4477153,8 17,8 L22,8 C22.5522847,8 23,8.44771525 23,9 C23,9.55228475 22.5522847,10 22,10 L17,10 C15.3431458,10 14,8.65685425 14,7 L14,2 C14,1.44771525 14.4477153,1 15,1 Z M9,1 C9.55228475,1 10,1.44771525 10,2 L10,7 C10,8.65685425 8.65685425,10 7,10 L2,10 C1.44771525,10 1,9.55228475 1,9 C1,8.44771525 1.44771525,8 2,8 L7,8 C7.55228475,8 8,7.55228475 8,7 L8,2 C8,1.44771525 8.44771525,1 9,1 Z'
      })
    )
  );
};

/**
 * Fullscreen-on icon
 *
 * @file FullscreenOn.jsx
 * @author Sam George
 */
var FullscreenOn = function FullscreenOn(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M2,14 C2.55228475,14 3,14.4477153 3,15 L3,20 C3,20.5522847 3.44771525,21 4,21 L9,21 C9.55228475,21 10,21.4477153 10,22 C10,22.5522847 9.55228475,23 9,23 L4,23 C2.34314575,23 1,21.6568542 1,20 L1,15 C1,14.4477153 1.44771525,14 2,14 Z M22,14 C22.5522847,14 23,14.4477153 23,15 L23,20 C23,21.6568542 21.6568542,23 20,23 L15,23 C14.4477153,23 14,22.5522847 14,22 C14,21.4477153 14.4477153,21 15,21 L20,21 C20.5522847,21 21,20.5522847 21,20 L21,15 C21,14.4477153 21.4477153,14 22,14 Z M9,1 C9.55228475,1 10,1.44771525 10,2 C10,2.55228475 9.55228475,3 9,3 L4,3 C3.44771525,3 3,3.44771525 3,4 L3,9 C3,9.55228475 2.55228475,10 2,10 C1.44771525,10 1,9.55228475 1,9 L1,4 C1,2.34314575 2.34314575,1 4,1 L9,1 Z M20,1 C21.6568542,1 23,2.34314575 23,4 L23,9 C23,9.55228475 22.5522847,10 22,10 C21.4477153,10 21,9.55228475 21,9 L21,4 C21,3.44771525 20.5522847,3 20,3 L15,3 C14.4477153,3 14,2.55228475 14,2 C14,1.44771525 14.4477153,1 15,1 L20,1 Z'
      })
    )
  );
};

/**
 * Globe icon
 *
 * @file Globe.jsx
 * @author Sam George
 */
var Globe = function Globe(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,16 C11.0735264,16 10.1810649,16.0493827 9.33577099,16.1383813 C9.91737584,19.6319332 11.133025,22 12,22 C12.866975,22 14.0826242,19.6319332 14.6635195,16.1371499 C13.8189688,16.0493846 12.9264911,16 12,16 Z M7.35029554,16.4268622 C5.85567319,16.710882 4.59333162,17.1094285 3.6719983,17.5376894 C4.91781043,19.40755 6.77658315,20.8341208 8.9613363,21.5304752 C8.24894044,20.2201862 7.68771071,18.4601965 7.35029554,16.4268622 Z M16.6497826,16.426877 L16.5828617,16.8060758 C16.2414169,18.6788615 15.7065351,20.3020235 15.0389153,21.5298871 C17.2234901,20.8338644 19.0821708,19.4074812 20.3292801,17.5374906 C19.4906402,17.1483763 18.3711348,16.783615 17.0515723,16.5071152 L16.6497826,16.426877 Z M2.75253733,8.18727195 C2.26755576,9.36227034 2,10.6498897 2,12 C2,13.350409 2.26767414,14.6382993 2.7536673,15.8127568 C3.92277077,15.2245958 5.408928,14.7498235 7.10300167,14.4350066 C7.0354748,13.6486995 7,12.8342924 7,12 C7,11.4174849 7.01729409,10.8446641 7.05071723,10.2843335 L7.08947358,9.72826984 L7.10300167,9.56672928 C5.40845458,9.2507363 3.92194015,8.77578688 2.75253733,8.18727195 Z M21.2473771,8.18736583 C20.0782004,8.77572619 18.5917951,9.25066064 16.897038,9.56545533 C16.9645391,10.3516195 17,11.1658709 17,12 C17,12.8342924 16.9645252,13.6486995 16.8973846,14.4339885 C18.5917951,14.7499874 20.0782004,15.2249219 21.2475509,15.8125143 C21.7324767,14.6375735 22,13.3500285 22,12 C22,10.6499715 21.7324767,9.36242648 21.2473771,8.18736583 Z M14.9110194,9.85129635 L14.6047409,9.8825328 C13.766101,9.95987026 12.8944795,10.0006481 12,10.0006481 C10.9958165,10.0006481 10.0204417,9.94925444 9.08898062,9.85129635 C9.03153154,10.5410813 9,11.259682 9,12 C9,12.7406753 9.03156198,13.4596123 9.08819966,14.1482126 C10.0204417,14.0513937 10.9958165,14 12,14 C13.0038763,14 13.9789615,14.0513622 14.9109362,14.1497024 C14.968438,13.4596123 15,12.7406753 15,12 C15,11.4447615 14.9822635,10.901739 14.9491589,10.3739271 L14.9110194,9.85129635 Z M12,2 C11.1329588,2 9.91719004,4.36842878 9.3365283,7.86350317 C10.1810649,7.9512654 11.0735264,8.00064809 12,8.00064809 C12.9264911,8.00064809 13.8189688,7.95126353 14.6643623,7.86241964 C14.08281,4.36842878 12.8670412,2 12,2 Z M8.96068405,2.47072469 L8.78877137,2.52675349 C6.67839125,3.24189108 4.8842336,4.64242921 3.67082038,6.46320415 C4.59333162,6.89121963 5.85567319,7.28976605 7.35117209,7.57348563 C7.66344884,5.6860443 8.16950839,4.03384223 8.81041549,2.75832398 L8.96068405,2.47072469 Z M15.0389153,2.47011288 L15.2200623,2.81946961 C15.8463416,4.086056 16.3412042,5.71503101 16.6497826,7.57377104 C18.1444251,7.28974183 19.4067762,6.89118321 20.3286962,6.46337348 C19.148477,4.69152172 17.4179081,3.31769299 15.3811655,2.58606305 L15.0389153,2.47011288 Z'
      })
    )
  );
};

/**
 * An icon for Grid View
 *
 * @author Praveen Punniyamoorthi
 */
var Grid = function Grid(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, props),
    React.createElement('path', {
      d: 'M9.99984 13.3334C10.368 13.3334 10.6665 13.6319 10.6665 14.0001V20.6667C10.6665 21.0349 10.368 21.3334 9.99984 21.3334H3.33317C2.96498 21.3334 2.6665 21.0349 2.6665 20.6667V14.0001C2.6665 13.6319 2.96498 13.3334 3.33317 13.3334H9.99984ZM20.6665 13.3334C21.0347 13.3334 21.3332 13.6319 21.3332 14.0001V20.6667C21.3332 21.0349 21.0347 21.3334 20.6665 21.3334H13.9998C13.6316 21.3334 13.3332 21.0349 13.3332 20.6667V14.0001C13.3332 13.6319 13.6316 13.3334 13.9998 13.3334H20.6665ZM8.33317 15.6667H4.99984V19.0001H8.33317V15.6667ZM18.9998 15.6667H15.6665V19.0001H18.9998V15.6667ZM9.99984 2.66675C10.368 2.66675 10.6665 2.96522 10.6665 3.33341V10.0001C10.6665 10.3683 10.368 10.6667 9.99984 10.6667H3.33317C2.96498 10.6667 2.6665 10.3683 2.6665 10.0001V3.33341C2.6665 2.96522 2.96498 2.66675 3.33317 2.66675H9.99984ZM20.6665 2.66675C21.0347 2.66675 21.3332 2.96522 21.3332 3.33341V10.0001C21.3332 10.3683 21.0347 10.6667 20.6665 10.6667H13.9998C13.6316 10.6667 13.3332 10.3683 13.3332 10.0001V3.33341C13.3332 2.96522 13.6316 2.66675 13.9998 2.66675H20.6665ZM8.33317 5.00008H4.99984V8.33341H8.33317V5.00008ZM18.9998 5.00008H15.6665V8.33341H18.9998V5.00008Z',
      fill: 'currentcolor',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    })
  );
};

/**
 * An icon for Home
 *
 * @author Praveen Punniyamoorthi
 */
var Home = function Home(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 23 23' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M11.7178 0.260181L22.0619 9.42766V20.7409C22.0619 21.8485 21.164 22.7464 20.0565 22.7464H13.7581C13.2043 22.7464 12.7554 22.2974 12.7554 21.7436V16.542C12.7554 15.5902 11.9838 14.8186 11.0319 14.8186C10.0801 14.8186 9.30849 15.5902 9.30849 16.542V21.7436C9.30849 22.2974 8.85956 22.7464 8.30577 22.7464H2.0074C0.899824 22.7464 0.00195313 21.8485 0.00195312 20.7409V9.42766L10.3461 0.260181C10.7375 -0.0867269 11.3263 -0.0867269 11.7178 0.260181ZM11.0317 2.87598L2.41455 10.5115V20.3323H6.89548V16.5421C6.89548 14.3393 8.61742 12.5387 10.7887 12.4129L11.0317 12.4059C13.2345 12.4059 15.0351 14.1278 15.1609 16.2991L15.168 16.5421V20.3323H19.6489V10.5129L11.0317 2.87598Z',
        fill: 'currentcolor'
      })
    )
  );
};

var HelpOutlined = function HelpOutlined(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 18 18' }, props),
    React.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      React.createElement('path', { d: 'M0 0h18v18H0z' }),
      React.createElement('path', {
        fillRule: 'nonzero',
        stroke: 'currentcolor',
        strokeWidth: '1.5',
        d: 'M9 17.25A8.25 8.25 0 1 0 9 .75a8.25 8.25 0 0 0 0 16.5z'
      }),
      React.createElement('path', {
        fill: 'currentcolor',
        fillRule: 'nonzero',
        d: 'M8.625 13h.75a.5.5 0 0 1.5.5v.75a.5.5 0 0 1-.5.5h-.75a.5.5 0 0\n          1-.5-.5v-.75a.5.5 0 0 1 .5-.5zM7.25 7.003L6.5 6.997a.5.5 0 0 1-.495-.505v-.001l.002-.18a2.505\n          2.505 0 0 1 2.497-2.306h1.69a2.81 2.81 0 0 1 2.81 2.81v.345a2.775 2.775 0 0 1-2.286 2.731\n          1.025 1.025 0 0 0-.844 1.009v.6a.5.5 0 0 1-.5.5h-.75a.5.5 0 0 1-.5-.5v-.6c0-1.344.963-2.495\n          2.286-2.731.488-.088.844-.513.844-1.009v-.345a1.06 1.06 0 0 0-1.06-1.06h-1.69c-.394\n          0-.721.302-.75.633l-.001.12a.5.5 0 0 1-.504.495z'
      })
    )
  );
};

var HelpFilled = function HelpFilled(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 18 18', fill: 'none' }, props),
    React.createElement(
      'g',
      { opacity: '0.8' },
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 \n          18ZM9.375 13C9.65114 13 9.875 13.2239 9.875 13.5V14.25C9.875 14.5261 9.65114 14.75 9.375 14.75H8.625C8.34886 \n          14.75 8.125 14.5261 8.125 14.25V13.5C8.125 13.2239 8.34886 13 8.625 13H9.375ZM6.50121 6.99673L7.24955 \n          7.00329C7.52569 7.0057 7.7515 6.78382 7.75392 6.50768L7.75497 6.38766C7.7836 6.05741 8.11117 5.755 8.50479 \n          5.755H10.195C10.7804 5.755 11.255 6.22958 11.255 6.815V7.16015C11.255 7.65638 10.8994 8.08128 10.4109 \n          8.16868C9.08806 8.40535 8.125 9.55601 8.125 10.8999V11.5C8.125 11.7761 8.34886 12 8.625 12H9.375C9.65114 12 \n          9.875 11.7761 9.875 11.5V10.8999C9.875 10.4036 10.2306 9.97872 10.7191 9.89132C12.0419 9.65465 13.005 8.50399 \n          13.005 7.16015V6.815C13.005 5.26308 11.7469 4.005 10.195 4.005H8.50479C7.19879 4.005 6.11193 5.00838 6.00779 \n          6.31022L6.00562 6.49075L6.0056 6.49237C6.00319 6.7685 6.22507 6.99431 6.50121 6.99673Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * Image Icon
 *
 * @file Image.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Image = function Image(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M3.125 2H14.875C16.0486 2 17 2.95139 17 4.125V13.875C17 15.0486 16.0486 16 14.875 16H3.125C1.95139 16 1 15.0486 1 13.875V4.125C1 2.95139 1.95139 2 3.125 2ZM15.25 10.4725V4.125C15.25 3.91789 15.0821 3.75 14.875 3.75H3.125C2.91789 3.75 2.75 3.91789 2.75 4.125V12.8902L5.40648 9.43859C5.86964 8.83679 6.73295 8.72441 7.33475 9.18757C7.39043 9.23197 7.39044 9.23198 7.44291 9.28011L7.44292 9.28012L7.44293 9.28013L8.3386 10.1306L10.4453 6.92984C10.8628 6.29552 11.7155 6.11975 12.3498 6.53726C12.493 6.6315 12.6173 6.75168 12.7163 6.89161L15.25 10.4725ZM11.6051 8.35087L15.25 13.5023V13.875C15.25 14.0821 15.0821 14.25 14.875 14.25H3.91173L6.53957 10.8356L7.67529 11.9141C8.12584 12.3419 8.83792 12.3235 9.26575 11.8729L9.26576 11.8729C9.33233 11.7985 9.33233 11.7985 9.38967 11.7168L11.6051 8.35087Z',
        fill: 'currentcolor'
      }),
      React.createElement('circle', { cx: '5.5', cy: '6.5', r: '1.5', fill: 'currentcolor' })
    )
  );
};

var Information = function Information(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
    }, props),
    React.createElement('path', {
      d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z',
      fill: 'currentcolor',
      fillRule: 'nonzero'
    }),
    React.createElement('path', {
      d: 'M11.5,9 L12.5,9 C12.7761424,9 13,9.22385763 13,9.5 L13,18.5 C13,18.7761424 12.7761424,19 12.5,19 L11.5,19 C11.2238576,19 11,18.7761424 11,18.5 L11,9.5 C11,9.22385763 11.2238576,9 11.5,9 Z',
      fill: 'currentcolor'
    }),
    React.createElement('path', {
      d: 'M11.5,5 L12.5,5 C12.7761424,5 13,5.22385763 13,5.5 L13,6.5 C13,6.77614237 12.7761424,7 12.5,7 L11.5,7 C11.2238576,7 11,6.77614237 11,6.5 L11,5.5 C11,5.22385763 11.2238576,5 11.5,5 Z',
      fill: 'currentcolor'
    })
  );
};

/**
 * Key Takeaways icon
 *
 * @author Arish Kumar K
 */
var KeyTakeaway = function KeyTakeaway(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 13 13' }, props),
    React.createElement('path', { d: 'M11.916 10L10.1093 6.88C10.479 6.201 10.6716 5.43978 10.6693 4.66667C10.6693 3.42899 10.1777 2.242 9.30248 1.36683C8.42731 0.491665 7.24033 0 6.00265 0C4.76498 0 3.57799 0.491665 2.70282 1.36683C1.82765 2.242 1.33599 3.42899 1.33599 4.66667C1.33369 5.43978 1.52629 6.201 1.89599 6.88L0.0893196 10C0.0306937 10.1015 -0.00011551 10.2167 3.25434e-07 10.334C0.000116161 10.4512 0.0311528 10.5664 0.0899792 10.6678C0.148806 10.7692 0.233341 10.8534 0.335057 10.9117C0.436772 10.97 0.552071 11.0005 0.66932 11H2.58265L3.55599 12.64C3.5888 12.6944 3.62921 12.7437 3.67599 12.7867C3.79957 12.9058 3.96434 12.9726 4.13599 12.9733H4.22932C4.32997 12.9596 4.42613 12.923 4.51048 12.8664C4.59482 12.8097 4.66512 12.7346 4.71599 12.6467L6.00265 10.4333L7.28932 12.6667C7.34094 12.7534 7.41156 12.8272 7.49586 12.8826C7.58016 12.9381 7.67594 12.9736 7.77599 12.9867H7.86932C8.04327 12.9877 8.21074 12.9207 8.33599 12.8C8.38082 12.7595 8.41906 12.7123 8.44932 12.66L9.42265 11.02H11.336C11.4535 11.0205 11.569 10.9899 11.6708 10.9313C11.7727 10.8728 11.8573 10.7884 11.916 10.6867C11.9783 10.583 12.0112 10.4643 12.0112 10.3433C12.0112 10.2224 11.9783 10.1037 11.916 10ZM4.12932 11.02L3.53599 10.0267C3.47756 9.92811 3.39473 9.84628 3.29547 9.78906C3.19621 9.73184 3.08388 9.70117 2.96932 9.7H1.81599L2.76932 8.04667C3.4258 8.67925 4.2532 9.1057 5.14932 9.27333L4.12932 11.02ZM6.00265 8C5.34338 8 4.69892 7.8045 4.15075 7.43823C3.60259 7.07196 3.17535 6.55136 2.92305 5.94228C2.67076 5.33319 2.60475 4.66297 2.73337 4.01637C2.86199 3.36976 3.17946 2.77582 3.64563 2.30964C4.11181 1.84347 4.70575 1.526 5.35235 1.39738C5.99896 1.26877 6.66918 1.33478 7.27826 1.58707C7.88735 1.83936 8.40795 2.2666 8.77422 2.81477C9.14049 3.36293 9.33599 4.0074 9.33599 4.66667C9.33599 5.55072 8.9848 6.39857 8.35968 7.02369C7.73455 7.64881 6.88671 8 6.00265 8ZM9.03599 9.7C8.92142 9.70117 8.8091 9.73184 8.70984 9.78906C8.61058 9.84628 8.52774 9.92811 8.46932 10.0267L7.87599 11.02L6.86265 9.25333C7.75564 9.08226 8.57996 8.65621 9.23599 8.02667L10.1893 9.68L9.03599 9.7Z', fill: 'black' })
  );
};

/**
 * An icon for Launch
 *
 * @author Praveen Punniyamoorthi
 */
var LaunchOutlined = function LaunchOutlined(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        d: '\n      M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2\n      2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83\n      1.41 1.41L19 6.41V10h2V3h-7z',
        fill: 'currentColor'
      })
    )
  );
};

var LineSpacingDefault = function LineSpacingDefault(props) {
  return React.createElement(
    SvgIcon,
    _extends({ width: '25', height: '12', viewBox: '0 0 25 12' }, props),
    React.createElement('rect', { y: '10', width: '25', height: '2', rx: '1', fill: 'currentColor' }),
    React.createElement('rect', { y: '5', width: '25', height: '2', rx: '1', fill: 'currentColor' }),
    React.createElement('rect', { width: '25', height: '2', rx: '1', fill: 'currentColor' })
  );
};

var LineSpacingWide = function LineSpacingWide(props) {
  return React.createElement(
    SvgIcon,
    _extends({ width: '25', height: '16', viewBox: '0 0 25 16' }, props),
    React.createElement('rect', { y: '14', width: '25', height: '2', rx: '1', fill: 'currentColor' }),
    React.createElement('rect', { y: '7', width: '25', height: '2', rx: '1', fill: 'currentColor' }),
    React.createElement('rect', { width: '25', height: '2', rx: '1', fill: 'currentColor' })
  );
};

var LineSpacingWider = function LineSpacingWider(props) {
  return React.createElement(
    SvgIcon,
    _extends({ width: '25', height: '20', viewBox: '0 0 25 20' }, props),
    React.createElement('rect', { y: '18', width: '25', height: '2', rx: '1', fill: 'currentColor' }),
    React.createElement('rect', { y: '9', width: '25', height: '2', rx: '1', fill: 'currentColor' }),
    React.createElement('rect', { width: '25', height: '2', rx: '1', fill: 'currentColor' })
  );
};

/**
 * Links Icon
 *
 * @file Links.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Links = function Links(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M12.8743 4.005C15.6329 4.005 17.8693 6.24133 17.8693 9C17.8693 11.7587 15.6329 13.995 12.8743 13.995H11.0057C10.5225 13.995 10.1307 13.6032 10.1307 13.12C10.1307 12.6367 10.5225 12.245 11.0057 12.245H12.8743C14.6664 12.245 16.1193 10.7922 16.1193 9C16.1193 7.20783 14.6664 5.755 12.8743 5.755H11.0057C10.5225 5.755 10.1307 5.36325 10.1307 4.88C10.1307 4.39675 10.5225 4.005 11.0057 4.005H12.8743ZM6.99428 4.005C7.47753 4.005 7.86928 4.39675 7.86928 4.88C7.86928 5.36325 7.47753 5.755 6.99428 5.755H5.12571C3.33354 5.755 1.88071 7.20783 1.88071 9C1.88071 10.7922 3.33354 12.245 5.12571 12.245H6.99428C7.47753 12.245 7.86928 12.6367 7.86928 13.12C7.86928 13.6032 7.47753 13.995 6.99428 13.995H5.12571C2.36704 13.995 0.130707 11.7587 0.130707 9C0.130707 6.24133 2.36704 4.005 5.12571 4.005H6.99428ZM12 8C12.5523 8 13 8.44771 13 9C13 9.55228 12.5523 10 12 10H5.99999C5.44771 10 4.99999 9.55228 4.99999 9C4.99999 8.44771 5.44771 8 5.99999 8H12Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * List bulleted icon
 *
 * @file ListBulleted.jsx
 * @author Sam George
 */
var ListBulleted = function ListBulleted(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M3.5,16.5 C4.32842712,16.5 5,17.1715729 5,18 C5,18.8284271 4.32842712,19.5 3.5,19.5 C2.67157288,19.5 2,18.8284271 2,18 C2,17.1715729 2.67157288,16.5 3.5,16.5 Z M21,17 C21.5522847,17 22,17.4477153 22,18 C22,18.5522847 21.5522847,19 21,19 L8,19 C7.44771525,19 7,18.5522847 7,18 C7,17.4477153 7.44771525,17 8,17 L21,17 Z M3.5,10.5 C4.32842712,10.5 5,11.1715729 5,12 C5,12.8284271 4.32842712,13.5 3.5,13.5 C2.67157288,13.5 2,12.8284271 2,12 C2,11.1715729 2.67157288,10.5 3.5,10.5 Z M21,11 C21.5522847,11 22,11.4477153 22,12 C22,12.5522847 21.5522847,13 21,13 L8,13 C7.44771525,13 7,12.5522847 7,12 C7,11.4477153 7.44771525,11 8,11 L21,11 Z M3.5,4.5 C4.32842712,4.5 5,5.17157288 5,6 C5,6.82842712 4.32842712,7.5 3.5,7.5 C2.67157288,7.5 2,6.82842712 2,6 C2,5.17157288 2.67157288,4.5 3.5,4.5 Z M21,5 C21.5522847,5 22,5.44771525 22,6 C22,6.55228475 21.5522847,7 21,7 L8,7 C7.44771525,7 7,6.55228475 7,6 C7,5.44771525 7.44771525,5 8,5 L21,5 Z'
      })
    )
  );
};

/**
 * Listen(audio) icon
 *
 * @file Listen.jsx
 * @author Sam George
 */
var Listen = function Listen(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M13,1 C17.418278,1 21,4.581722 21,9 L21,11.684544 C22.7864764,12.6506437 24,14.5407479 24,16.7142857 L24,17.2857143 C24,20.4416271 21.4416271,23 18.2857143,23 L18,23 C16.8954305,23 16,22.1045695 16,21 L16,13 C16,11.8954305 16.8954305,11 18,11 L18.2857143,11 C18.5276145,11 18.7660041,11.015031 19,11.0442098 L19,9 C19,5.6862915 16.3137085,3 13,3 L11,3 C7.6862915,3 5,5.6862915 5,9 L5,11.0442098 C5.23399589,11.015031 5.47238547,11 5.71428571,11 L6,11 C7.1045695,11 8,11.8954305 8,13 L8,21 C8,22.1045695 7.1045695,23 6,23 L5.71428571,23 C2.55837286,23 0,20.4416271 0,17.2857143 L0,16.7142857 C0,14.5407479 1.21352361,12.6506437 3,11.684544 L3,9 C3,4.581722 6.581722,1 11,1 L13,1 Z M18.2857143,13 L18,13 L18,21 L18.2857143,21 C20.3370576,21 22,19.3370576 22,17.2857143 L22,16.7142857 C22,14.6629424 20.3370576,13 18.2857143,13 Z M6,13 L5.71428571,13 C3.66294236,13 2,14.6629424 2,16.7142857 L2,17.2857143 C2,19.3370576 3.66294236,21 5.71428571,21 L6,21 L6,13 Z'
      })
    )
  );
};

/**
 * List View Icon
 *
 * @file ListView.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var ListView = function ListView(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement(
        'g',
        { fill: 'none' },
        React.createElement('rect', { x: '3', y: '6', width: '18', height: '4', rx: '1', stroke: 'currentcolor', strokeWidth: '1.5' }),
        React.createElement('rect', { x: '3', y: '14', width: '18', height: '4', rx: '1', stroke: 'currentcolor', strokeWidth: '1.5' })
      )
    )
  );
};

var LockIcon = function LockIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 16 18'
    }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      d: 'M2.598 6.26v-.782a5.478 5.478 0 1 1 10.956 0v.783h.783c.864 0 1.565.7 1.565 1.565v8.609c0 .864-.7 1.565-1.565 \n        1.565H1.815C.951 18 .25 17.3.25 16.435V7.826c0-.864.7-1.565 1.565-1.565h.783zm1.565 0h7.826v-.782a3.913 3.913 \n        0 1 0-7.826 0v.783zm4.97 6.471c.465-.331.768-.875.768-1.49v-.021a1.828 1.828 0 0 0-3.656 0v.021c0 .618.306 \n        1.164.775 1.495v1.742c0 .216.175.392.39.392h1.331a.391.391 0 0 0 .392-.392v-1.747z'
    })
  );
};

/**
 * Lock-on outlined icon
 *
 * @file LockOnOutlined.jsx
 * @author Sam George
 */
var LockOnOutlined = function LockOnOutlined(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        React.createElement('path', { d: 'M0 0H24V24H0z', transform: 'translate(-2)' }),
        React.createElement('path', {
          fill: 'currentcolor',
          d: 'M12 0c3.866 0 7 3.134 7 7v1h1c1.105 0 2 .895 2 2v11c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2V10c0-1.105.895-2 2-2h1V7c0-3.866 3.134-7 7-7zm8 10H4v11h16V10zM7 8h10V7c0-2.761-2.239-5-5-5S7 4.239 7 7v1zm6.35 8.268c.595-.424.982-1.119.982-1.904v-.028c0-1.29-1.046-2.336-2.336-2.336-1.29 0-2.336 1.046-2.336 2.336v.028c0 .789.391 1.486.99 1.91V18.5c0 .276.224.5.5.5h1.7c.276 0 .5-.224.5-.5v-2.232z',
          transform: 'translate(-2)'
        })
      )
    )
  );
};

var MenuIcon = function MenuIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 20 18' }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      d: 'M1 0h18a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zM1 8h18a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2zM1 16h18a1 1 0 0 1 0 \n        2H1a1 1 0 0 1 0-2z'
    })
  );
};

var MessageOutlined = function MessageOutlined(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 18 18', fill: 'none' }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      fillRule: 'nonzero',
      d: 'M13.114 17.714c.504 0 .798-.354.798-.918v-2.17h.463c2.333 0 3.625-1.304 3.625-3.6V4.6C18 \n        2.304 16.708 1 14.375 1H3.625C1.292 1 0 2.315 0 4.6v6.426c0 2.285 1.292 3.6 3.625 3.6h5.58l2.869 \n        2.514c.43.386.683.574 1.04.574zM12.82 16.4l-2.67-2.577c-.294-.292-.504-.355-.924-.355h-5.59c-1.64 \n        0-2.47-.866-2.47-2.452V4.61c0-1.586.83-2.452 2.47-2.452h10.728c1.65 0 2.47.866 2.47 2.452v6.406c0 \n        1.586-.82 2.452-2.47 2.452h-.998c-.4 0-.546.156-.546.542v2.39z'
    })
  );
};

/**
 * Misc. Icon
 *
 * @file Misc.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Misc = function Misc(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M14 15V16C14 17.1046 13.1046 18 12 18H3C1.89543 18 1 17.1046 1 16V5C1 3.89543 1.89543 3 3 3H4V2C4 0.89543 4.89543 0 6 0H12.5858C12.851 0 13.1054 0.105357 13.2929 0.292893L16.7071 3.70711C16.8946 3.89464 17 4.149 17 4.41421V13C17 14.1046 16.1046 15 15 15H14ZM12.25 15H6C4.89543 15 4 14.1046 4 13V4.75H3C2.86193 4.75 2.75 4.86193 2.75 5V16C2.75 16.1381 2.86193 16.25 3 16.25H12C12.1381 16.25 12.25 16.1381 12.25 16V15ZM15.25 13V5H13C12.4477 5 12 4.55228 12 4V1.75H6C5.86193 1.75 5.75 1.86193 5.75 2V13C5.75 13.1381 5.86193 13.25 6 13.25H15C15.1381 13.25 15.25 13.1381 15.25 13Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * Renders the More overflow menu (3 vertical dots)
 *
 * @file MoreVert.jsx
 * @author Hari Gangadharan
 */
var MoreVert = function MoreVert(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M12,18 C13.1045695,18 14,18.8954305 14,20 C14,21.1045695 13.1045695,22 12,22 C10.8954305,22 10,21.1045695 10,20 C10,18.8954305 10.8954305,18 12,18 Z M12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 Z M12,2 C13.1045695,2 14,2.8954305 14,4 C14,5.1045695 13.1045695,6 12,6 C10.8954305,6 10,5.1045695 10,4 C10,2.8954305 10.8954305,2 12,2 Z'
      })
    )
  );
};

/**
 * Navigation Icon
 *
 * @file Navigation.jsx
 * @author Nivedhitha M
 */
var Navigation = function Navigation(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 23 23' }, props),
      React.createElement('path', {
        fill: 'none',
        d: 'M12.1109 6.11145L21.6569 1.51525L17.0607 11.0612L11.7783 21.3478C11.333 22.215 10.0367 21.9975 9.89883 21.0324L8.92893 14.2432L2.13968 13.2733C1.17462 13.1354 0.957091 11.8391 1.82429 11.3938L12.1109 6.11145Z',
        stroke: 'currentcolor',
        strokeWidth: '2',
        strokeLinejoin: 'round'
      })
    )
  );
};

/**
 * New Preference Icon
 *
 * @file NewPreference.jsx
 * @author Satyaki Bose
 */

var NewPreference = function NewPreference(props) {
  return React.createElement(
    SvgIcon,
    props,
    React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.6892 17H20.3109L21.9132 21.5018C22.0195 21.8006 22.3016 22 22.6178 22H23.5012C23.7767  22 24 21.776 24 21.4997C24 21.4423 23.9902 21.3854 23.971 21.3314L16.6744 0.830593C16.4428  0.179998 15.7294 -0.159112 15.0808 0.0731699C14.7286 0.199299 14.4515 0.477318 14.3257 0.830593L8.44836  17.344L5.98665 10.4491C5.78238 9.87692 5.15297 9.5787 4.58083 9.78297C4.27015 9.89389 4.02566 10.1384  3.91474 10.4491L0.0292492 21.3319C-0.0636005 21.5919 0.0719509 21.878 0.332016 21.9709C0.385975 21.9902  0.442841 22 0.500135 22H1.12031C1.43729 22 1.72005 21.8007 1.82664 21.5022L2.36296 20H7.50305L7.02918  21.3314C6.93655 21.5917 7.07177 21.878 7.3312 21.9709C7.38503 21.9901 7.44176 22 7.49891 22H8.38236C8.69857  22 8.98063 21.8006 9.08696 21.5018L10.6892 17ZM11.4011 15L15.5001 3.4832L19.5991 15H11.4011ZM6.91362  18.25H2.98776L4.95069 12.7521L6.91362 18.25Z',
      fill: 'currentColor'
    })
  );
};

/**
 * Notebook icon
 *
 * @file Notebook.jsx
 */
var Notebook = function Notebook(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M18,1 C18.5522847,1 19,1.44771525 19,2 L20.5,2 C21.8807119,2 23,3.11928813 23,4.5 L23,15.1715729 C23,15.7020059 22.7892863,16.2107137 22.4142136,16.5857864 L16.5857864,22.4142136 C16.2107137,22.7892863 15.7020059,23 15.1715729,23 L3.5,23 C2.11928813,23 1,21.8807119 1,20.5 L1,4.5 C1,3.11928813 2.11928813,2 3.5,2 L5,2 C5,1.44771525 5.44771525,1 6,1 C6.55228475,1 7,1.44771525 7,2 L9,2 C9,1.44771525 9.44771525,1 10,1 C10.5522847,1 11,1.44771525 11,2 L13,2 C13,1.44771525 13.4477153,1 14,1 C14.5522847,1 15,1.44771525 15,2 L17,2 C17,1.44771525 17.4477153,1 18,1 Z M5,4 L3.5,4 C3.22385763,4 3,4.22385763 3,4.5 L3,4.5 L3,20.5 C3,20.7761424 3.22385763,21 3.5,21 L3.5,21 L15,21 L15,17.5 C15,16.1192881 16.1192881,15 17.5,15 L17.5,15 L21,15 L21,4.5 C21,4.22385763 20.7761424,4 20.5,4 L20.5,4 L19,4 L19,5 C19,5.55228475 18.5522847,6 18,6 C17.4477153,6 17,5.55228475 17,5 L17,5 L17,4 L15,4 L15,5 C15,5.55228475 14.5522847,6 14,6 C13.4477153,6 13,5.55228475 13,5 L13,5 L13,4 L11,4 L11,5 C11,5.55228475 10.5522847,6 10,6 C9.44771525,6 9,5.55228475 9,5 L9,5 L9,4 L7,4 L7,5 C7,5.55228475 6.55228475,6 6,6 C5.44771525,6 5,5.55228475 5,5 L5,5 L5,4 Z'
      })
    )
  );
};

/**
 * Notes Icon
 *
 * @file Notes.jsx
 * @author Nivedhitha M
 */
var Notes = function Notes(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 19 22', fill: 'none' }, props),
      React.createElement('path', {
        clipRule: 'evenodd',
        fillRule: 'evenodd',
        fill: 'currentcolor',
        d: 'M1.00024 4.625V2C1.00024 0.895428 1.89567 0 3.00024 0H17.0002C18.0002 0 19.0002 0.999998 19.0002 2V4V6V20C19.0002 21.1046 18.1048 22 17.0002 22L3.00024 22C1.89567 22 1.00024 21.1046 1.00024 20V16.75H0.875244C0.391995 16.75 0.000244141 16.3583 0.000244141 15.875C0.000244141 15.3918 0.391995 15 0.875244 15H1.00024V13.25H0.875244C0.391995 13.25 0.000244141 12.8583 0.000244141 12.375C0.000244141 11.8918 0.391995 11.5 0.875244 11.5H1.00024V9.75H0.875244C0.391995 9.75 0.000244141 9.35825 0.000244141 8.875C0.000244141 8.39176 0.391995 8 0.875244 8H1.00024V6.375H0.875244C0.391995 6.375 0.000244141 5.98325 0.000244141 5.5C0.000244141 5.01675 0.391995 4.625 0.875244 4.625H1.00024ZM9.82761 1.75H17.0007C17.0995 1.75 17.2507 1.85181 17.2507 2V6.00001V20C17.2507 20.1381 17.1388 20.25 17.0007 20.25H7.75024V1.75H9.82761ZM6.00024 1.75H3.00073C2.86265 1.75 2.75073 1.86193 2.75073 2L2.75068 4.625H3.62568C4.10893 4.625 4.50069 5.01675 4.50069 5.5C4.50069 5.98325 4.10893 6.375 3.62568 6.375H2.75068L2.75072 8H3.62572C4.10897 8 4.50072 8.39175 4.50072 8.875C4.50072 9.35825 4.10897 9.75 3.62572 9.75H2.75072L2.75073 11.5H3.62573C4.10897 11.5 4.50073 11.8918 4.50073 12.375C4.50073 12.8583 4.10897 13.25 3.62573 13.25H2.75073V15H3.62573C4.10897 15 4.50073 15.3918 4.50073 15.875C4.50073 16.3583 4.10897 16.75 3.62573 16.75H2.75073V20C2.75073 20.1381 2.86265 20.25 3.00073 20.25H6.00024V1.75ZZ'
      })
    )
  );
};

/**
 * Pause icon for media player
 *
 * @author Sam George
 */
var Pause = function Pause(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 24 24' }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      fillRule: 'evenodd',
      d: 'M15.5,3 L19.5,3 C20.3284271,3 21,3.67157288 21,4.5 L21,19.5 C21,20.3284271 20.3284271,21 19.5,21 L15.5,21 C14.6715729,21 14,20.3284271 14,19.5 L14,4.5 C14,3.67157288 14.6715729,3 15.5,3 Z'
    }),
    React.createElement('path', {
      fill: 'currentcolor',
      fillRule: 'evenodd',
      d: 'M4.5,3 L8.5,3 C9.32842712,3 10,3.67157288 10,4.5 L10,19.5 C10,20.3284271 9.32842712,21 8.5,21 L4.5,21 C3.67157288,21 3,20.3284271 3,19.5 L3,4.5 C3,3.67157288 3.67157288,3 4.5,3 Z'
    })
  );
};

/**
 * Renders PDF Icon.
 *
 * @author Hari Gangadharan
 */
var Pdf = function Pdf(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 35 42' }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      fillRule: 'evenodd',
      d: 'M32.5 38.719c0 .356-.286.656-.625.656H3.125c-.339 0-.625-.3-.625-.656V3.28c0-.355.286-.656.625-.656h18.75c' + '.189 0 .4.025.625.07v10.43h9.934c.042.236.066.458.066.656V38.72zm-1.477-28.683c.122.128.244.286.362.464H25V3' + '.796c.17.124.32.252.442.38l5.58 5.86zM32.79 8.18l-5.58-5.86C25.994 1.044 23.594 0 21.875 0H3.125C1' + '.406 0 0 1.477 0 3.281V38.72C0 40.523 1.406 42 3.125 42h28.75C33.594 42 35 40.523 35 38.719V13.78c0-1.804-' + '.994-4.325-2.21-5.601zm-2.91 17.81c-.163.106-.628.168-.927.168-.965 0-2.159-.464-3.833-1.217.643-.05 1.233-' + '.075 1.762-.075.968 0 1.255-.005 2.201.249.947.253.958.768.796.875zm-16.8.157c.37-.694.753-1.425 1.146-2' + '.201.957-1.9 1.56-3.387 2.01-4.608.896 1.71 2.01 3.163 3.32 4.327.164.146.337.292.52.437-2.665.554-4' + '.968 1.227-6.996 2.045zM16.19 8.19c.53 0 .831 1.403.856 2.718.025 1.315-.268 2.238-.63 2.92-.302-1.01-' + '.447-2.604-.447-3.646 0 0-.022-1.992.22-1.992zM5.768 33.39c.3-.863 1.49-2.57 3.25-4.084.11-.094.383-.362' + '.632-.61-1.84 3.08-3.072 4.309-3.882 4.694zm24.623-9.211c-.533-.552-1.715-.844-3.514-.868-1.218-.015-2.684' + '.098-4.226.325-.69-.419-1.402-.874-1.96-1.422-1.503-1.473-2.757-3.518-3.538-5.766.05-.21.094-.395.134-' + '.583 0 0 .847-5.048.623-6.754a2.054 2.054 0 0 0-.11-.484l-.074-.198c-.23-.558-.681-1.149-1.389-1.116l-' + '.415-.014h-.011c-.79 0-1.432.423-1.601 1.057-.513 1.986.016 4.958.976 8.807l-.246.627c-.687 1.759-' + '1.548 3.53-2.308 5.093l-.098.203a86.95 86.95 0 0 1-2.182 4.217l-.679.377c-.05.027-1.213.673-1.485.847-' + '2.315 1.45-3.849 3.098-4.103 4.406-.081.417-.021.95.39 1.198l.657.347c.285.15.585.225.893.225 1.648 0 3.562' + '-2.156 6.199-6.987 3.044-1.041 6.51-1.906 9.547-2.383 2.315 1.369 5.162 2.32 6.96 2.32.318 0 .593-.033' + '.817-.095.344-.096.635-.302.812-.582.348-.551.42-1.31.325-2.087-.029-.23-.204-.515-.394-.71z'
    })
  );
};

/**
 * PearsonLogoMojo Icon
 *
 * @file PearsonLogoMojo.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var PearsonLogoMojo = function PearsonLogoMojo(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 60 60' }, props),
      React.createElement(
        'g',
        { fill: 'none' },
        React.createElement('rect', {
          width: '60',
          height: '60',
          rx: '13',
          fill: 'url(#paint0_linear_11587:14567)'
        }),
        React.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M44.2572 38.353C49.8988 28.4639 48.011 18.6907 39.9036 14.3314C30.9457 9.51361 19.2674 12.1349 14.2334 22.4537C10.7661 29.5585 12.3405 41.906 20.4082 46.3328C28.4747 50.7572 39.2999 47.0449 44.2572 38.353ZM41.5176 27.8438C41.7926 25.8537 41.2989 23.4279 39.7117 21.8288L39.6886 21.807C36.6396 18.5569 32.4062 18.353 29.7255 18.4157C26.7621 18.4869 24.6339 19.4102 22.8932 20.2671C21.3738 21.0141 20.004 22.2994 19.4476 22.9379C19.0934 23.3446 18.491 24.1846 18.8145 24.9377C19.0806 25.5628 20.0794 25.5218 20.4555 25.2551C20.6535 25.1141 20.8579 24.9345 21.0827 24.7369C21.2834 24.5605 21.5003 24.3699 21.7434 24.1797C24.0315 22.3936 26.0599 21.2688 30.7857 21.2688C35.5115 21.2688 38.072 24.0494 38.072 26.5319C38.072 29.0145 36.8289 30.7005 34.4794 31.8011C33.3168 32.3454 32.0736 32.7666 30.5082 32.8234C30.622 30.4169 30.6808 28.1395 30.6808 28.1395C30.6863 27.8543 30.6993 27.5778 30.7117 27.3139C30.7747 25.9752 30.8225 24.9596 29.7958 24.7651C28.5693 24.5322 26.3093 24.7615 26.2671 26.083C26.2121 25.8863 26.4999 36.9122 26.5523 37.1295L26.5728 37.3829C26.5971 37.6629 26.702 37.9091 26.8874 38.1058C27.0729 38.3001 27.3734 38.4208 27.6433 38.4498C27.6855 38.4534 27.7277 38.457 27.7699 38.457C28.027 38.457 28.3889 38.4136 28.7534 38.317C29.2139 38.1927 29.6769 37.9815 29.9442 37.6521C30.0797 37.4855 30.191 37.3238 30.2486 37.0257C30.2882 36.8229 30.3662 35.5424 30.3867 35.1707C32.8717 35.149 35.3977 34.7097 37.32 33.6042C39.7436 32.2127 41.2017 30.1127 41.5176 27.8438ZM28.6588 39.7267C28.9389 39.7786 29.2151 39.9029 29.462 40.0839H29.462C29.9097 40.4122 30.1783 40.9251 30.1833 41.4501C30.1872 41.9027 29.9864 42.307 29.6168 42.593C29.2983 42.8344 28.889 42.9647 28.4337 42.9647H28.4324C28.2239 42.9647 28.0155 42.9357 27.8121 42.8826C27.4591 42.7873 27.1752 42.6292 26.9897 42.424C26.8235 42.2418 26.7122 41.9968 26.6636 41.7132C26.5894 41.2715 26.7058 40.8141 26.9872 40.4327C27.3248 39.9729 27.8428 39.6989 28.3697 39.6989C28.4657 39.6989 28.5641 39.7086 28.6588 39.7267Z',
          fill: '#FEFEFE'
        })
      ),
      React.createElement(
        'defs',
        null,
        React.createElement(
          'linearGradient',
          {
            id: 'paint0_linear_11587:14567',
            x1: '56.875',
            y1: '-5.71133e-07',
            x2: '7.13952e-07',
            y2: '65.5',
            gradientUnits: 'userSpaceOnUse'
          },
          React.createElement('stop', { stopColor: '#360017' }),
          React.createElement('stop', { offset: '1', stopColor: '#73016E' })
        )
      )
    )
  );
};

var PearsonLogo = function PearsonLogo(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      width: 43,
      height: 48,
      viewBox: '0 0 43 48'
    }, props),
    React.createElement('path', {
      id: 'a',
      fill: 'currentcolor',
      d: 'M33.192 3.028c9.82 5.662 12.106 18.358 5.273 31.203C32.461 45.523 19.35 50.345 9.58 44.596-.193 38.846-2.1 \n        22.808 2.099 13.578 8.197.175 22.342-3.23 33.192 3.028zM19.227 35.981c-.639 0-1.265.356-1.675.953a2.3 2.3 0 0 \n        0-.391 1.665c.057.366.193.685.394.922.225.269.569.474.996.597.246.069.5.106.753.106.551 0 1.047-.168 \n        1.432-.484.448-.37.692-.896.687-1.482a2.304 2.304 0 0 0-.873-1.775 2.345 2.345 0 0 0-.973-.467 1.835 \n        1.835 0 0 0-.35-.035zm13.71-23.24c-3.694-4.221-8.821-4.487-12.069-4.404-3.589.091-6.167 1.29-8.275 \n        2.404-1.84.97-3.5 2.64-4.173 3.469-.429.528-1.158 1.62-.768 2.598.324.812 1.533.76 1.988.412.455-.347.936-.874 \n        1.561-1.397 2.771-2.32 5.228-3.781 10.952-3.781 5.723 0 8.826 3.612 8.826 6.837 0 3.225-1.506 5.415-4.352 \n        6.843-1.41.708-2.915 1.255-4.81 \n        1.33.138-3.127.208-6.085.208-6.085.04-2.25.417-4.08-1.071-4.384-1.486-.303-4.223-.004-4.274 1.712-.067-.255.281\n        14.067.345 14.35l.025.329c.03.363.157.684.381.938.225.253.588.41.916.447.05.006.101.009.154.009.31 0 .748-.055 \n        1.191-.182.557-.16 1.118-.436 1.441-.862.164-.218.299-.427.37-.815.047-.263.143-1.927.167-2.41 3.01-.027 \n        6.069-.6 8.397-2.033 2.937-1.809 4.702-4.536 5.084-7.483.334-2.585-.265-5.737-2.187-7.814z'
    })
  );
};

/**
 * Play icon for media player
 *
 * @author Sam George
 */
var Play = function Play(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        fillRule: 'evenodd',
        d: 'M6.19561754,2.16877423 L22.0592145,10.4487432 C22.9164049,10.8961518 23.2483935,11.9533453 22.8007316,12.8100509 C22.6351144,13.1269983 22.3763278,13.385636 22.0591994,13.5511565 L6.19560463,21.8309285 C5.46086625,22.2144145 4.55419036,21.930005 4.17048735,21.1956822 C4.0584905,20.981345 4,20.7431242 4,20.5013194 L4,3.49837657 C4,2.66994944 4.67195293,1.99837657 5.50084888,1.99837657 C5.74279543,1.99837657 5.98115573,2.05683637 6.19561754,2.16877423 Z'
      })
    )
  );
};

/**
 * Preview icon
 *
 * @file Preview.jsx
 * @author Sam George
 */
var Preview = function Preview(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M12.5 8c3.038 0 5.5 2.462 5.5 5.5 0 1.157-.357 2.231-.968 3.117l4.696 4.696c.39.39.39 1.024 0 1.415-.36.36-.928.388-1.32.083l-.095-.083-4.696-4.696c-.886.61-1.96.968-3.117.968C9.462 19 7 16.538 7 13.5S9.462 8 12.5 8zm4.086-7c.265 0 .52.105.707.293l4.414 4.414c.188.188.293.442.293.707V19.11l-2-1.999V7h-3l-.117-.007c-.459-.053-.823-.417-.876-.876L16 6V3H4.5l-.09.008c-.175.032-.318.155-.379.318l-.023.084L4 3.5v17l.008.09c.032.175.155.318.318.379l.084.023.09.008h11.611l1.999 2H4.5C3.12 23 2 21.88 2 20.5v-17C2 2.12 3.12 1 4.5 1h12.086zM12.5 10C10.567 10 9 11.567 9 13.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5z'
      })
    )
  );
};

/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Punch hole locked icon. This icon have rounded hole on the lock
 *
 * @author Vinothkumar, Krishnamoorthi
 * @file PunchHoleLock.jsx
 */
var PunchHoleLock = function PunchHoleLock(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 16 16'
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, props),
    React.createElement(
      'g',
      {
        fill: 'currentcolor',
        fillRule: 'evenodd'
      },
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M4 6V5c0-2.21 1.79-4 4-4s4 1.79 4 4v1h.5c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5h-9c-.828 0-1.5-.672-1.5-1.5v-6C2 6.672 2.672 6 3.5 6H4zm1.75 0h4.5V5c0-1.243-1.007-2.25-2.25-2.25S5.75 3.757 5.75 5v1zM7.5 9c-.276 0-.5.224-.5.5v2c0 .276.224.5.5.5h1c.276 0 .5-.224.5-.5v-2c0-.276-.224-.5-.5-.5h-1z',
        transform: 'translate(-296 -1248) translate(292 442) translate(0 320) translate(0 88) translate(0 384) translate(4 12) translate(0 2)'
      })
    )
  );
};

/**
 * Quizzes Icon
 *
 * @file Quizzes.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Quizzes = function Quizzes(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 19 14' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M2.27692 0.886719C3.10535 0.886719 3.77692 1.55829 3.77692 2.38672C3.77692 3.21515 3.10535 3.88672 2.27692 3.88672C1.4485 3.88672 0.776924 3.21515 0.776924 2.38672C0.776924 1.55829 1.4485 0.886719 2.27692 0.886719ZM3.77692 7.06851C3.77692 6.24008 3.10534 5.56851 2.27692 5.56851C1.44849 5.56851 0.776917 6.24008 0.776917 7.06851C0.776917 7.89694 1.44849 8.56851 2.27692 8.56851C3.10534 8.56851 3.77692 7.89694 3.77692 7.06851ZM3.77692 11.7503C3.77692 10.9219 3.10534 10.2503 2.27692 10.2503C1.44849 10.2503 0.776917 10.9219 0.776917 11.7503C0.776917 12.5787 1.44849 13.2503 2.27692 13.2503C3.10534 13.2503 3.77692 12.5787 3.77692 11.7503ZM2.27692 12.5003C2.69113 12.5003 3.02692 12.1645 3.02692 11.7503C3.02692 11.3361 2.69113 11.0003 2.27692 11.0003C1.8627 11.0003 1.52692 11.3361 1.52692 11.7503C1.52692 12.1645 1.8627 12.5003 2.27692 12.5003ZM17.5518 10.7503C18.0396 10.7503 18.4351 11.198 18.4351 11.7503C18.4351 12.3026 18.0396 12.7503 17.5518 12.7503H6.06842C5.58057 12.7503 5.18509 12.3026 5.18509 11.7503C5.18509 11.198 5.58057 10.7503 6.06842 10.7503H17.5518ZM3.02692 7.06851C3.02692 7.48273 2.69113 7.81851 2.27692 7.81851C1.8627 7.81851 1.52692 7.48273 1.52692 7.06851C1.52692 6.6543 1.8627 6.31851 2.27692 6.31851C2.69113 6.31851 3.02692 6.6543 3.02692 7.06851ZM18.4351 7.06851C18.4351 6.51623 18.0396 6.06851 17.5517 6.06851H6.06841C5.58056 6.06851 5.18508 6.51623 5.18508 7.06851C5.18508 7.6208 5.58056 8.06851 6.06841 8.06851H17.5517C18.0396 8.06851 18.4351 7.6208 18.4351 7.06851ZM18.4351 2.38672C18.4351 1.83443 18.0396 1.38672 17.5518 1.38672H6.06843C5.58057 1.38672 5.18509 1.83443 5.18509 2.38672C5.18509 2.939 5.58057 3.38672 6.06843 3.38672H17.5518C18.0396 3.38672 18.4351 2.939 18.4351 2.38672Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * Remove icon
 *
 * @file Remove.jsx
 */
var Remove = function Remove(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M12,10.5857864 L17.2928932,5.29289322 C17.6834175,4.90236893 18.3165825,4.90236893 18.7071068,5.29289322 C19.0976311,5.68341751 19.0976311,6.31658249 18.7071068,6.70710678 L13.4142136,12 L18.7071068,17.2928932 C19.0976311,17.6834175 19.0976311,18.3165825 18.7071068,18.7071068 C18.3165825,19.0976311 17.6834175,19.0976311 17.2928932,18.7071068 L12,13.4142136 L6.70710678,18.7071068 C6.31658249,19.0976311 5.68341751,19.0976311 5.29289322,18.7071068 C4.90236893,18.3165825 4.90236893,17.6834175 5.29289322,17.2928932 L10.5857864,12 L5.29289322,6.70710678 C4.90236893,6.31658249 4.90236893,5.68341751 5.29289322,5.29289322 C5.68341751,4.90236893 6.31658249,4.90236893 6.70710678,5.29289322 L12,10.5857864 Z'
      })
    )
  );
};

/**
 * Remove icon
 *
 * @author Arish Kumar K
 */
var RemoveCircleOutlined = function RemoveCircleOutlined(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '2 2 20 20' }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      d: 'M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
    })
  );
};

/**
 * Resources Nav Icon
 *
 * @file ResourcesNav.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var ResourcesNav = function ResourcesNav(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 22 18' }, props),
      React.createElement('path', {
        d: 'M19.5909 16H2.40909V2.5C2.40909 2.22386 2.63295 2 2.90909 2H6.58579C6.851 2 7.10536 2.10536 7.29289 2.29289L9 4H19.5909V16ZM19.4 2.25H10.1L8.59301 0.635363C8.21475 0.230093 7.68526 0 7.1309 0L2.6 0C1.4345 0 0.5 1.00125 0.5 2.25V15.75C0.5 16.9926 1.4402 18 2.6 18H19.4C20.5598 18 21.5 16.9926 21.5 15.75V4.5C21.5 3.25125 20.555 2.25 19.4 2.25Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * Resources Nav Filled Icon
 *
 * @file ResourcesNavFilled.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var ResourcesNavFilled = function ResourcesNavFilled(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 40 40' }, props),
      React.createElement('circle', { cx: '20', cy: '20', r: '20', fill: '#94E7EA' }),
      React.createElement('path', {
        d: 'M28.5909 27H11.4091V13.5C11.4091 13.2239 11.6329 13 11.9091 13H15.5858C15.851 13 16.1054 13.1054 16.2929 13.2929L18 15H28.5909V27ZM28.4 13.25H19.1L17.593 11.6354C17.2148 11.2301 16.6853 11 16.1309 11L11.6 11C10.4345 11 9.5 12.0013 9.5 13.25V26.75C9.5 27.9926 10.4402 29 11.6 29H28.4C29.5598 29 30.5 27.9926 30.5 26.75V15.5C30.5 14.2513 29.555 13.25 28.4 13.25Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * Right Icon
 *
 * @file Right.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Right = function Right(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M8.86377 18.6701L5.26967 14.8477C4.89151 14.4456 4.91067 13.8127 5.31247 13.4342C5.71426 13.0557 6.34654 13.0748 6.7247 13.477L9.49147 16.4195L17.1805 5.42479C17.4969 4.97234 18.1199 4.8623 18.5719 5.17902C19.0239 5.49573 19.1339 6.11926 18.8174 6.57171L10.4241 18.5735C10.1077 19.0259 9.48476 19.1359 9.03274 18.8192C8.96968 18.775 8.91328 18.7249 8.86377 18.6701Z',
        fill: 'currentcolor'
      })
    )
  );
};

var ScoreOutlined = function ScoreOutlined(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 18 18', fill: 'none' }, props),
    React.createElement(
      'defs',
      null,
      React.createElement('path', {
        id: 'ascr',
        d: 'M0 0h18v13.886H0z'
      })
    ),
    React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)'
      },
      React.createElement(
        'mask',
        { id: 'bscr' },
        React.createElement('use', { xlinkHref: '#ascr' })
      ),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M14.657 12.343a.257.257 0 0 1-.257.257h-2.571a.256.256 0\n        0 1-.257-.257v-10.8c0-.143.114-.258.257-.258H14.4c.142\n        0 .257.115.257.257v10.801zm-4.436 0c0 .142-.102.257-.23.257H7.687c-.127\n        0-.229-.115-.229-.257V4.628c0-.142.102-.257.229-.257h2.304c.128\n        0 .23.115.23.257v7.715zm-4.049 0c0 .142-.106.257-.237.257H3.579c-.131\n        0-.236-.115-.236-.257v-3.6c0-.143.105-.257.236-.257h2.356c.131\n        0 .237.114.237.257v3.6zm11.104.282h-1.028a.257.257\n        0 0 1-.257-.257L15.943.514A.515.515 0 0 0 15.428 0h-4.627a.514.514\n        0 0 0-.515.514v2.314a.257.257 0 0 1-.257.257H6.686a.515.515\n        0 0 0-.514.515v3.343a.258.258 0 0 1-.257.257H2.571a.514.514\n        0 0 0-.514.514v4.566a.257.257 0 0 1-.256.257H.771c-.425 0-.771.222-.771.647\n        0 .426.346.702.771.702h16.457c.425 0 .772-.206.772-.63 0-.427-.299-.63-.724-.63z'
      })
    )
  );
};

/**
 * Search icon
 *
 * @file Search.jsx
 * @author Sam George
 */
var Search = function Search(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M17.9097583,16.4457485 L22.6967936,21.2327838 C23.1010688,21.637059 23.1010688,22.2925185 22.6967936,22.6967936 C22.2925185,23.1010688 21.637059,23.1010688 21.2327838,22.6967936 L16.4457485,17.9097583 C14.8180853,19.2175068 12.7504232,20 10.5,20 C5.25329488,20 1,15.7467051 1,10.5 C1,5.25329488 5.25329488,1 10.5,1 C15.7467051,1 20,5.25329488 20,10.5 C20,12.7504232 19.2175068,14.8180853 17.9097583,16.4457485 L17.9097583,16.4457485 Z M10.5,17.9 C14.5869071,17.9 17.9,14.5869071 17.9,10.5 C17.9,6.41309285 14.5869071,3.1 10.5,3.1 C6.41309285,3.1 3.1,6.41309285 3.1,10.5 C3.1,14.5869071 6.41309285,17.9 10.5,17.9 Z'
      })
    )
  );
};

/**
 * Select Icon
 *
 * @file Select.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Select = function Select(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 17 18' }, props),
      React.createElement(
        'g',
        { fill: 'none' },
        React.createElement('path', {
          d: 'M8.49267 1.43579L7.15 1.43579C4.90979 1.43579 3.78968 1.43579 2.93404 1.87176C2.18139 2.25526 1.56947 2.86718 1.18597 3.61983C0.75 4.47548 0.75 5.59558 0.75 7.83579L0.75 10.5211C0.75 12.7613 0.75 13.8815 1.18597 14.7371C1.56947 15.4897 2.18139 16.1017 2.93404 16.4852C3.78968 16.9211 4.90979 16.9211 7.15 16.9211H9.83535C12.0756 16.9211 13.1957 16.9211 14.0513 16.4852C14.804 16.1017 15.4159 15.4897 15.7994 14.7371C16.2353 13.8815 16.2353 12.7613 16.2353 10.5211V9.17846',
          stroke: 'currentcolor',
          strokeWidth: '1.5',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }),
        React.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M7.91187 11.9588L5.08833 8.95592C4.79124 8.63997 4.8063 8.14278 5.12195 7.84541C5.4376 7.54805 5.93432 7.56311 6.23141 7.87906L8.40501 10.1907L14.4456 1.55318C14.6941 1.19773 15.1835 1.11128 15.5387 1.3601C15.8938 1.60891 15.9801 2.09876 15.7315 2.45421L9.1377 11.8829C8.88912 12.2383 8.39973 12.3248 8.04462 12.0759C7.99508 12.0412 7.95077 12.0018 7.91187 11.9588Z',
          fill: 'currentcolor'
        })
      )
    )
  );
};

var Settings = function Settings(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
    }, props),
    React.createElement('path', {
      d: 'M12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 C9.790861,8 8,9.790861 8,12 \n        C8,14.209139 9.790861,16 12,16 Z M12,18 C8.6862915,18 6,15.3137085 6,12 C6,8.6862915 8.6862915,6 12,6 \n        C15.3137085,6 18,8.6862915 18,12 C18,15.3137085 15.3137085,18 12,18 Z',
      fill: 'currentcolor',
      fillRule: 'nonzero'
    }),
    React.createElement('path', {
      d: 'M3.95528796,3.228 C4.15355233,3.04036364 4.46648851,3.04145455 4.66689628,3.22581818 C5.33885171,3.84436364 \n        6.35053582,3.98290909 7.17788765,3.49745455 C8.00523948,3.01090909 8.39426631,2.04654545 8.20136045,1.14436364 \n        C8.14348869,0.874909091 8.29781338,0.6 8.5571646,0.520363636 C9.64601105,0.182181818 10.8023746,0 12.0005343,0 \n        C13.1976224,0 14.3539859,0.182181818 15.4439041,0.520363636 C15.7021836,0.6 15.8565083,0.874909091 \n        15.7997082,1.14436364 C15.6068024,2.04654545 15.9947575,3.01090909 16.823181,3.49745455 C17.6494612,3.98290909 \n        18.6611453,3.84436364 19.3331007,3.22581818 C19.5335085,3.04145455 19.8475163,3.04036364 20.044709,3.228 \n        C21.7283486,4.82945455 22.9511574,6.92618182 23.487007,9.29127273 C23.5491656,9.56509091 23.3819805,9.83890909 \n        23.1204859,9.92618182 C22.2641982,10.212 21.6458277,11.0323636 21.6458277,12 C21.6458277,12.9676364 \n        22.2641982,13.788 23.1204859,14.0738182 C23.3819805,14.1610909 23.5491656,14.4349091 23.487007,14.7087273 \n        C22.9511574,17.0727273 21.7283486,19.1705455 20.044709,20.772 C19.8475163,20.9596364 19.5335085,20.9585455 \n        19.3331007,20.7741818 C18.6611453,20.1556364 17.6494612,20.0170909 16.823181,20.5025455 C15.9947575,20.9890909 \n        15.6068024,21.9534545 15.7997082,22.8556364 C15.8565083,23.124 15.7021836,23.4 15.4439041,23.4796364 \n        C14.3539859,23.8178182 13.1976224,24 12.0005343,24 C10.8023746,24 9.64601105,23.8178182 8.5571646,23.4796364 \n        C8.29781338,23.4 8.14348869,23.124 8.20136045,22.8556364 C8.39426631,21.9534545 8.00523948,20.9890909 \n        7.17788765,20.5025455 C6.35053582,20.0170909 5.33885171,20.1556364 4.66689628,20.7741818 \n        C4.46648851,20.9585455 4.15355233,20.9596364 3.95528796,20.772 C2.27164842,19.1705455 1.04883956,17.0727273 \n        0.51298993,14.7087273 C0.450831373,14.4349091 0.618016458,14.1610909 0.880582777,14.0738182 C1.73687049,13.788 \n        2.35524096,12.9676364 2.35524096,12 C2.35524096,11.0323636 1.73687049,10.212 0.880582777,9.92618182 \n        C0.618016458,9.83890909 0.450831373,9.56509091 0.51298993,9.29127273 C1.04883956,6.92618182 \n        2.27164842,4.82945455 3.95528796,3.228 Z M2.72289906,8.6910312 C3.70344377,9.46411738 4.31648127,10.6716004 \n        4.31648127,12 C4.31648127,13.3280196 3.70379443,14.5351918 2.72284206,15.3086045 C3.1290776,16.4877819 \n        3.75037089,17.577547 4.54986117,18.5222071 C5.69634127,18.0445316 7.02777923,18.1070294 8.1576521,18.7699911 \n        C9.28525031,19.4331042 10.0052265,20.5762278 10.1732485,21.8276552 C10.7704015,21.9418647 11.3812586,22 \n        12.0005343,22 C12.6188636,22 13.2292295,21.9419175 13.8271844,21.8275363 C13.9949771,20.5765354 \n        14.7150925,19.4326723 15.8441139,18.7695813 C16.9723039,18.1067492 18.303557,18.044366 19.4499271,18.5219926 \n        C20.250109,17.5763394 20.8711536,16.4869021 21.2772292,15.3082272 C20.297233,14.5351105 19.6845874,13.3279749 \n        19.6845874,12 C19.6845874,10.6719732 20.2972809,9.46479499 21.277371,8.69167314 C20.8714701,7.51309428 \n        20.2504815,6.42385262 19.4499157,5.47793045 C18.3034295,5.95563834 16.9723114,5.89325521 15.8443682,5.23056813 \n        C14.7144276,4.56693724 13.9940591,3.42198666 13.8263971,2.17221714 C13.2292468,2.05808415 12.6188723,2 \n        12.0005343,2 C11.3819103,2 10.7716873,2.05801301 10.173664,2.17243835 C10.0055786,3.42308748 \n        9.28516939,4.56694312 8.15600217,5.23097806 C7.02733272,5.89323285 5.69622991,5.95554047 4.55001591,5.47797838 \n        C3.74976695,6.42354124 3.12889458,7.51248929 2.72289906,8.6910312 Z',
      fill: 'currentcolor',
      fillRule: 'nonzero'
    })
  );
};

/**
 * Show-off outlined icon
 *
 * @file ShowOffOutlined.jsx
 * @author Sam George
 */
var ShowOffOutlined = function ShowOffOutlined(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        React.createElement('path', {
          fill: 'currentcolor',
          d: 'M3.70710678,2.29289322 L21.7383297,20.3241161 C22.128854,20.7146404 22.128854,21.3478054 21.7383297,21.7383297 C21.3478054,22.128854 20.7146404,22.128854 20.3241161,21.7383297 L17.3921578,18.8063714 C15.7516967,19.5694467 13.9251429,19.9951038 12,19.9951038 C6.63880713,19.9951038 2.04219905,16.694018 0.100000381,11.9975519 C1.07627271,9.63680994 2.72323617,7.62863952 4.80086741,6.21508097 L2.29289322,3.70710678 C1.90236893,3.31658249 1.90236893,2.68341751 2.29289322,2.29289322 C2.68341751,1.90236893 3.31658249,1.90236893 3.70710678,2.29289322 Z M6.2454306,7.65964416 C4.58500506,8.70372256 3.21038639,10.1942444 2.2987767,11.9975519 C4.13574904,15.6313724 7.85280338,17.9951038 12,17.9951038 C13.3510643,17.9951038 14.6564772,17.7442383 15.8661066,17.2803202 L14.7573899,16.1716035 C13.9669569,16.6951232 13.0190823,17 12,17 C9.23857625,17 7,14.7614237 7,12 C7,10.9809177 7.30487676,10.0330431 7.82839654,9.2426101 L6.2454306,7.65964416 Z M12,4 C17.3611929,4 21.9578009,7.30108581 23.8999996,11.9975519 C23.1818921,13.7340207 22.1009076,15.2797308 20.7525693,16.5383565 L19.3384867,15.1242739 C20.2941719,14.2443439 21.0987971,13.1892457 21.7012233,11.9975519 C19.864251,8.36373136 16.1471966,6 12,6 C11.4381218,6 10.8841392,6.04338837 10.3416581,6.12744529 L8.65598048,4.44176768 C9.72242002,4.15363382 10.843418,4 12,4 Z M9.29237099,10.7065845 C9.10495216,11.0982198 9,11.5368535 9,12 C9,13.6568542 10.3431458,15 12,15 C12.4631465,15 12.9017802,14.8950478 13.2934155,14.707629 L9.29237099,10.7065845 Z M12,7 C14.7614237,7 17,9.23857625 17,12 C17,12.2488343 16.9818228,12.4934232 16.9467239,12.7325111 L11.2674889,7.05327613 C11.5065768,7.01817717 11.7511657,7 12,7 Z'
        })
      )
    )
  );
};

/**
 * Show-on outlined icon
 *
 * @file ShowOnOutlined.jsx
 * @author Sam George
 */
var ShowOnOutlined = function ShowOnOutlined(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        React.createElement('path', {
          fill: 'currentcolor',
          d: 'M12,4 C17.3611929,4 21.9578009,7.30108581 23.8999996,11.9975519 C21.9578009,16.694018 17.3611929,19.9951038 12,19.9951038 C6.63880713,19.9951038 2.04219905,16.694018 0.100000381,11.9975519 C2.04219905,7.30108581 6.63880713,4 12,4 Z M12,6 C7.85280338,6 4.13574904,8.36373136 2.2987767,11.9975519 C4.13574904,15.6313724 7.85280338,17.9951038 12,17.9951038 C16.1471966,17.9951038 19.864251,15.6313724 21.7012233,11.9975519 C19.864251,8.36373136 16.1471966,6 12,6 Z M12,7 C14.7614237,7 17,9.23857625 17,12 C17,14.7614237 14.7614237,17 12,17 C9.23857625,17 7,14.7614237 7,12 C7,9.23857625 9.23857625,7 12,7 Z M12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 Z'
        })
      )
    )
  );
};

/**
 * Single page icon
 *
 * @file SinglePage.jsx
 * @author Sam George
 */
var SinglePage = function SinglePage(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M14.172 3c.217 0 .426.086.579.24l3.612 3.611c.153.154.24.362.24.579v11.525c0 1.13-.917 2.045-2.046 2.045H8.045C6.915 21 6 20.084 6 18.955V5.045C6 3.915 6.916 3 8.045 3h6.127zm-.479 1.636H8.045c-.2 0-.367.145-.402.336l-.007.073v13.91c0 .2.145.367.336.402l.073.007h8.512c.2 0 .368-.145.402-.336l.007-.073V7.909H14.51c-.42 0-.765-.316-.812-.723l-.006-.095V4.636z'
      })
    )
  );
};

/**
 * Skill icon
 *
 * @author Arish Kumar K
 */
var Skill = function Skill(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 12 8' }, props),
    React.createElement('path', { d: 'M11.7867 0.861667C11.7275 0.719129 11.6142 0.60586 11.4717 0.546667C11.4016 0.516776 11.3263 0.500922 11.25 0.5H8.33338C8.17867 0.5 8.0303 0.561458 7.9209 0.670854C7.8115 0.780251 7.75005 0.928624 7.75005 1.08333C7.75005 1.23804 7.8115 1.38642 7.9209 1.49581C8.0303 1.60521 8.17867 1.66667 8.33338 1.66667H9.84421L6.58338 4.9275L4.66421 3.0025C4.60998 2.94782 4.54547 2.90443 4.47438 2.87481C4.4033 2.8452 4.32705 2.82995 4.25005 2.82995C4.17304 2.82995 4.09679 2.8452 4.02571 2.87481C3.95462 2.90443 3.89011 2.94782 3.83588 3.0025L0.335879 6.5025C0.281204 6.55673 0.237808 6.62124 0.208192 6.69233C0.178577 6.76341 0.16333 6.83966 0.16333 6.91667C0.16333 6.99367 0.178577 7.06992 0.208192 7.141C0.237808 7.21209 0.281204 7.2766 0.335879 7.33083C0.390107 7.38551 0.454625 7.4289 0.525709 7.45852C0.596794 7.48813 0.673039 7.50338 0.750046 7.50338C0.827053 7.50338 0.903297 7.48813 0.974382 7.45852C1.04547 7.4289 1.10998 7.38551 1.16421 7.33083L4.25005 4.23917L6.16921 6.16417C6.22344 6.21884 6.28796 6.26224 6.35904 6.29185C6.43013 6.32147 6.50637 6.33671 6.58338 6.33671C6.66039 6.33671 6.73663 6.32147 6.80772 6.29185C6.8788 6.26224 6.94332 6.21884 6.99755 6.16417L10.6667 2.48917V4C10.6667 4.15471 10.7282 4.30308 10.8376 4.41248C10.947 4.52187 11.0953 4.58333 11.25 4.58333C11.4048 4.58333 11.5531 4.52187 11.6625 4.41248C11.7719 4.30308 11.8334 4.15471 11.8334 4V1.08333C11.8325 1.0071 11.8166 0.931796 11.7867 0.861667Z', fill: 'black' })
  );
};

var SmallCircleFilledIcon = function SmallCircleFilledIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 18'
    }, props),
    React.createElement('circle', { cx: '9', cy: '9', r: '4', fill: 'currentcolor', stroke: 'currentcolor', strokeWidth: '1.5' })
  );
};

var SmallCircleHalfFilledIcon = function SmallCircleHalfFilledIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 18'
    }, props),
    React.createElement('path', {
      stroke: 'currentcolor',
      fill: 'currentcolor',
      fillRule: 'evenodd',
      d: 'M9 13V5a4 4 0 1 0 0 8z M 5, 9 a 4,4 0 1,0 8,0 a 4,4 0 1,0 -8,0',
      transform: 'scale(-1,1) translate(-18,0)'
    })
  );
};

var SmallCircleOutlineIcon = function SmallCircleOutlineIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 18'
    }, props),
    React.createElement('circle', { cx: '9', cy: '9', r: '4', stroke: 'currentcolor', strokeWidth: '1.5', fill: 'none' })
  );
};

/**
 * Social Icon
 *
 * @file Social.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Social = function Social(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 23' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M21.0003 -1.83588e-06C22.6571 -1.98073e-06 24.0003 1.34314 24.0003 3L24.0003 14C24.0003 15.6569 22.6571 17 21.0003 17L12.5508 17L7.76208 22.6313C7.4043 23.052 6.77319 23.1031 6.35246 22.7453C6.12903 22.5553 6.00028 22.2768 6.00028 21.9835L6.00028 17L3.00028 17C1.34342 17 0.000276027 15.6569 0.000275882 14L0.00027492 3C0.000274776 1.34315 1.34342 -1.17422e-07 3.00027 -2.62268e-07L21.0003 -1.83588e-06ZM21.0003 2L3.00027 2C2.44799 2 2.00027 2.44772 2.00027 3L2.00028 14C2.00028 14.5523 2.44799 15 3.00028 15L8.00028 15L8.00028 19.2639L11.6262 15L21.0003 15C21.5526 15 22.0003 14.5523 22.0003 14L22.0003 3C22.0003 2.44771 21.5526 2 21.0003 2Z',
        fill: 'currentcolor'
      })
    )
  );
};

var Sortable = function Sortable(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 24 24'
    }, props),
    React.createElement('path', {
      d: 'M12,17.5455844 L15.2526912,14.2928932 C15.6432155,13.9023689 16.2763805,13.9023689 16.6669048,14.2928932 C17.057429,14.6834175 17.057429,15.3165825 16.6669048,15.7071068 L12.7071068,19.6669048 C12.3165825,20.057429 11.6834175,20.057429 11.2928932,19.6669048 L7.33309524,15.7071068 C6.94257095,15.3165825 6.94257095,14.6834175 7.33309524,14.2928932 C7.72361954,13.9023689 8.35678451,13.9023689 8.74730881,14.2928932 L12,17.5455844 Z',
      fill: 'currentcolor',
      fillRule: 'nonzero'
    }),
    React.createElement('path', {
      d: 'M12,6.41421356 L8.74730881,9.66690476 C8.35678451,10.057429 7.72361954,10.057429 7.33309524,9.66690476 C6.94257095,9.27638046 6.94257095,8.64321549 7.33309524,8.25269119 L11.2928932,4.29289322 C11.6834175,3.90236893 12.3165825,3.90236893 12.7071068,4.29289322 L16.6669048,8.25269119 C17.057429,8.64321549 17.057429,9.27638046 16.6669048,9.66690476 C16.2763805,10.057429 15.6432155,10.057429 15.2526912,9.66690476 L12,6.41421356 Z',
      fill: 'currentcolor',
      fillRule: 'nonzero'
    })
  );
};

/**
 * SparkLab Icon
 *
 * @file SparkLab.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var SparkLab = function SparkLab(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement(
        'g',
        { fill: 'none' },
        React.createElement('path', {
          d: 'M6.4447 1.74561V5.94979C6.4447 6.28498 6.3647 6.62016 6.2247 6.9362L3.0547 13.8219C2.7347 14.521 2.8647 15.3254 3.3947 15.8904L3.6847 16.1969C4.0647 16.6087 4.6147 16.8385 5.1847 16.8385H12.8147C13.6047 16.8385 14.3347 16.465 14.7747 15.8426C15.1647 15.2967 15.2247 14.588 14.9447 13.9847L11.8747 7.30011C11.6247 6.75424 11.4947 6.16048 11.4947 5.55715V1.74561H6.4447Z',
          stroke: 'currentcolor',
          strokeWidth: '1.75',
          strokeMiterlimit: '10'
        }),
        React.createElement('path', {
          d: 'M12.6347 1.16162H5.3647C5.0847 1.16162 4.8647 1.37231 4.8647 1.64046C4.8647 1.90861 5.0847 2.11929 5.3647 2.11929H12.6247C12.9047 2.11929 13.1247 1.90861 13.1247 1.64046C13.1347 1.37231 12.9047 1.16162 12.6347 1.16162Z',
          fill: 'currentcolor',
          stroke: 'currentcolor',
          strokeMiterlimit: '10'
        }),
        React.createElement('path', {
          d: 'M6 9.34131C6.35521 9.61844 6.89462 9.94549 7.54585 10.0315C8.70879 10.175 9.27522 9.41707 10.3345 9.22404C10.9615 9.111 11.866 9.17287 13.0404 9.99897',
          stroke: 'currentcolor',
          strokeWidth: '1.75',
          strokeMiterlimit: '10',
          strokeLinecap: 'round'
        }),
        React.createElement('circle', { cx: '10.6336', cy: '12.3171', r: '0.925', fill: 'currentcolor' }),
        React.createElement('circle', { cx: '7.52161', cy: '13.8496', r: '1.25', fill: 'currentcolor' })
      )
    )
  );
};

var StarFilledIcon = function StarFilledIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 18'
    }, props),
    React.createElement('path', {
      fill: 'currentcolor',
      fillRule: 'nonzero',
      stroke: 'currentcolor',
      strokeWidth: '1.5',
      d: 'M6.635 5.108l-4.684.725a.5.5 0 0 0-.284.841l3.42 3.554-.764 4.75a.5.5 0 0 0 .738.516L9 13.288l3.938 \n        2.206a.5.5 0 0 0 .738-.515l-.764-4.75 3.42-3.555a.5.5 0 0 0-.283-.84l-4.684-.726L9.454.98a.5.5 \n        0 0 0-.908 0l-1.91 4.128z'
    })
  );
};

var StarHalfFilledIcon = function StarHalfFilledIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 17'
    }, props),
    React.createElement('path', {
      fillRule: 'evenodd',
      stroke: 'currentcolor',
      fill: 'currentcolor',
      strokeWidth: '1.5',
      d: 'M6.635 5.108l-4.684.725a.5.5 0 0 0-.284.841l3.42 3.554-.764 4.75a.5.5 0 0 0 .738.516L9 13.288V2.27a.5.5 \n        0 0 0-.954-.21l-1.41 3.048z M6.635 5.108l-4.684.725a.5.5 0 0 0-.284.841l3.42 3.554-.764 4.75a.5.5 0 0 0 \n        .738.516L9 13.288l3.938 2.206a.5.5 0 0 0 .738-.515l-.764-4.75 3.42-3.555a.5.5 0 0 \n        0-.283-.84l-4.684-.726L9.454.98a.5.5 0 0 0-.908 0l-1.91 4.128z',
      transform: 'scale(-1,1) translate(-18,0)'
    })
  );
};

var StarOutlineIcon = function StarOutlineIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      viewBox: '0 0 18 17'
    }, props),
    React.createElement('path', {
      stroke: 'currentcolor',
      fill: 'none',
      strokeWidth: '1.5',
      d: 'M6.635 5.108l-4.684.725a.5.5 0 0 0-.284.841l3.42 3.554-.764 4.75a.5.5 0 0 0 .738.516L9 13.288l3.938\n        2.206a.5.5 0 0 0 .738-.515l-.764-4.75 3.42-3.555a.5.5 0 0 0-.283-.84l-4.684-.726L9.454.98a.5.5 0 0 \n        0-.908 0l-1.91 4.128z'
    })
  );
};

/**
 * Study Icon
 *
 * @file Study.jsx
 * @author Nivedhitha M
 */
var Study = function Study(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 23 23', fill: 'none' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M19.5412 2.73762L14.7618 1.92041C14.123 1.09088 13.1089 0.555268 11.9696 0.557441L4.01903 0.5726C2.09797 0.576262 0.548577 2.10759 0.558358 3.99292L0.624132 16.6723C0.633912 18.5576 2.19917 20.083 4.12022 20.0794L6.98975 20.0739C7.38762 20.3396 7.84802 20.5284 8.35251 20.6146L16.1893 21.9546C18.0829 22.2784 19.8806 21.0352 20.2045 19.1779L22.3832 6.68684C22.7072 4.82953 21.4348 3.0614 19.5412 2.73762ZM13.4781 3.96828L13.5438 16.6477C13.548 17.4557 12.884 18.112 12.0607 18.1135L4.1101 18.1287C3.28679 18.1303 2.61597 17.4765 2.61178 16.6685L2.546 3.98913C2.54181 3.18113 3.20584 2.52485 4.02915 2.52328L11.9797 2.50812C12.8031 2.50655 13.4739 3.16029 13.4781 3.96828ZM20.424 6.35185L18.2453 18.8429C18.1065 19.6389 17.3361 20.1717 16.5245 20.0329L13.8552 19.5765C14.8654 18.9779 15.5379 17.888 15.5315 16.6439L15.466 4.01983L19.206 4.65932C20.0175 4.79808 20.5629 5.55585 20.424 6.35185ZM10.2499 10.6731C10.8022 10.6707 11.2518 11.1165 11.2542 11.6688C11.2565 12.2211 10.8107 12.6707 10.2585 12.6731L5.7585 12.6922C5.20622 12.6945 4.7566 12.2487 4.75425 11.6965C4.7519 11.1442 5.19771 10.6946 5.74999 10.6922L10.2499 10.6731ZM11.5042 8.24926C11.5018 7.69698 11.1082 7.25093 10.6249 7.25299L5.37499 7.27532C4.89175 7.27738 4.5019 7.72676 4.50425 8.27904C4.5066 8.83132 4.90025 9.27736 5.3835 9.27531L10.6335 9.25297C11.1167 9.25091 11.5065 8.80154 11.5042 8.24926Z',
        fill: 'currentcolor'
      })
    )
  );
};

/* eslint-disable max-len */

var StudyIcon = function StudyIcon(props) {
  return React.createElement(
    SvgIcon,
    _extends({
      width: '24',
      height: '28',
      viewBox: '0 0 24 28',
      fill: 'none'
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, props),
    React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M20.6887 3.67486L15.5271 2.78954C14.8372 1.89088 13.742 1.31064 12.5115 1.313L3.92503 1.32942C1.85031 1.33339 0.176987 2.99232 0.18755 5.03476L0.258585 18.7708C0.269147 20.8132 1.9596 22.4657 4.03431 22.4617L7.13336 22.4558C7.53526 22.725 7.99624 22.9213 8.5 23.0221V25.626C8.5 26.7305 9.39543 27.626 10.5 27.626H20.5C21.6046 27.626 22.5 26.7305 22.5 25.626V16.626C22.5 16.3781 22.4549 16.1408 22.3725 15.9218L23.7581 7.95318C24.108 5.94109 22.7338 4.02562 20.6887 3.67486ZM8.5 16.626V20.3399L4.02338 20.3485C3.13422 20.3502 2.40974 19.642 2.40521 18.7667L2.33418 5.03065C2.32965 4.15532 3.04679 3.44435 3.93595 3.44265L12.5225 3.42623C13.4116 3.42453 14.1361 4.13274 14.1406 5.00807L14.1904 14.626H10.5C9.39543 14.626 8.5 15.5214 8.5 16.626ZM20.4188 14.626H16.337L16.2876 5.06391L20.3267 5.7567C21.2032 5.90702 21.7921 6.72794 21.6422 7.59027L20.4188 14.626ZM11.0592 8.5665C11.5811 8.56428 12.0062 9.04749 12.0088 9.64579C12.0113 10.2441 11.5903 10.7309 11.0684 10.7331L5.39852 10.7573C4.87662 10.7596 4.45148 10.2764 4.44894 9.67806C4.44641 9.07975 4.86743 8.59293 5.38933 8.5907L11.0592 8.5665ZM10.6542 12.2718C11.2507 12.2692 11.7362 12.7522 11.7388 13.3505C11.7413 13.9488 11.2599 14.4359 10.6634 14.4384L5.80351 14.4592C5.20706 14.4617 4.72148 13.9788 4.71894 13.3804C4.7164 12.7821 5.19787 12.2951 5.79432 12.2925L10.6542 12.2718ZM20.5 16.626H10.5V25.626H20.5V16.626ZM18.5087 21.1078L13.7051 18.3711V23.8445L18.5087 21.1078Z',
      fill: 'currentColor'
    })
  );
};

/**
 * Renders Text File Icon.
 *
 * @author Hari Gangadharan
 */
var Text = function Text(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 35 42' }, props),
    React.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M32.5 38.719c0 .356-.286.656-.625.656H3.125c-.339 0-.625-.3-.625-.656V3.28c0-.355.286-.656.625-.656h18.' + '75c.189 0 .4.025.625.07v10.43h9.934c.042.236.066.458.066.656V38.72zm-1.477-28.683c.122.128.244.286.362.' + '464H25V3.796c.17.124.32.252.442.38l5.58 5.86zM32.79 8.18l-5.58-5.86C25.994 1.044 23.594 0 21.875 0H3.125C1' + '.406 0 0 1.477 0 3.281V38.72C0 40.523 1.406 42 3.125 42h28.75C33.594 42 35 40.523 35 38.719V13.78c0-1.804' + '-.994-4.325-2.21-5.601z'
      }),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M1 30h32v10H1z M14.337 33.496h-2.093v6.306h-1.739v-6.306H8.447v-1.478h5.89v1.478zM19.5 39.802l-.694-1' + '.41c-.284-.542-.466-.946-.682-1.397H18.1c-.16.45-.352.855-.591 1.398l-.637 1.409h-1.979l2.218-3.939-2' + '.138-3.845h1.99l.671 1.42c.227.473.398.855.58 1.294h.023c.181-.497.33-.843.522-1.294l.649-1.42h1' + '.979l-2.161 3.799 2.274 3.985H19.5zM27.813 33.496H25.72v6.306h-1.74v-6.306h-2.059v-1.478h5.89v1.478z'
      }),
      React.createElement('path', {
        fill: 'currentcolor',
        fillRule: 'nonzero',
        stroke: 'currentcolor',
        d: 'M9.536 12h8.927c.296 0 .537-.224.537-.5s-.241-.5-.537-.5H9.536c-.296 0-.536.224-.536.5s.24.5.536.5zM24.454 \n          16H9.545c-.3 0-.545.224-.545.5s.244.5.545.5h14.909c.301 0 .546-.224.546-.5 0-.277-.245-.5-.546-.5zM24.454 \n          21H9.545c-.3 0-.545.223-.545.5 0 .276.244.5.545.5h14.909c.301 0 \n          .546-.224.546-.5 0-.277-.245-.5-.546-.5zM24.454 26H9.545c-.3 0-.545.224-.545.5 0 \n          .277.244.5.545.5h14.909c.301 0 .546-.224.546-.5s-.245-.5-.546-.5z'
      })
    )
  );
};

/**
 * An icon for Upload
 *
 * @author Praveen Punniyamoorthi
 */
var Upload = function Upload(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        d: 'M22,15 C22.5522847,15 23,15.4477153 23,16 L23,20 C23,21.6568542 21.6568542,23\n      20,23 L4,23 C2.34314575,23 1,21.6568542 1,20 L1,16 C1,15.4477153 1.44771525,15 2,\n      15 C2.55228475,15 3,15.4477153 3,16 L3,20 C3,20.5522847 3.44771525,21 4,21 L20,21\n      C20.5522847,21 21,20.5522847 21,20 L21,16 C21,15.4477153 21.4477153,15 22,15 Z M12,\n      0 C12.2559223,0 12.5118446,0.0976310729 12.7071068,0.292893219\n      L17.7071068,5.29289322 C18.0976311,5.68341751 18.0976311,6.31658249\n      17.7071068,6.70710678 C17.3165825,7.09763107 16.6834175,7.09763107\n      16.2928932,6.70710678 L13,3.41421356 L13,15 C13,15.5522847\n      12.5522847,16 12,16 C11.4477153,16 11,15.5522847 11,15 L11,3.41421356\n      L7.70710678,6.70710678 C7.31658249,7.09763107 6.68341751,7.09763107\n      6.29289322,6.70710678 C5.90236893,6.31658249 5.90236893,5.68341751\n      6.29289322,5.29289322 L11.2928932,0.292893219 C11.4881554,0.0976310729\n      11.7440777,0 12,0 Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * Video Icon
 *
 * @file Video.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var Video = function Video(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M3.12 2H14.88C16.0508 2 17 2.94916 17 4.12V13.88C17 15.0508 16.0508 16 14.88 16H3.12C1.94916 16 1 15.0508 1 13.88V4.12C1 2.94916 1.94916 2 3.12 2ZM3.12 3.75C2.91565 3.75 2.75 3.91565 2.75 4.12V13.88C2.75 14.0843 2.91565 14.25 3.12 14.25H14.88C15.0843 14.25 15.25 14.0843 15.25 13.88V4.12C15.25 3.91565 15.0843 3.75 14.88 3.75H3.12ZM7.05889 6.50609C7.02038 6.56897 7 6.64127 7 6.715V11.2852C7 11.5061 7.17909 11.6852 7.4 11.6852C7.47373 11.6852 7.54603 11.6648 7.60891 11.6263L11.0616 9.51176C11.3442 9.3387 11.433 8.96932 11.2599 8.68673C11.2104 8.60589 11.1425 8.53793 11.0616 8.48842L7.60891 6.37389C7.42052 6.25851 7.17426 6.3177 7.05889 6.50609Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * Warning icon for alert
 *
 * @author Arish Kumar K
 */
var Warning = function Warning(props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 24 24' }, props),
    React.createElement('path', { fill: 'currentcolor', d: 'M13.559459,1.91844891 L23.7769385,20.3590868 C24.2534332,21.2190706 23.9414416,22.3018852 23.0800857,22.7776209 C22.8159921,22.9234825 22.5191252,23 22.2173157,23 L1.78235667,23 C0.797988264,23 -1.11022302e-14,22.2032829 -1.11022302e-14,21.2204825 C-1.11022302e-14,20.9191537 0.076639574,20.6227597 0.222733909,20.3590868 L10.4402134,1.91844891 C10.9167082,1.05846511 12.0012504,0.746970493 12.8626062,1.22270621 C13.1557674,1.38462214 13.3972847,1.62575473 13.559459,1.91844891 Z M11.5,9 C11.2238576,9 11,9.22385763 11,9.5 L11,15.5 C11,15.7761424 11.2238576,16 11.5,16 L12.5,16 C12.7761424,16 13,15.7761424 13,15.5 L13,9.5 C13,9.22385763 12.7761424,9 12.5,9 L11.5,9 Z M11.5,18 C11.2238576,18 11,18.2238576 11,18.5 L11,19.5 C11,19.7761424 11.2238576,20 11.5,20 L12.5,20 C12.7761424,20 13,19.7761424 13,19.5 L13,18.5 C13,18.2238576 12.7761424,18 12.5,18 L11.5,18 Z' })
  );
};

/**
 * Web Links Icon
 *
 * @file WebLinks.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var WebLinks = function WebLinks(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement(
        'g',
        { fill: 'none' },
        React.createElement('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0ZM9 12.25C8.40831 12.25 7.83674 12.2789 7.29185 12.3321C7.45542 13.217 7.68322 14.0177 7.96373 14.6909C8.42068 15.7875 8.87625 16.25 9 16.25C9.12375 16.25 9.57932 15.7875 10.0363 14.6909C10.3168 14.0177 10.5446 13.217 10.7082 12.3309C10.1633 12.2789 9.59169 12.25 9 12.25ZM12.4402 12.5875C12.2127 13.8421 11.8694 14.9482 11.4426 15.8283C12.6599 15.3928 13.7267 14.641 14.5442 13.6719L14.7433 13.4252L14.8272 13.3143C14.1984 13.0363 13.3857 12.7788 12.4402 12.5875ZM5.56027 12.5867C4.61429 12.7788 3.80163 13.0364 3.17321 13.3149C4.01994 14.4564 5.19412 15.3404 6.55672 15.8277C6.13028 14.9479 5.78719 13.842 5.56027 12.5867ZM2.31808 6.17972L2.23246 6.394C1.92083 7.20274 1.75 8.08142 1.75 9C1.75 10.0006 1.95268 10.9538 2.31808 11.8203C3.15282 11.4094 4.17673 11.0759 5.32914 10.8481C5.27727 10.2516 5.25 9.63344 5.25 9C5.25 8.3668 5.27725 7.74888 5.32877 7.15317C4.32073 6.95276 3.4108 6.67236 2.63986 6.33012L2.31808 6.17972ZM15.6818 6.17976C14.8471 6.59062 13.8233 6.92412 12.6709 7.15258C12.7228 7.74885 12.75 8.36679 12.75 9C12.75 9.63344 12.7227 10.2516 12.6713 10.8469C13.8233 11.0759 14.8471 11.4094 15.6808 11.8208C16.0473 10.9538 16.25 10.0006 16.25 9C16.25 7.99944 16.0473 7.04623 15.6818 6.17976ZM10.936 7.40608L10.6555 7.43248C10.1189 7.47682 9.56552 7.5 9 7.5C8.33509 7.5 7.68703 7.46795 7.06403 7.40608C7.02192 7.92334 7 8.45681 7 9C7 9.54319 7.02192 10.0767 7.06319 10.5929C7.68703 10.532 8.33509 10.5 9 10.5C9.66473 10.5 10.3126 10.532 10.936 10.5939C10.9781 10.0767 11 9.54319 11 9C11 8.63787 10.9903 8.28007 10.9713 7.9285L10.936 7.40608ZM9 1.75C8.87625 1.75 8.42068 2.21246 7.96373 3.30912C7.68322 3.98234 7.45542 4.78302 7.29177 5.66906C7.83674 5.7211 8.40831 5.75 9 5.75C9.59169 5.75 10.1633 5.7211 10.7081 5.66794C10.5446 4.78302 10.3168 3.98234 10.0363 3.30912C9.57932 2.21246 9.12375 1.75 9 1.75ZM11.4426 2.17175L11.6041 2.52394C11.9561 3.33945 12.2418 4.31875 12.4397 5.41333C13.3857 5.22121 14.1984 4.96365 14.8263 4.68458C14.04 3.62472 12.9714 2.78687 11.7317 2.28224L11.4426 2.17175ZM6.5569 2.17191L6.25165 2.28906C5.01897 2.79441 3.95639 3.62951 3.17375 4.68614C3.80248 4.96392 4.61478 5.22131 5.55987 5.4119C5.76207 4.29682 6.05563 3.29917 6.41788 2.47341L6.5569 2.17191Z',
          fill: 'currentcolor'
        })
      )
    )
  );
};

/**
 * Zipped Files Icon
 *
 * @file ZippedFiles.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

var ZippedFiles = function ZippedFiles(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 18 18' }, props),
      React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M6 1C6.62951 1 7.22229 1.29639 7.6 1.8L8.5 3H15C16.1046 3 17 3.89543 17 5V16C17 16.5523 16.5523 17 16 17H2C1.44772 17 1 16.5523 1 16V3C1 1.89543 1.89543 1 3 1H6ZM6 2.75H3C2.86193 2.75 2.75 2.86193 2.75 3V15.25H15.25V5C15.25 4.86193 15.1381 4.75 15 4.75H7.625L6.2 2.85C6.15279 2.78705 6.07869 2.75 6 2.75ZM9 6C9.55229 6 10 6.44772 10 7V9H12C12.5523 9 13 9.44771 13 10C13 10.5523 12.5523 11 12 11H10V13C10 13.5523 9.55229 14 9 14C8.44772 14 8 13.5523 8 13V11H6C5.44772 11 5 10.5523 5 10C5 9.44771 5.44772 9 6 9H8V7C8 6.44772 8.44772 6 9 6Z',
        fill: 'currentcolor'
      })
    )
  );
};

/**
 * Zoom in icon
 *
 * @file ZoomIn.jsx
 * @author Sam George
 */
var ZoomIn = function ZoomIn(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M11,1.5 C16.2467051,1.5 20.5,5.75329488 20.5,11 C20.5,13.2450781 19.7212194,15.3082623 18.4190676,16.9341433 L22.7424621,21.2575379 C23.1525126,21.6675884 23.1525126,22.3324116 22.7424621,22.7424621 C22.3324116,23.1525126 21.6675884,23.1525126 21.2575379,22.7424621 L16.9341433,18.4190676 C15.3082623,19.7212194 13.2450781,20.5 11,20.5 C5.75329488,20.5 1.5,16.2467051 1.5,11 C1.5,5.75329488 5.75329488,1.5 11,1.5 Z M11,3.6 C6.91309285,3.6 3.6,6.91309285 3.6,11 C3.6,15.0869071 6.91309285,18.4 11,18.4 C15.0869071,18.4 18.4,15.0869071 18.4,11 C18.4,6.91309285 15.0869071,3.6 11,3.6 Z M11,6 C11.5522847,6 12,6.44771525 12,7 L12,10 L15,10 C15.5522847,10 16,10.4477153 16,11 C16,11.5522847 15.5522847,12 15,12 L12,12 L12,15 C12,15.5522847 11.5522847,16 11,16 C10.4477153,16 10,15.5522847 10,15 L10,12 L7,12 C6.44771525,12 6,11.5522847 6,11 C6,10.4477153 6.44771525,10 7,10 L10,10 L10,7 C10,6.44771525 10.4477153,6 11,6 Z'
      })
    )
  );
};

/**
 * Zoom out icon
 *
 * @file ZoomOut.jsx
 * @author Sam George
 */
var ZoomOut = function ZoomOut(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(
      SvgIcon,
      _extends({ viewBox: '0 0 24 24' }, props),
      React.createElement('path', {
        fill: 'currentcolor',
        d: 'M11,1.5 C16.2467051,1.5 20.5,5.75329488 20.5,11 C20.5,13.2450781 19.7212194,15.3082623 18.4190676,16.9341433 L22.7424621,21.2575379 C23.1525126,21.6675884 23.1525126,22.3324116 22.7424621,22.7424621 C22.3324116,23.1525126 21.6675884,23.1525126 21.2575379,22.7424621 L16.9341433,18.4190676 C15.3082623,19.7212194 13.2450781,20.5 11,20.5 C5.75329488,20.5 1.5,16.2467051 1.5,11 C1.5,5.75329488 5.75329488,1.5 11,1.5 Z M11,3.6 C6.91309285,3.6 3.6,6.91309285 3.6,11 C3.6,15.0869071 6.91309285,18.4 11,18.4 C15.0869071,18.4 18.4,15.0869071 18.4,11 C18.4,6.91309285 15.0869071,3.6 11,3.6 Z M15,10 C15.5522847,10 16,10.4477153 16,11 C16,11.5522847 15.5522847,12 15,12 L7,12 C6.44771525,12 6,11.5522847 6,11 C6,10.4477153 6.44771525,10 7,10 L15,10 Z'
      })
    )
  );
};

/**
 * A Map containing all Icons
 * @author Hari Gangadharan
 */
var icons = new Map([['AccountOutlined', AccountOutlined], ['Activities', Activities], ['Add', AddIcon], ['AddCircleOutlined', AddCircleOutlinedIcon], ['Archive', ArchiveIcon], ['ArrowBack', ArrowBack], ['Audio', Audio], ['BellFilled', BellFilled], ['BlankCalendarOutlined', BlankCalendarOutlined], ['BookFilled', BookFilled], ['BookHalfFilled', BookHalfFilled], ['BookmarkOutlined', BookmarkOutlined], ['BookmarkFilled', BookmarkFilled], ['BookOutlined', BookOutlined], ['CalendarOutlined', CalendarOutlined], ['CardView', CardView], ['CaretDown', CaretDown], ['CaretUp', CaretUp], ['CheckCircleFilled', CheckCircleFilled], ['ChevronDown', ChevronDown], ['ChevronLeft', ChevronLeftIcon], ['ChevronRight', ChevronRightIcon], ['ChevronUp', ChevronUp], ['CircleOutline', CircleOutline], ['CircleInprogressOutline', CircleInprogressOutline], ['CircleNotStartedOutline', CircleNotStartedOutline], ['ClockOutlined', ClockOutlined], ['Close', Close], ['Copy', Copy], ['Collapse', CollapseIcon], ['CollapseControl', CollapseControl], ['CollapseMojo', CollapseMojo], ['CollapseMojoAudio', CollapseMojoAudio], ['Correct', Correct], ['Delete', Delete], ['Descending', Descending], ['Document', Document], ['DoublePage', DoublePage], ['Download', Download], ['Downloading', Downloading], ['DrawerClose', DrawerClose], ['DrawerLeft', DrawerLeft], ['Expand', ExpandIcon], ['ExpandControl', ExpandControl], ['ExpandMojo', ExpandMojo], ['ExpandMojoAudio', ExpandMojoAudio], ['Edit', Edit], ['Email', Email], ['Figure', Figure], ['Filter', FilterIcon], ['FilterOptions', FilterOptions], ['FlagOutlined', FlagOutlined], ['FlashcardOutlined', FlashcardOutlined], ['Folder', Folder], ['Font', Font], ['FontChange', FontChange], ['FullscreenOff', FullscreenOff], ['FullscreenOn', FullscreenOn], ['Globe', Globe], ['Grid', Grid], ['Home', Home], ['HelpFilled', HelpFilled], ['HelpOutlined', HelpOutlined], ['Image', Image], ['Information', Information], ['KeyTakeaway', KeyTakeaway], ['LaunchOutlined', LaunchOutlined], ['LineSpacingDefault', LineSpacingDefault], ['LineSpacingWide', LineSpacingWide], ['LineSpacingWider', LineSpacingWider], ['Links', Links], ['ListBulleted', ListBulleted], ['Listen', Listen], ['ListView', ListView], ['Lock', LockIcon], ['LockOnOutlined', LockOnOutlined], ['Menu', MenuIcon], ['MessageOutlined', MessageOutlined], ['Misc', Misc], ['MoreVert', MoreVert], ['Navigation', Navigation], ['NewPreference', NewPreference], ['Notebook', Notebook], ['Notes', Notes], ['PearsonLogoMojo', PearsonLogoMojo], ['Pause', Pause], ['Pdf', Pdf], ['PearsonLogo', PearsonLogo], ['Play', Play], ['Preview', Preview], ['PunchHoleLock', PunchHoleLock], ['Quizzes', Quizzes], ['Remove', Remove], ['RemoveCircleOutlined', RemoveCircleOutlined], ['ResourcesNav', ResourcesNav], ['ResourcesNavFilled', ResourcesNavFilled], ['Right', Right], ['ScoreOutlined', ScoreOutlined], ['Search', Search], ['Select', Select], ['Settings', Settings], ['ShowOffOutlined', ShowOffOutlined], ['ShowOnOutlined', ShowOnOutlined], ['SinglePage', SinglePage], ['Skill', Skill], ['SmallCircleFilled', SmallCircleFilledIcon], ['SmallCircleHalfFilled', SmallCircleHalfFilledIcon], ['SmallCircleOutline', SmallCircleOutlineIcon], ['Social', Social], ['Sortable', Sortable], ['SparkLab', SparkLab], ['StarFilled', StarFilledIcon], ['StarHalfilled', StarHalfFilledIcon], ['StarOutline', StarOutlineIcon], ['Study', Study], ['StudyIcon', StudyIcon], ['Text', Text], ['Upload', Upload], ['Video', Video], ['Warning', Warning], ['WebLinks', WebLinks], ['ZippedFiles', ZippedFiles], ['ZoomIn', ZoomIn], ['ZoomOut', ZoomOut]]);

/**
 * A wrapper for Pearson Icons.
 *
 * @author Hari Gangadharan
 */
var Icon = function Icon(_ref) {
  var name = _ref.name,
      rest = objectWithoutProperties(_ref, ['name']);

  var IconToRender = icons.get(name);
  return React.createElement(IconToRender, rest);
};

Icon.propTypes = {
  name: PropTypes.string.isRequired
};

var styles = function styles() {
  return {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: 1138,
      margin: '0 auto'
    },
    '@media (max-width: 1176px)': {
      root: {
        maxWidth: 750
      }
    },
    '@media (max-width: 790px)': {
      root: {
        width: 362
      }
    },
    '@media (max-width: 394px)': {
      root: {
        width: 362,
        marginLeft: 16,
        marginRight: 16
      }
    }
  };
};

var CardList = function CardList(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      children = _ref.children;
  return React.createElement(
    'div',
    { className: className + ' ' + classes.root },
    children
  );
};

CardList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

CardList.defaultProps = {
  className: ''
};

var CardList$1 = withStyles(styles)(CardList);

var useStyles = makeStyles(function () {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      backgroundColor: '#002e60',
      height: '100%',
      width: 85,
      minWidth: 85,
      maxWidth: 85,
      minHeight: function minHeight(props) {
        return props.variant && props.variant === 'scrollable' ? 'auto' : 640;
      }
    },
    tabs: {
      border: 0
    },
    indicator: {
      display: 'none'
    },
    scrollButtons: {
      color: '#fff'
    }
  };
});

/**
 * Vertical tab implementation
 *
 * @file VerticalTab.jsx
 */
var VerticalTabs = function VerticalTabs(_ref) {
  var children = _ref.children,
      rest = objectWithoutProperties(_ref, ['children']);

  var classes = useStyles(rest);

  return React.createElement(
    'div',
    { className: classes.root },
    React.createElement(
      Tabs,
      _extends({
        'aria-label': 'Vertical tabs',
        className: classes.tabs,
        classes: {
          scrollButtons: classes.scrollButtons,
          indicator: classes.indicator
        },
        orientation: 'vertical'
      }, rest),
      children
    )
  );
};

VerticalTabs.propTypes = {
  children: PropTypes.array.isRequired
};

var styles$1 = function styles() {
  return {
    root: {
      width: 270
    }
  };
};

var MediaCard = function MediaCard(props) {
  return React.createElement(Card, _extends({}, props, { className: props.classes.root }));
};

MediaCard.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired
  }).isRequired
};

var MediaCard$1 = withStyles(styles$1)(MediaCard);

var styles$2 = function styles(theme) {
  return {
    primary: {
      backgroundColor: 'transparent',
      border: '2px solid white',
      color: 'white'
    },
    secondary: {
      backgroundColor: 'white',
      border: '2px solid white',
      color: theme.palette.primary.dark
    },
    default: {},
    small: {
      width: 40,
      height: 40,
      fontSize: '0.875rem',
      fontWeight: 400
    },
    medium: {},
    large: {
      width: 56,
      height: 56,
      fontSize: '1.25rem',
      fontWeight: 600
    }
  };
};

var AvatarCustom = withStyles(styles$2)(function (_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      color = _ref.color,
      size = _ref.size,
      disableHover = _ref.disableHover,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ['classes', 'className', 'color', 'size', 'disableHover', 'children']);
  return React.createElement(
    Avatar,
    _extends({
      className: classes[size] + ' ' + (classes[color] || '') + ' ' + (disableHover ? '' : 'avatarHover') + ' ' + className
    }, rest),
    children
  );
});

AvatarCustom.defaultProps = {
  className: '',
  color: 'default',
  size: 'medium',
  disableHover: false
};

AvatarCustom.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.string, PropTypes.node]).isRequired,
  classes: PropTypes.object.isRequired,
  disableHover: PropTypes.bool,
  color: PropTypes.oneOf(['primary', 'default', 'secondary']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string
};

var Avatar$1 = withStyles(styles$2)(AvatarCustom);

var styles$3 = function styles() {
  return {
    root: {
      display: 'flex'
    },
    nameCard: {
      paddingLeft: 8,
      wordBreak: 'break-word'
    }
  };
};

var ProfileDisplay = function ProfileDisplay(_ref) {
  var classes = _ref.classes,
      id = _ref.id,
      name = _ref.name,
      avatarText = _ref.avatarText,
      email = _ref.email;
  return React.createElement(
    'div',
    { id: id, className: classes.root },
    React.createElement(
      Avatar$1,
      { id: id + '-avatar' },
      avatarText
    ),
    React.createElement(
      'div',
      { className: classes.nameCard },
      React.createElement(
        Typography,
        { id: id + '-name', variant: 'h4', component: 'div' },
        name
      ),
      React.createElement(
        Typography,
        { id: id + '-email', variant: 'subtitle2', component: 'div' },
        email
      )
    )
  );
};

ProfileDisplay.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  avatarText: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired
};

ProfileDisplay.defaultProps = {
  id: 'pmui-profile-display'
};

var ProfileDisplay$1 = withStyles(styles$3)(ProfileDisplay);

var styles$4 = function styles() {
  return {
    indicator: {
      marginTop: 21,
      marginLeft: 8
    }
  };
};

var OpenCloseIndicator = function OpenCloseIndicator(_ref) {
  var id = _ref.id,
      open = _ref.open,
      classes = _ref.classes;
  return open ? React.createElement(CaretUp, { id: id + '-open', color: 'secondary', className: classes.indicator }) : React.createElement(CaretDown, { id: id + '-close', color: 'secondary', className: classes.indicator });
};

OpenCloseIndicator.propTypes = {
  id: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired
};

var OpenCloseIndicator$1 = withStyles(styles$4)(OpenCloseIndicator);

/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2019 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

var useStylesBootstrap = makeStyles(function (theme) {
  return {
    arrow: {
      color: theme.palette.common.black
    },
    tooltip: {
      backgroundColor: theme.palette.common.black
    }
  };
});

var ArrowTooltip = function ArrowTooltip(_ref) {
  var title = _ref.title,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ['title', 'children']);

  var classes = useStylesBootstrap();
  return React.createElement(
    Tooltip,
    _extends({
      arrow: true,
      title: React.createElement(
        Fragment,
        null,
        React.createElement(
          Typography,
          { color: 'secondary', variant: 'body2' },
          title
        )
      ),
      classes: classes
    }, rest),
    children
  );
};

ArrowTooltip.propTypes = {
  title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

/**
 * A component that extends IconButton to add tooltip functionality.
 */
var IconButtonWithTooltip = function IconButtonWithTooltip(_ref) {
  var title = _ref.title,
      tooltipPlacement = _ref.tooltipPlacement,
      children = _ref.children,
      other = objectWithoutProperties(_ref, ['title', 'tooltipPlacement', 'children']);
  return title ? React.createElement(
    ArrowTooltip,
    {
      title: title,
      placement: tooltipPlacement
    },
    React.createElement(
      IconButton,
      other,
      children
    )
  ) : React.createElement(
    IconButton,
    other,
    children
  );
};

IconButtonWithTooltip.defaultProps = {
  title: null,
  tooltipPlacement: 'bottom'
};

IconButtonWithTooltip.propTypes = {
  title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  tooltipPlacement: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

var styles$5 = function styles() {
  return {
    popup: {
      width: 360
    },
    popper: {
      zIndex: 100
    }
  };
};

var Dropdown = function (_React$Component) {
  inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    classCallCheck(this, Dropdown);

    var _this = possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.handleToggle = function () {
      if (_this.props.open || !_this.ignoreOpen) {
        _this.handleChange(!_this.props.open);
      }
    };

    _this.handleClose = function () {
      _this.ignoreOpen = true;
      setTimeout(function () {
        _this.ignoreOpen = false;
      }, 5);
      _this.handleChange(false);
    };

    _this.handleEscapePress = function (event) {
      if (event.keyCode === 27) {
        _this.handleClose();
      }
    };

    _this.ignoreOpen = false;
    return _this;
  }

  createClass(Dropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addKeyboardEventListener(false);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.open) {
        this.addKeyboardEventListener(prevProps.open);
      } else {
        this.removeKeyboardEventListener();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeKeyboardEventListener();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(newOpen) {
      if (this.props.onChange) {
        this.props.onChange(newOpen);
      }
    }
  }, {
    key: 'addKeyboardEventListener',
    value: function addKeyboardEventListener(prevOpen) {
      if (this.props.open && !prevOpen) {
        // add handler
        document.addEventListener('keydown', this.handleEscapePress);
      }
    }
  }, {
    key: 'removeKeyboardEventListener',
    value: function removeKeyboardEventListener() {
      // remove handler
      document.removeEventListener('keydown', this.handleEscapePress);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Returns open state either from parent or local
      var open = this.props.open;
      var _props = this.props,
          classes = _props.classes,
          id = _props.id,
          title = _props.title,
          hide = _props.hide,
          tooltipPlacement = _props.tooltipPlacement,
          children = _props.children,
          icon = _props.icon,
          color = _props.color,
          disableHover = _props.disableHover,
          popperPlacement = _props.popperPlacement,
          modifiers = _props.modifiers,
          rest = objectWithoutProperties(_props, ['classes', 'id', 'title', 'hide', 'tooltipPlacement', 'children', 'icon', 'color', 'disableHover', 'popperPlacement', 'modifiers']);

      var ariaProps = {};
      if (rest['aria-label']) {
        ariaProps['aria-label'] = rest['aria-label'];
      }
      return hide ? null : React.createElement(
        Fragment,
        null,
        React.createElement(
          IconButtonWithTooltip,
          _extends({
            id: id,
            title: title,
            tooltipPlacement: tooltipPlacement,
            color: color,
            className: disableHover ? 'disableHover' : '',
            buttonRef: function buttonRef(node) {
              _this2.anchorEl = node;
            },
            'aria-expanded': open,
            onClick: this.handleToggle
          }, ariaProps),
          icon
        ),
        React.createElement(
          Popper,
          {
            id: id + '-profile-menu-pop',
            open: open,
            className: classes.popper,
            anchorEl: this.anchorEl,
            placement: popperPlacement,
            modifiers: modifiers,
            transition: true,
            disablePortal: true
          },
          function (_ref) {
            var TransitionProps = _ref.TransitionProps,
                placement = _ref.placement;
            return React.createElement(
              Collapse,
              _extends({}, TransitionProps, {
                id: id + '-profile-menu',
                style: { transformOrigin: placement === 'bottom' ? 'top' : 'bottom' }
              }),
              React.createElement(
                Paper,
                { className: _this2.props.className || classes.popup },
                React.createElement(
                  ClickAwayListener,
                  { onClickAway: _this2.handleClose },
                  React.createElement(
                    'div',
                    null,
                    children
                  )
                )
              )
            );
          }
        )
      );
    }
  }]);
  return Dropdown;
}(React.Component);

Dropdown.defaultProps = {
  id: 'pmui-dropdown',
  open: false,
  hide: false,
  disableHover: false,
  title: null,
  className: null,
  tooltipPlacement: 'bottom',
  color: 'default',
  onChange: null,
  popperPlacement: 'bottom-end',
  modifiers: null
};

Dropdown.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  open: PropTypes.bool,
  hide: PropTypes.bool,
  disableHover: PropTypes.bool,
  color: PropTypes.oneOf(['primary', 'secondary', 'default', 'inherit', 'action']),
  title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  tooltipPlacement: PropTypes.string,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onChange: PropTypes.func,
  popperPlacement: PropTypes.string,
  modifiers: PropTypes.object
};

var Dropdown$1 = withStyles(styles$5)(Dropdown);

var ProfileDropdown = function ProfileDropdown(_ref) {
  var text = _ref.text,
      open = _ref.open,
      hide = _ref.hide,
      onChange = _ref.onChange,
      id = _ref.id,
      children = _ref.children,
      disableIndicator = _ref.disableIndicator,
      customIndicator = _ref.customIndicator,
      rest = objectWithoutProperties(_ref, ['text', 'open', 'hide', 'onChange', 'id', 'children', 'disableIndicator', 'customIndicator']);

  var avatarColor = open ? 'secondary' : 'primary';
  var DropDownIndicator = customIndicator || OpenCloseIndicator$1;
  return React.createElement(
    Dropdown$1,
    _extends({
      id: id,
      open: open,
      hide: hide,
      color: 'secondary',
      onChange: onChange,
      disableHover: true,
      icon: React.createElement(
        Fragment,
        null,
        React.createElement(
          Avatar$1,
          {
            id: id + '-icon-button-avatar',
            color: avatarColor,
            disableHover: open,
            component: 'span'
          },
          text
        ),
        !disableIndicator && React.createElement(DropDownIndicator, {
          id: id + '-indicator',
          open: open
        })
      )
    }, rest),
    children
  );
};

ProfileDropdown.defaultProps = {
  id: 'pmui-profile-dropdown',
  open: true,
  hide: false,
  disableIndicator: false,
  onChange: function onChange() {},
  customIndicator: null
};

ProfileDropdown.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  open: PropTypes.bool,
  hide: PropTypes.bool,
  id: PropTypes.string,
  text: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  disableIndicator: PropTypes.bool,
  customIndicator: PropTypes.elementType
};

var pseudoOutline = function pseudoOutline(padding, borderRadius, focusColor) {
  return {
    content: '""',
    boxSizing: 'content-box',
    position: 'absolute',
    top: -(padding * 3),
    left: -(padding * 3),
    borderRadius: borderRadius,
    width: 'calc(100% + ' + padding * 4 + 'px)',
    height: 'calc(100% + ' + padding * 4 + 'px)',
    border: '2px solid ' + focusColor
  };
};

var cardActionAreaPseudoOutline = function cardActionAreaPseudoOutline(padding, borderRadius, focusColor) {
  return {
    content: '""',
    boxSizing: 'content-box',
    position: 'absolute',
    top: -(padding * 2),
    left: -(padding * 2),
    borderRadius: borderRadius,
    width: 'calc(100% + ' + padding * 8 + 'px)',
    height: 'calc(100% + ' + padding * 8 + 'px)',
    border: '2px solid ' + focusColor
  };
};

var menuPseudoOutline = function menuPseudoOutline(focusColor) {
  return {
    content: '""',
    boxSizing: 'content-box',
    position: 'absolute',
    top: 1,
    left: 1,
    borderRadius: 8,
    width: 'calc(100% - 6px)',
    height: 'calc(100% - 6px)',
    border: '2px solid ' + focusColor
  };
};

var tabPseudoOutline = function tabPseudoOutline(borderRadius, focusColor) {
  return {
    content: '""',
    boxSizing: 'content-box',
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: borderRadius,
    width: 'calc(100% - 4px)',
    height: 'calc(100% - 4px)',
    border: '2px solid ' + focusColor
  };
};

// pearson {} should be used for internal reference only
var pearson = {
  font: {
    family: ['Open Sans', 'Calibri', 'Tahoma', 'sans-serif'],
    size: {
      small: 12,
      normal: 14,
      large: 16
    }
  },
  borderRadius: {
    normal: 22,
    large: 32
  },
  lineHeight: {
    xxl: 1.58,
    xl: 1.5,
    l: 1.38,
    m: 1.33,
    s: 1.29,
    xs: 1.25,
    xxs: 1
  },
  colors: colors,
  iconSize: {
    normal: 19
  },
  padding: {
    xs: 4,
    s: 8,
    m: 12,
    l: 16
  },
  avatar: {
    small: 60,
    large: 120
  }
};

var pearsonMuiTheme = {
  spacing: 16,
  props: {
    // Name of the component️
    MuiButtonBase: {
      // The properties to apply
      disableRipple: true, // No more ripple, on the whole application
      focusVisibleClassName: 'pmuiCustomFocusVisible'
    },
    MuiAppBar: {
      elevation: 0,
      color: 'inherit'
    },
    MuiMenuItem: {
      focusVisibleClassName: 'pmuiCustomFocusVisible'
    },
    MuiSlider: {
      trackSize: 8
    }
  },
  palette: {
    primary: {
      light: colors.seaBlue,
      main: colors.digitalBlue,
      dark: colors.inkBlue,
      contrastText: colors.white
    },
    secondary: {
      main: colors.white,
      dark: colors.white,
      contrastText: colors.seaBlue
    },
    text: {
      primary: colors.charcoal,
      secondary: colors.mediumGray,
      disabled: colors.concrete,
      hint: colors.charcoal
    },
    error: {
      main: colors.strawberryRed,
      contrastText: colors.whiteGray
    },
    action: {
      disabled: colors.mediumGray,
      disabledBackground: colors.moonlight
    }
  },
  typography: {
    useNextVariants: true,
    color: colors.charcoal,
    fontFamily: pearson.font.family,
    fontSize: pearson.font.size.normal
  },
  mixins: {},
  overrides: {
    MuiPaper: {
      root: {
        boxSizing: 'border-box',
        padding: 0,
        marginLeft: 0,
        boxShadow: '0 5px 22px 4px rgba(0, 0, 0, 0.03), 0 7px 8px -4px rgba(0, 0, 0, 0.05)',
        backgroundColor: colors.white
      },
      elevation1: {
        minHeight: 100
      },
      rounded: {
        borderRadius: 8
      }
    },
    MuiAppBar: {
      root: {
        maxWidth: 4000
      },
      colorPrimary: {
        backgroundColor: colors.white,
        color: colors.charcoal,
        border: '0 none'
      },
      colorSecondary: {
        backgroundColor: colors.transparent,
        color: colors.white,
        border: '0 none'
      },
      // eslint-disable-next-line no-dupe-keys
      colorDefault: {
        backgroundColor: colors.white,
        color: colors.charcoal,
        border: '0 none'
      }
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        marginRight: 10,
        marginLeft: 10,
        '@media (min-width: 960px)': {
          minWidth: 'inherit'
        },
        '&$selected': {
          fontWeight: 600
        }
      },
      textColorInherit: {
        '&.pmuiCustomFocusVisible': {
          '&:after': tabPseudoOutline(6, colors.summerSky)
        }
      },
      textColorPrimary: {
        '&.pmuiCustomFocusVisible': {
          '&:after': tabPseudoOutline(6, colors.focusBlue)
        }
      },
      textColorSecondary: {
        color: 'rgba(255, 255, 255, 0.8)',
        lineHeight: 1.29,
        textTransform: 'uppercase',
        '&.pmuiCustomFocusVisible': {
          '&:after': tabPseudoOutline(6, colors.summerSky)
        }
      },
      wrapper: {
        paddingLeft: 4,
        paddingRight: 4
      }
    },
    MuiToolbar: {
      root: {
        '& button:not(:first-child)': {
          marginLeft: 18
        }
      },
      dense: {
        height: 50,
        borderBottom: '1px solid ' + colors.alto
      }
    },
    MuiCustomTabs: {
      DarkMode: {
        root: {
          flexGrow: 1,
          backgroundColor: '#f5f5f5',
          padding: '10px',
          fontFamily: 'Open Sans',
          fontStyle: 'normal',
          fontStretch: 'normal',
          letterSpacing: 'normal'
        },
        tabs: {
          backgroundColor: '#002e60',
          fontSize: '14px',
          fontWeight: 'bold',
          lineHeight: '1.29',
          color: '#ffffff'
        },
        indicator: {
          height: 3,
          borderRadius: 2,
          backgroundColor: '#ffffff'
        },
        CustomTab: {
          border: 0,
          fontSize: '14px',
          lineHeight: '1.29'
        }
      }
    },
    MuiPrivateTabIndicator: {
      colorSecondary: {
        backgroundColor: colors.white,
        height: 3,
        marginBottom: 8
      }
    },
    MuiVerticalTabs: {
      container: {
        flexGrow: 1,
        display: 'flex',
        minHeight: 224,
        height: '100%',
        padding: '20px',
        backgroundColor: '#f5f5f5'
      },
      root: {
        minWidth: 85
      },
      labelIcon: {
        '& $wrapper > *:first-child': {
          marginBottom: 9
        }
      },
      activeTab: {
        width: 58,
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid #33557b',
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8
      },
      tab: {
        color: '#ffffff',
        textAlign: 'center',
        margin: 0,
        height: 80,
        fontSize: 10,
        fontWeight: 600,
        minHeight: 60,
        opacity: 1,
        padding: 0,
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid #33557b',
          borderTopLeftRadius: 8,
          borderBottomLeftRadius: 8
        },
        '&:active': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid #33557b',
          borderTopLeftRadius: 8,
          borderBottomLeftRadius: 8
        },
        '&:visited': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid #33557b',
          borderTopLeftRadius: 8,
          borderBottomLeftRadius: 8
        }
      },
      tabContent: {
        width: '100%',
        paddingLeft: '10px'
      },
      wrapper: {
        padding: 0
      }
    },
    MuiTypography: {
      root: {
        lineHeight: pearson.lineHeight.l,
        color: colors.charcoal,
        fontSize: 16
      },
      h1: {
        fontSize: '2.3125em',
        fontWeight: 300,
        lineHeight: pearson.lineHeight.m
      },
      h2: {
        fontSize: '1.5em',
        fontWeight: 300,
        lineHeight: pearson.lineHeight.xs
      },
      h3: {
        fontSize: '1.25em',
        fontWeight: 600,
        fontStyle: 'normal',
        lineHeight: pearson.lineHeight.m
      },
      h4: {
        fontSize: '1.125em',
        fontWeight: 400,
        letterSpacing: 'normal',
        lineHeight: pearson.lineHeight.m
      },
      h5: {
        fontSize: '1em',
        fontWeight: 600,
        lineHeight: pearson.lineHeight.xs,
        color: colors.charcoal
      },
      h6: {
        fontSize: '0.875em',
        fontWeight: 600,
        lineHeight: pearson.lineHeight.xxl
      },
      subtitle1: {
        fontSize: '.75em',
        letterSpacing: 0.15,
        color: colors.mediumGray,
        lineHeight: pearson.lineHeight.xl
      },
      subtitle2: {
        fontSize: '.875em',
        fontWeight: 'normal',
        color: colors.mediumGray,
        letterSpacing: -0.3,
        lineHeight: pearson.lineHeight.m
      },
      body1: {
        fontSize: 16,
        lineHeight: pearson.lineHeight.xs
      },
      body2: {
        fontSize: 14
      }
    },
    MuiAvatar: {
      root: {
        height: 48,
        width: 48,
        fontSize: '1rem',
        fontWeight: 'bold',
        boxSizing: 'border-box'
      },
      colorDefault: {
        backgroundColor: colors.mediumGray,
        color: colors.white,
        border: '0px solid ' + colors.mediumGray
      }
    },
    MuiButtonBase: {
      root: {
        border: '2px solid ' + colors.transparent,
        '&$focusVisible': {
          '&:after': pseudoOutline(2, 36, colors.focusBlue)
        }
      }
    },
    MuiButton: {
      root: {
        fontSize: 16,
        fontWeight: 600,
        lineHeight: 1.25,
        textTransform: 'none'
      },
      label: {
        minWidth: 104
      },
      text: {
        padding: 0,
        textAlign: 'inherit',
        border: '0px',
        '&:hover': {
          backgroundColor: 'inherit'
        },
        '&$focusVisible': {
          '&:after': pseudoOutline(2, 1, colors.focusBlue)
        }
      },
      outlined: {
        padding: '7px 17px',
        boxShadow: 'none',
        borderColor: colors.mediumGray,
        color: colors.mediumGray,
        backgroundColor: 'transparent',
        borderRadius: pearson.borderRadius.normal,
        '&:hover': {
          color: colors.charcoal,
          backgroundColor: 'transparent',
          borderColor: colors.charcoal
        },
        '&$disabled': {
          border: '1px solid',
          backgroundColor: colors.moonlight,
          borderColor: colors.moonlight
        }
      },
      textPrimary: {
        color: colors.whiteGray,
        backgroundColor: colors.strawberryRed,
        '&:hover': {
          color: colors.white,
          backgroundColor: colors.strawberryRed
        }
      },
      outlinedPrimary: {
        color: colors.white,
        backgroundColor: colors.digitalBlue,
        borderColor: colors.digitalBlue,
        '&:hover': {
          color: colors.white,
          borderColor: colors.inkBlue,
          backgroundColor: colors.inkBlue
        },
        '&$disabled': {
          opacity: 0.5,
          backgroundColor: colors.digitalBlue,
          border: 'solid 1px rgba(151, 151, 151, 0.07)',
          color: colors.white
        }
      },
      outlinedSecondary: {
        color: colors.seaBlue,
        borderColor: colors.white,
        backgroundColor: colors.white,
        '&$focusVisible': {
          '&:after': pseudoOutline(2, 36, colors.summerSky)
        },
        '&:hover': {
          backgroundColor: colors.white,
          boxShadow: '0 6px 10px 0 rgba(37, 37, 37, 0.5), 0 2px 4px 0 rgba(0, 0, 0, 0.5)',
          color: colors.inkBlue
        },
        '&:active': {
          backgroundColor: colors.whiteGray,
          boxShadow: 'none'
        }
      },
      contained: {
        padding: '7px 20px',
        fontSize: 14,
        lineHeight: '18px',
        fontWeight: 600,
        borderRadius: pearson.borderRadius.normal,
        color: colors.charcoal,
        backgroundColor: colors.sunshineYellow,
        boxShadow: '0 5px 22px 4px rgba(0, 0, 0, 0.03), 0 7px 8px -4px rgba(0, 0, 0, 0.05)',
        '&:hover': {
          backgroundColor: colors.sunflowerYellow,
          color: colors.charcoal
        },
        '&:active': {
          boxShadow: 'none'
        }
      },
      containedPrimary: {
        color: colors.whiteGray,
        backgroundColor: colors.strawberryRed,
        '&:hover': {
          backgroundColor: colors.strawberryRed,
          color: colors.white
        }
      },
      sizeSmall: {
        padding: '5px 24px',
        fontSize: '0.875rem',
        lineHeight: '20px',
        '& span': {
          minWidth: 80
        }
      },
      sizeLarge: {
        padding: '9px 24px',
        fontSize: '16px',
        lineHeight: '20px',
        borderRadius: pearson.borderRadius.large
      }
    },
    MuiCard: {
      root: {
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 5%), 0px 4px 22px 0px rgba(0, 0, 0, 3%)'
      }
    },
    MuiCardActionArea: {
      root: {
        fontFamily: pearson.font.family,
        fontSize: pearson.font.size.large,
        boxSizing: 'border-box',
        '&$focusVisible': {
          '&:after': cardActionAreaPseudoOutline(-1, 5, colors.focusBlue),
          backgroundColor: 'inherit'
        },
        '&:hover': {
          background: 'inherit'
        }
      }
    },
    MuiCardActions: {
      root: {
        '@media (min-width:600px)': {
          paddingLeft: pearson.padding.xs,
          paddingRight: pearson.padding.m,
          paddingTop: pearson.padding.xs,
          paddingBottom: pearson.padding.s
        }
      }
    },
    MuiCardContent: {
      root: {
        paddingTop: pearson.padding.l,
        paddingBottom: pearson.padding.xs,
        paddingLeft: pearson.padding.l,
        paddingRight: pearson.padding.l,
        '@media (min-width:600px)': {
          paddingTop: pearson.padding.l,
          paddingBottom: pearson.padding.xs,
          paddingLeft: pearson.padding.l,
          paddingRight: pearson.padding.l
        }
      }
    },
    MuiCardHeader: {
      root: {
        paddingBottom: 0,
        alignItems: 'flex-start'
      },
      content: {
        overflow: 'hidden'
      }
    },
    MuiDivider: {
      root: {
        backgroundColor: colors.alto,
        marginTop: pearson.padding.l,
        marginBottom: pearson.padding.l
      }
    },
    MuiListItem: {
      button: {
        '&:hover': {
          backgroundColor: 'inherit',
          '& .applyHover': {
            color: pearson.colors.seaBlue
          }
        }
      }
    },
    MuiMenuItem: {
      root: {
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.08)'
        },
        '&.pmuiCustomFocusVisible': {
          '&:after': menuPseudoOutline(colors.focusBlue)
        }
      }
    },
    MuiPopover: {
      root: {
        borderRadius: '4px',
        padding: '24px',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.4)',
        marginTop: '10px'
      }
    },
    MuiSlider: {
      track: {
        backgroundColor: colors.seaBlue,
        height: 8,
        borderRadius: 16,
        '$vertical &': {
          width: 8
        }
      },
      thumb: {
        backgroundColor: colors.white,
        border: 'solid 1px ' + colors.alto,
        boxShadow: '0 5px 22px 4px rgba(0, 0, 0, 0.03), 0 7px 8px -4px rgba(0, 0, 0, 0.05)',
        width: 20,
        height: 20
      },
      rail: {
        backgroundColor: colors.concrete,
        height: 8,
        '$vertical &': {
          width: 8
        }
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: 18
      },
      colorPrimary: {
        fill: colors.whiteGray
      },
      colorAction: {
        color: colors.charcoal
      },
      fontSizeSmall: {
        fontSize: 16
      },
      fontSizeLarge: {
        fontSize: 24
      }
    },
    MuiDialogActions: {
      root: {
        margin: 24
      }
    },
    MuiIconButton: {
      root: {
        padding: 6,
        color: colors.mediumGray,
        '&$disabled': {
          opacity: 0.5
        },
        '&.disableHover': {
          '&:hover': {
            backgroundColor: 'inherit'
          },
          '&:active': {
            backgroundColor: 'inherit'
          }
        },
        '&:hover': {
          backgroundColor: colors.alto + 'A6',
          '& .avatarHover': {
            backgroundColor: colors.white + '33',
            color: colors.white
          }
        },
        '&.pmuiCustomFocusVisible': {
          backgroundColor: colors.alto + 'A6'
        }
      },
      sizeSmall: {
        padding: 4
      },
      colorSecondary: {
        '&:hover': {
          backgroundColor: colors.black + 'CC'
        },
        '&:active': {
          backgroundColor: colors.black + '4D'
        },
        '&$disabled': {
          opacity: 0.5,
          color: colors.white
        },
        '&.pmuiCustomFocusVisible': {
          '&.disableHover': {
            backgroundColor: 'inherit'
          },
          backgroundColor: colors.black + 'CC',
          '&:after': pseudoOutline(2, 36, colors.summerSky)
        }
      }
    },
    MuiRadio: {
      root: {
        paddingTop: 2,
        '&$checked': {
          '& + span': {
            fontWeight: 700,
            color: colors.digitalBlue
          }
        }
      }
    },
    MuiFormControl: {},
    MuiUnderline: {
      root: {
        '&:after': {
          borderBottomWidth: 4
        }
      }
    },
    MuiFormLabel: {
      root: {
        lineHeight: 1.38,
        '&$focused': {
          color: colors.charcoal
        }
      }
    },
    MuiFormControlLabel: {
      root: {
        alignItems: 'flex-start',
        paddingTop: 30
      }
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        marginBottom: 17
      },
      iconButton: {
        padding: '7px'
      },
      dayLabel: {
        color: colors.mediumGray,
        width: 8,
        height: 16,
        margin: '12px 16px'
      }
    },
    MuiPickersDay: {
      day: {
        width: 32,
        height: 32,
        margin: 4
      },
      daySelected: {
        backgroundColor: colors.mediumGray,
        '&:hover': {
          backgroundColor: colors.mediumGray
        }
      },
      dayDisabled: {
        cursor: 'auto',
        color: colors.concrete
      },
      current: {
        backgroundColor: colors.moonlight,
        color: colors.charcoal
      }
    },
    MuiPickersCalendar: {
      transitionContainer: {
        minHeight: 236
      }
    },
    MuiPickersToolbarButton: {
      toolbarBtn: {
        maxWidth: 60,
        marginLeft: '0 !important',
        fontSize: '1.75rem'
      }
    }
  }
};

export default pearsonMuiTheme;
export { icons, Icon, CardList$1 as CardList, VerticalTabs, MediaCard$1 as MediaCard, Avatar$1 as Avatar, ProfileDisplay$1 as ProfileDisplay, ProfileDropdown, Dropdown$1 as Dropdown, ArrowTooltip as Tooltip, IconButtonWithTooltip, PearsonLogo };
//# sourceMappingURL=index.es.js.map
